import {
    APP_TITLE,
    LANDING_BRIEF,
    LANDING_LANGUAGE_SELECTOR,
    LANDING_COUNTRY_SELECTOR,
    LANDING_TERMS,
    LANDING_TERMS_ERROR,
    LANDING_CAPTCHA_ERROR,
    BUTTON_PREV,
    BUTTON_NEXT,
    BUTTON_SUBMIT,
    MENU_FEEDBACK_FORM,
    MENU_FEEDBACK_STATUS,
    MENU_FORM_INTAKE,
    MENU_FORM_EVENT_DETAILS,
    MENU_FORM_PRODUCT_INFO,
    SYSTEM_FEEDBACK_FORM,
    SYSTEM_FEEDBACK_STATUS,
    FORM_TITLE,
    FORM_MANDATORY_FIELDS,
    APP_DESCRIPTION,
    SUBMIT_FEEDBACK,
    CHECK_SUBMITTED_FEEDBACK,
    BTN_LAUNCH_FORM,
    BTN_CHECK_STATUS,
    SELECT_RESPONSE,
    FUNCTION_ROLE,
    CUSTOMER_ACCOUNT_NUMBER,
    ENTER_CUSTOMER_ACCOUNT,
    HELP_CUSTOMER_ACCOUNT_NUMBER,
    EVENT_REPORTED,
    REFERENCE_NUMBER,
    ENTER_REFERENCE,
    WHO_REPORTED_TO,
    WHO_WAS_NOTIFIED,
    ENTER_NAME,
    YOUR_NAME,
    OCCUPATION,
    PHONE_NUMBER,
    ENTER_PHONE_NUMBER,
    ENTER_EMAIL,
    EMAIL_ADDRESS,
    ENTER_ADDRESS,
    ENTER_NA_IF_UNKNOWN,
    FACILITY_HOSPITAL,
    ENTER_FACILITY,
    ADDRESS_1,
    ADDRESS_2,
    CITY,
    STATE,
    POSTAL_CODE,
    COUNTRY,
    END_USER_CUSTOMER,
    ADDITIONAL_CONTACT_PERSON,
    ADDITIONAL_PHONE,
    ADDITIONAL_EMAIL,
    ANOTHER_FACILITY_ADDRESS,
    ANOTHER_FACILITY_HOSPITAL,
    ANOTHER_ENTER_FACILITY,
    ANOTHER_ADDRESS_1,
    ANOTHER_ADDRESS_2,
    ANOTHER_CITY,
    ANOTHER_STATE,
    ANOTHER_POSTAL_CODE,
    ANOTHER_COUNTRY,
    LOT_SERIAL_NUMBER,
    ENTER_LOT_SERIAL_NUMBER,
    HELP_LOT_SERIAL_NUMBER,
    OPTION_WHATINCORRECTLYDISPLAYEDOPTIONS_PRODUCT_CODE,
    PRODUCT_CODE,
    ENTER_PRODUCT_CODE,
    HELP_PRODUCT_CODE,
    NDC,
    ENTER_NDC,
    UDI,
    ENTER_UDI,
    PRODUCT_NAME,
    ENTER_PRODUCT_NAME,
    HELP_PRODUCT_NAME,
    BEST_DESCRIBES,
    QUANTITY_TO_SELECT,
    ENTER_QUANTITY,
    HELP_QUANTITY,
    UNIT,
    AVAILABLE_TO_RETURNED,
    PHOTOGRAPH_AVAILABLE,
    HELP_PHOTOGRAPH_AVAILABLE,
    UPLOAD_IMAGES,
    REPORTER_NAME,
    REPORTER_FACILITY,
    REPORTER_OCCUPATION,
    ENTER_NUMBER,
    REPORTER_PHONE_NUMBER,
    REPORTER_EMAIL_ADDRESS,
    EMPLOYEE_NAME,
    EMPLOYEE_PHONE_NUMBER,
    EMPLOYEE_EMAIL_ADDRESS,
    RETURNING_FOR_INVESTIGATION,
    HELP_RETURNING_FOR_INVESTIGATION,
    UNUSED_VANTIVE_PRODUCT,
    YOU_INDICATED_SAMPLES,
    SAMPLE_RETURN_KIT,
    A_BOX_WITH_A_PREPAID_LABEL,
    SAME_AS_MY_ADDRESS,
    OTHER_CONTACT_NAME,
    OTHER_CONTACT_OCCUPATION,
    OTHER_CONTACT_PHONE_NUMBER,
    OTHER_CONTACT_EMAIL_ADDRESS,
    MANUFACTURED_BY_ANOTHER_COMPANY,
    CUSTOMER_EXPLICITLY_REQUEST,
    EXPLICITLY_REQUEST_CREDIT,
    PRODUCT_FROM_VANTIVE,
    QUANTITY_REQUESTED_CREDIT,
    ENTER_OCCUPATION,
    LOT_QUANTITY_NUMBER,
    WHOLESALERS_NAME,
    PLACE_WHOLESALERS_NAME,
    DATE_OF_EVENT,
    DATE_OF_EVENT_MSG,
    HELP_DATE_OF_EVENT,
    DATE_VANTIVE_EMPLOYEE,
    DURING_WHAT_PROCESS,
    WAS_THE_PATIENT,
    WERE_YOU_CONNECTED,
    PROVIDE_ANY_ADDITIONAL,
    HELP_YOU_IDENTIFIED_MORE,
    ENTER_DETAILS,
    PROVIDE_ANY_ATTACHMENT,
    WAS_NEGATIVE_MEDICAL,
    WAS_MEDICAL_INTERVENTION,
    PROVIDE_DETAILS,
    REQUIRED_TREATMENT,
    ENTER_TREATMENT,
    RELEVANT_TESTS,
    HELP_RELEVANT_TESTS,
    RELEVANT_MEDICAL_HISTORY,
    ENTER_HISTORY,
    PATIENT_NAME,
    PATIENT_INITIALS,
    PATIENT_PHONE_NUMBER,
    PATIENT_EMAIL_ADDRESS,
    I_DO_NOT_WISH_TO_PROVIDE,
    PATIENT_ADDRESS,
    SAME_ADDRESS,
    DRUG_BEING_USED,
    PATIENT_IDENTIFIER,
    PATIENT_AGE_OR_DOB,
    ENTER_PATIENT_AGE,
    PATIENT_GENDER,
    PATIENT_WEIGHT,
    ENTER_WEIGHT,
    PATIENT_WEIGHT_UNIT,
    MY_NAME,
    ENTER_IN_YOUR_CONTACT,
    MY_PHONE_NUMBER,
    MY_EMAIL_ADDRESS,
    MY_ADDRESS,
    NAME_OF_VANTIVE_DRUG,
    ENTER_DRUG_NAME,
    PLEASE_PROVIDE_THE_NAME,
    APPLY_TO_EACH_UNIT,
    SELECT_THE_COMPONENT,
    USE_THE_DIAGRAM,
    TYPE_OF_DAMAGE,
    PLEASE_ENTER_VALUE,
    WAS_THE_PRODUCT_KINKED,
    WERE_ANY_CLEANING,
    WHAT_WAS_THE_DISINFECTANT,
    NOTE_VANTIVE_LABELING,
    SELECT_ALL_THAT_APPLY,
    DID_FOLLOWING_OCCUR,
    SELECT_THE_LOCATION,
    WAS_THE_PRODUCT_EXPOSED,
    HOW_LONG_TRANSFER,
    WAS_THERE_DIFFICULTY,
    WAS_DEVICE_OR_TOOL,
    DESCRIBE_HOW_PRODUCT,
    DID_YOU_OBSERVE,
    WERE_DIFFICULTIES_PUTTING,
    WAS_THE_TRANSFER,
    SELECT_TYPE_OF_FLOW,
    WAS_ANYTHING_BLOCKING,
    WAS_ANY_ALARM,
    SELECT_BEST_DESCRIBE,
    WERE_THE_MINICAPS,
    WAS_THE_SPONGE_VISIBLE,
    WHERE_PARTICULATE_MATTERFOREIGN,
    DESCRIBE_THE_EXACT_LOCATION,
    WAS_THE_PARTICULATE_MATTER,
    DOES_THE_PARTICULATE_MATER,
    WHAT_COMPONENT_DOES,
    SELECT_CONNECTION_ISSUE,
    WERE_ASSIST_DEVICES,
    WERE_ANY_DIFFICULTIES,
    PROVIDE_PRODUCT_INFORMATION,
    WERE_THE_SPIKE_LUER,
    VANTIVE_LABELING_STATES,
    WERE_PETS_OR_ANIMALS,
    VANTIVE_LABELING_CONTAMINATION,
    WERE_OTHER_ISSUES,
    WAS_MINICAP_TWISTED,
    WERE_DIFFICULTIES_TRANSFER_SET,
    DID_TRANSFER_SET_CONNECTORS,
    WHAT_WAS_THE_ALARM,
    WHERE_OBSERVED_DAMAGE,
    SELECT_THE_TYPE_OBSERVED,
    DID_DAMAGE_CAUSE_LEAK,
    WAS_THE_SHIPPING_CARTON,
    SELECT_FLOW_ISSUE_OBSERVED,
    HOW_LONG_WAS_STORAGE,
    WAS_THERE_AN_ADAPTER,
    NAME_AND_MODEL,
    NAME_VAPORIZER,
    WAS_VIAL_INVERTED,
    WHAT_VIAL_USED,
    DRUG_NAME_MANUFACTURER,
    WERE_BREAK_FRANGIBLE,
    WAS_ALARM_ASSOCIATED,
    WHAT_PART_DISCOLORED,
    DESCRIBE_DISCOLORATION,
    HOW_PRODUCT_STORED,
    DOES_DISCOLORATION_APPEAR,
    WHICH_CHAMBER_DISCOLORED,
    WAS_PEEL_SEAL_INTERCHAMBER,
    WAS_DISCOLORATION_NOTICED,
    SELECT_SPECIFICALLY_DESCRIBES,
    WHAT_DEVICE_HAD_ALARM,
    WHAT_MISSING_MISASSEMBLED,
    RECONSTITUTION_ISSUE,
    WHAT_MEDICATION_SOLUTION,
    WHAT_VOLUME_MEDICATION,
    WHAT_DEVICES_RECONSTITUTION,
    WAS_PRODUCT_EXPOSED_HEAT,
    DESCRIBE_EXPOSURE,
    WHAT_USED_ACTIVATE_SOLUTION,
    WAS_DAMAGE_OBSERVED,
    DESCRIBE_THE_DAMAGE,
    APPROXIMATELY_SOLUTION_POWDER,
    WAS_LEAK_OBSERVED,
    WHAT_FEATUR_DIFFICULT_USE,
    HOW_WAS_DIFFICULT_USE,
    WHERE_MATTER_FOREIGN,
    DOES_PARTICULATE_MATTER,
    DESCRIBE_EXACT_LOCATION,
    WAS_MATTER_FOREIGN,
    WHEN_MATTER_FOREIGN,
    PROVIDE_INFORMATION_MEDICATION,
    PRODUCT_NAME_CODE_NUMBER,
    DESCRIBE_SPIKING,
    INCLUDE_NEEDLE,
    WHAT_ADMINISTRATION_RECONSTITUTION,
    INCLUDE_MANUFACTURER,
    WAS_MEDICATION_ADDITIVE,
    WHAT_MEDICATION_ADDITIVE,
    WHAT_STATE_OF_PRODUCT,
    AFTER_UNITS_SAT,
    DID_ATTEMPT_AGITATE,
    DID_PRECIPITATE_DISSOLVE,
    WHAT_STORAGE_TEMPERATURE,
    PROVIDE_TEMPERATURE_LOCATION,
    ARE_TEMPERATURE_LOGS,
    LOGS_CAN_BE_ATTACHED,
    IS_THE_STORAGE_UNIT,
    HOW_PRODUCT_THAWED,
    WHAT_STORAGE_CONDITIONS,
    WAS_ANY_DAMAGE,
    MORE_SPECIFIC_INFORMATION,
    WHAT_PURPOSE_INDICATION,
    WHAT_ROUTE_ADMINISTRATION,
    WHAT_DATE_ADMINISTRATION,
    WHAT_DOSAGE_STRENGTH,
    WAS_RECENT_PRESCRIPTION,
    WHAT_WAS_STORAGE_TEMPERATURE,
    WERE_ANY_ADJUSTMENTS,
    SELECT_APPROPRIATE_DESCRIPTION,
    SELECT_LABELING_ISSUE,
    WAS_CONNECTION_SECURE,
    WAS_EXPIRED_PRODUCT,
    WAS_COMPONENT_DAMAGED,
    WERE_ABNORMALITIES_DAMAGE,
    WHAT_PURCHASE_ORDER_NUMBER,
    WHAT_DATE_OF_ADMINISTRATION,
    WHAT_WAS_EXPIRATION_DATE,
    DESCRIBE_WAS_INCORRECT,
    WHAT_SCANNER_USED,
    WAS_OVERPOUCH_POUCH,
    WHAT_BACKGROUND_COLOR,
    DO_ALL_OF_THE_LABELS,
    PRODUCT_INFORMATION,
    IS_A_BARCODE_SCANNER,
    HOW_ARE_THESE_PRODUCTS,
    WHAT_INFORMATION_INCORRECTLY,
    WAS_THERE_LEAK,
    WHERE_LEAK_OBSERVED,
    WAS_FRANGIBLE_OBSERVED,
    IS_MOISTURE_CLEAR,
    WHO_IS_YOUR_DISTRIBUTOR,
    WHAT_MANUFACTURER_MEDICATION,
    WHAT_GAUGE_NEEDLE,
    WHAT_ADMINISTRATION_SET,
    WAS_DIFFICULTY_SPIKING,
    WERE_FOLLOWING_SCENARIOS,
    WAS_FRANGIBLE_OBSERVED_DEFECT,
    WHAT_AMOUNT_PRESSURE,
    WAS_BAG_COMPLETELY,
    WHAT_MANUFACTURER_MODEL,
    WHAT_PRESSURE_PRIOR,
    LIST_THE_VAPORIZER,
    APPROXIMATELY_HOW_MUCH,
    WAS_THE_BOTTLE_DIFFICULT,
    WERE_VISIBLE_DEFECTS,
    SELECT_THE_OPTION,
    PROVIDE_INVOLVED_CONNECTION_ISSUE,
    WHICH_PART_SEPARATED,
    WHAT_COMPONENT_DISCOLORED,
    SELECT_DESCRIBES_DISCOLORATION,
    WAS_THE_SET_DISCOLORED,
    DID_SET_CHANGE_COLOR,
    WHAT_MEDICATION_ADDED,
    WHERE_MATERIAL_LOCATED,
    DESCRIBE_APPEARANCE_COLOR_SIZE,
    WAS_EMBEDDED_PLASTIC,
    WAS_THERE_A_PRECIPITATE,
    WHAT_MEDICATIONS_SOLUTIONS,
    WHERE_DAMAGE_COMPONENT_AFFECTED,
    WHAT_DAMAGE_ISSUE,
    DID_ISSUE_RESULT,
    WAS_PATIENT_CONNECTED,
    WAS_PRODUCT_REPLACED,
    WHICH_SITUATION_BEST,
    SELECT_MOST_LABELING_ISSUE,
    WHAT_INFORMATION_DISPLAYED,
    WHAT_SCANNER_WAS_USED,
    INCLUDE_THE_MODEL_NAME,
    WAS_PRODUCT_ORDERED,
    WHERE_LEAK_COMING,
    DID_SCENARIOS_OCCURRED_LEAK,
    WAS_POWER_INJECTOR,
    WHAT_INJECTOR_USED,
    MANUFACTURER_NAME_CODE_LOT,
    DESCRIBE_INCORRECT_INCOMPLETE,
    PROVIDE_INFORMATION_SECOND_PRODUCT,
    WHICH_COMPONENTS_WERE_FOUND,
    DESCRIBE_CUT_HOLE_SLICE,
    WAS_LEAK_ORIGINATING,
    PROVIDE_DISCONNECTION_CONNECTION,
    WHICH_SPECIFIC_BONDED,
    WERE_VISIBLE_IRREGULARITIES,
    WAS_SUCCESSFUL_CONNECTION,
    WAS_TOOL_USED_ASSIST,
    WERE_LUER_CONNECTIONS,
    WAS_PRODUCT_SECURELY,
    WHICH_DESCRIBES_FLOW_ISSUE,
    WHAT_FLOWING_BACKWARDS,
    DESCRIBE_COMPONENTS_BACKFLOW,
    DO_SITUATIONS_APPLY,
    WHICH_SPECIFIC_AREA,
    WAS_FLOW_PREVIOUSLY_SEEN,
    WAS_ANY_FOLLOWING_OBSERVED,
    WHERE_SIMULTANEOUS_FLOW,
    WHAT_TYPE_HANGER,
    WHAT_WAS_HANGER_LENGTH,
    WHICH_BAG_LOWER,
    WHAT_Y_SITE_WAS,
    WHAT_COMPONENT_WITHIN,
    WAS_COMPONENT_SET_REPLACED,
    WHAT_VOLUME_FLUID_PERIOD_TIME,
    WHAT_VOLUME_FLUID_OVER_TIME,
    WAS_USED_WITH_PUMP,
    DID_CLAMP_FAIL,
    WHAT_CLAMP_FAILED,
    WAS_ISSUES_OBSERVED_CLAMP,
    DO_OTHER_SITUATIONS_DESCRIBE,
    DESCRIBE_ALARM_OBSERVED,
    INCLUDE_ANY_MESSAGES,
    WHICH_CLAMP_HAD_ISSUE,
    WHICH_TYPE_CLAMP_ISSUE,
    SELECT_BEST_DESCRIBES_ISSUE,
    PROVIDE_MORE_DETAILS,
    PROVIDE_MORE_DETAILS_INSTRUCTIONS,
    DESCRIBE_THE_SMELL,
    WAS_ISSUES_WITH_SET,
    WHERE_LEAK_LOCATED,
    DID_OCCUR_WITH_LEAK,
    PROVIDE_INVOLVED_DISCONNECTION,
    DID_OCCURRED_WITH_THE_LEAK,
    WHERE_WAS_PRODUCT_DAMAGED,
    SELECT_ALL_APPLY,
    DESCRIBE_OBSERVED_DAMAGE,
    WHAT_COMPONENT_IS_DISCOLORED,
    DESCRIBE_HUE_TINT_SHADE,
    INSIDE_OUTSIDE_OVERPOUCH,
    DESCRIBE_EXACT_LOCATION_SIZE,
    DOES_THE_PARTICULATE_MATTER,
    WAS_PARTICULATE_MATERIAL_EMBEDDED,
    DOES_APPEAR_PRODUCT_MATERIAL,
    WHERE_DID_THE_ISSUE_OCCUR,
    LIST_COMPONENTS_IF,
    WERE_THERE_VISIBLE_IRREGULARITIES,
    SELECT_OPTION_FLOW_ISSUE,
    DESCRIBE_IRREGULARITIES,

    HOW_PRODUCT_SETUP,
    SELECT_MOST_APPROPRIATE_DESCRIPTION,
    DESCRIBE_WHAT_INCORRECT_INCOMPLETE,
    WAS_SHIPPING_CARTON_DAMAGED,
    WHAT_PRODUCT_WAS_SUPPOSED,
    IF_PRODUCT_CODE_NOT,
    WAS_THE_CASE_MISSING,
    WHAT_CARRIER_DELIVERED,
    WHAT_IS_PURCHASE_ORDER_NUMBER,
    WHAT_QUANTITY_MISSING_UNITS,
    WAS_EXPIRED_PRODUCT_USE,
    ADD_PRODUCT_TO_THE_GRID,
    SAVE,
    CANCEL,
    ADD_MORE_PRODUCTS,
    REPORTER_ADDRESS,
    ATTACHMENTS,
    COPYRIGHT,
    TERMS_CONDITIONS,
    PRIVACY_POLICY,
    COOKIE_POLICY,
    FORM_SUB_TITLE,
    OPTION_REPORTEROCCUPATIONOPTIONS_ASKED_UNKNOWN,
    OPTION_FUNCTIONOPTIONS_VANTIVE_EMPLOYEE,
    OPTION_FUNCTIONOPTIONS_CAREGIVER,
    OPTION_FUNCTIONOPTIONS_DISTRIBUTOR,
    OPTION_FUNCTIONOPTIONS_HEALTHCARE_PROFESSIONAL,
    OPTION_FUNCTIONOPTIONS_PATIENT,
    OPTION_FUNCTIONOPTIONS_OTHER,
    OPTION_PROCESSSTEPOPTIONS_AFTER_USE,
    OPTION_PROCESSSTEPOPTIONS_BEFORE_USE,
    OPTION_PROCESSSTEPOPTIONS_DURING_SETUP_PREPARATION,
    OPTION_PROCESSSTEPOPTIONS_DURING_THERAPY,
    OPTION_PROCESSSTEPOPTIONS_MULTIPLE_STEPS,
    OPTION_PROCESSSTEPOPTIONS_NOT_SPECIFIED,
    OPTION_OCCUPATIONOPTIONS_FAMILY_MEMBER,
    OPTION_OCCUPATIONOPTIONS_NURSE,
    OPTION_OCCUPATIONOPTIONS_NURSE_PRACTITIONER,
    OPTION_OCCUPATIONOPTIONS_OTHER_HEALTH_CARE_PROFESSIONAL,
    OPTION_OCCUPATIONOPTIONS_PHYSICIAN,
    OPTION_UNITOPTIONS_BOXES,
    OPTION_UNITOPTIONS_PALLETS,
    OPTION_UNITOPTIONS_UNITS,
    OPTION_PROBLEMOPTIONS_ALARM_CONDITION,
    OPTION_PROBLEMOPTIONS_DAMAGE,
    OPTION_PROBLEMOPTIONS_DIFFICULT_TO_USE,
    OPTION_PROBLEMOPTIONS_DISCOLORED,
    OPTION_PROBLEMOPTIONS_FLOW_ISSUES,
    OPTION_PROBLEMOPTIONS_LABELING_ISSUES,
    OPTION_PROBLEMOPTIONS_LEAK_EXCESSIVE_MOISTURE,
    OPTION_PROBLEMOPTIONS_PARTICULATE_MATTER_FOREIGN_MATERIAL,
    OPTION_PROBLEMOPTIONS_PATIENT_REACTION_ADVERSE_EVENT,
    OPTION_PROBLEMOPTIONS_PRODUCT_INQUIRY,
    OPTION_PROBLEMOPTIONS_SEPARATION_CONNECTION,
    OPTION_PROBLEMOPTIONS_SHIPPING_ISSUES_EXPIRED_PRODUCT,
    OPTION_PATIENTSEXOPTIONS_FEMALE,
    OPTION_PATIENTSEXOPTIONS_UNDIFFERENTIATE,
    OPTION_PATIENTSEXOPTIONS_MALE,
    OPTION_PATIENTSEXOPTIONS_DECLINETOANSWER,
    OPTION_REPORTEROCCUPATIONOPTIONS_ADMINISTRATOR_SUPERVISOR,
    OPTION_REPORTEROCCUPATIONOPTIONS_BIOMEDICAL_ENGINEER,
    OPTION_REPORTEROCCUPATIONOPTIONS_COMPANY_REPRESENTATIVE,
    OPTION_REPORTEROCCUPATIONOPTIONS_DENTIST,
    OPTION_REPORTEROCCUPATIONOPTIONS_DISTRIBUTOR,
    OPTION_REPORTEROCCUPATIONOPTIONS_FAMILY_MEMBER,
    OPTION_REPORTEROCCUPATIONOPTIONS_LAY_USER,
    OPTION_REPORTEROCCUPATIONOPTIONS_NURSE,
    OPTION_REPORTEROCCUPATIONOPTIONS_NURSE_PRACTITIONER,
    OPTION_REPORTEROCCUPATIONOPTIONS_OTHER_HEALTH_CARE_PROFESSIONAL,
    OPTION_REPORTEROCCUPATIONOPTIONS_PHARMACIST,
    OPTION_REPORTEROCCUPATIONOPTIONS_PHARMACY_TECHNICIAN,
    OPTION_REPORTEROCCUPATIONOPTIONS_PHYSICIAN,
    OPTION_REPORTEROCCUPATIONOPTIONS_PATIENT,
    OPTION_REPORTEROCCUPATIONOPTIONS_RISK_MANAGER,
    OPTION_REPORTEROCCUPATIONOPTIONS_OTHER,
    OPTION_PRODUCTSURVEILLANCECONTACTOPTIONS_CONTACT_ADDITIONAL_CONTACT_PERSON,
    OPTION_PRODUCTSURVEILLANCECONTACTOPTIONS_CONTACT_ME,
    OPTION_PRODUCTSURVEILLANCECONTACTOPTIONS_CONTACT_OTHER,
    OPTION_REPORTEDTOOPTIONS_VANTIVE,
    OPTION_REPORTEDTOOPTIONS_CHINA_FDA,
    OPTION_REPORTEDTOOPTIONS_EMA,
    OPTION_REPORTEDTOOPTIONS_FDA,
    OPTION_REPORTEDTOOPTIONS_HEALTH_CANADA,
    OPTION_REPORTEDTOOPTIONS_PMDA_JAPAN,
    OPTION_REPORTEDTOOPTIONS_TUV,
    OPTION_REPORTEDTOOPTIONS_TGA_AUSTRALIA,
    OPTION_FOLLOWINGOCCUROPTIONS_A_PET_OR_ANIMAL,
    OPTION_FOLLOWINGOCCUROPTIONS_A_SHARP_OBJECT,
    OPTION_FOLLOWINGOCCUROPTIONS_THE_PRODUCT_PROBLEM_OCCURRED,
    OPTION_FOLLOWINGOCCUROPTIONS_THE_PRODUCT_COLD_ENVIRONMENT,
    OPTION_DAMAGEMINICAPOPTIONS_CARTON,
    OPTION_DAMAGEMINICAPOPTIONS_MINICAP,
    OPTION_DAMAGEMINICAPOPTIONS_POUCH,
    OPTION_DIFFICULTTOUSEOPTIONS_THE_TRANSFER_TIGHT,
    OPTION_DIFFICULTTOUSEOPTIONS_THE_TRANSFER_LOOSE,
    OPTION_DIFFICULTTOUSEOPTIONS_THE_TRANSFER_OPEN,
    OPTION_DIFFICULTTOUSEOPTIONS_THE_TWIST_CLAMP_OPEN,
    OPTION_DIFFICULTTOUSEOPTIONS_THE_TWIST_LAMP_CLOSE,
    OPTION_DIFFICULTTOUSEOPTIONS_THE_TRANSFER_CLOSE,
    OPTION_DIFFICULTIESMINICAPOPTIONS_YES_THERE_WAS_DAMAGE,
    OPTION_DIFFICULTIESMINICAPOPTIONS_YES_THE_MINICAP,
    OPTION_FLOWISSUEOPTIONS_COMPLETELY_STOPPED,
    OPTION_FLOWISSUEOPTIONS_RESTRICTED_OR_PARTIALLY,
    OPTION_BLOCKINGFLOWOPTIONS_CLOTTED_BLOOD,
    OPTION_BLOCKINGFLOWOPTIONS_FIBRIN,
    OPTION_BLOCKINGFLOWOPTIONS_KINK,
    OPTION_BLOCKINGFLOWOPTIONS_PARTICULATE,
    OPTION_BLOCKINGFLOWOPTIONS_PRODUCT_MATERIAL,
    OPTION_DESCRIBEISSUEOPTIONS_EXCESS_IODINE,
    OPTION_DESCRIBEISSUEOPTIONS_EXCESS_MOISTURE,
    OPTION_DESCRIBEISSUEOPTIONS_FOIL_POUCH,
    OPTION_DESCRIBEISSUEOPTIONS_PACKAGE_BOX,
    OPTION_DESCRIBEISSUEOPTIONS_SPONGE_DRIED_OUT_AND_WHITE,
    OPTION_DESCRIBEISSUEOPTIONS_SPONGE_DRIED_OUT_BROWNISH_COLOR,
    OPTION_MATERIALLOCATEDOPTIONS_IN_THE_SECONDARY,
    OPTION_MATERIALLOCATEDOPTIONS_INSIDE_THE_PRODUCT_FLUID,
    OPTION_MATERIALLOCATEDOPTIONS_INSIDE_THE_SHIPPING,
    OPTION_MATERIALLOCATEDOPTIONS_ON_THE_OUTSIDE_OF_PRODUCT,
    OPTION_MATERIALLOCATEDOPTIONS_ON_THE_OUTSIDE_OF_OVERPOUCH,
    OPTION_MATERIALLOCATEDOPTIONS_ON_THE_EXTERIOR,
    OPTION_CONNECTIONISSUEOPTIONS_DIFFICULTIES_CONNECTING,
    OPTION_CONNECTIONISSUEOPTIONS_DIFFICULTIES_DISCONNECTING,
    OPTION_CONNECTIONISSUEOPTIONS_SEPARATION_OF_COMPONENTS,
    OPTION_CONNECTIONISSUEOPTIONS_SEPARATION_DISCONNECTION,
    OPTION_RESIDUETHREADSOPTIONS_YES_RESIDUE,
    OPTION_RESIDUETHREADSOPTIONS_YES_VISIBLE,
    OPTION_RESIDUETHREADSOPTIONS_YES_OTHER,
    OPTION_OBSERVEDDAMAGEOPTIONS_FRANGIBLE,
    OPTION_OBSERVEDDAMAGEOPTIONS_HANGER_HOLE,
    OPTION_OBSERVEDDAMAGEOPTIONS_INJECTION_FILLING_PORT,
    OPTION_OBSERVEDDAMAGEOPTIONS_MEMBRANE_PORT,
    OPTION_OBSERVEDDAMAGEOPTIONS_OVERPOUCH_POUCH,
    OPTION_OBSERVEDDAMAGEOPTIONS_PATCH,
    OPTION_OBSERVEDDAMAGEOPTIONS_RUBBER_STOPPER,
    OPTION_OBSERVEDDAMAGEOPTIONS_SHIPPING_CARTON,
    OPTION_OBSERVEDDAMAGEOPTIONS_SHRINKBAND,
    OPTION_OBSERVEDDAMAGEOPTIONS_SOLUTION_CONTAINER,
    OPTION_OBSERVEDDAMAGEOPTIONS_TIP_PROTECTOR,
    OPTION_OBSERVEDDAMAGEOPTIONS_TAMPER_EVIDENT_SEAL,
    OPTION_TYPEOBSERVEDDAMAGEOPTIONS_BENT,
    OPTION_TYPEOBSERVEDDAMAGEOPTIONS_BROKEN,
    OPTION_TYPEOBSERVEDDAMAGEOPTIONS_CRACKED,
    OPTION_TYPEOBSERVEDDAMAGEOPTIONS_CUT,
    OPTION_TYPEOBSERVEDDAMAGEOPTIONS_DEFORMED,
    OPTION_TYPEOBSERVEDDAMAGEOPTIONS_FLAKING,
    OPTION_TYPEOBSERVEDDAMAGEOPTIONS_HOLE,
    OPTION_TYPEOBSERVEDDAMAGEOPTIONS_KINKED,
    OPTION_TYPEOBSERVEDDAMAGEOPTIONS_MELTED,
    OPTION_TYPEOBSERVEDDAMAGEOPTIONS_PATCH_LAYER_SEPARATION,
    OPTION_TYPEOBSERVEDDAMAGEOPTIONS_SHATTERED_GLASS,
    OPTION_TYPEOBSERVEDDAMAGEOPTIONS_SLICED,
    OPTION_TYPEOBSERVEDDAMAGEOPTIONS_TORN,
    OPTION_FLOWISSUEOBSERVEDOPTIONS_SOLUTION_WOULD_NOT_FLOW,
    OPTION_FLOWISSUEOBSERVEDOPTIONS_SOLUTION_WOULD_FLOW,
    OPTION_FLOWISSUEOBSERVEDOPTIONS_SOLUTION_WOULD_COMPOUNDING,
    OPTION_PRODUCTDISCOLOREDOPTIONS_BOTTLE,
    OPTION_PRODUCTDISCOLOREDOPTIONS_CONTAINER,
    OPTION_PRODUCTDISCOLOREDOPTIONS_HANGER_HOLE,
    OPTION_PRODUCTDISCOLOREDOPTIONS_LINER,
    OPTION_PRODUCTDISCOLOREDOPTIONS_OVERPOUCH_POUCH,
    OPTION_PRODUCTDISCOLOREDOPTIONS_OXYGEN_INDICATOR,
    OPTION_PRODUCTDISCOLOREDOPTIONS_PATCH,
    OPTION_PRODUCTDISCOLOREDOPTIONS_PORTS,
    OPTION_PRODUCTDISCOLOREDOPTIONS_SOLUTION,
    OPTION_PRODUCTDISCOLOREDOPTIONS_TIP_PROTECTOR,
    OPTION_CHAMBERDISCOLOREDOPTIONS_AMINO_ACID_CHAMBER,
    OPTION_CHAMBERDISCOLOREDOPTIONS_DEXTROSE_CHAMBER,
    OPTION_CHAMBERDISCOLOREDOPTIONS_LIPID_CHAMBER,
    OPTION_CHAMBERDISCOLOREDOPTIONS_LOWER_CHAMBER,
    OPTION_CHAMBERDISCOLOREDOPTIONS_UPPER_CHAMBER,
    OPTION_SPECIFICALLYDESCRIBESOPTIONS_BURST_RUPTURED_SEAL,
    OPTION_SPECIFICALLYDESCRIBESOPTIONS_MISASSEMBLED_PRODUCT_PART,
    OPTION_SPECIFICALLYDESCRIBESOPTIONS_MISSING_COMPONENT,
    OPTION_WHATTYPEDAMAGEISSUEOPTIONS_SEPARATION_DISCONNECTION_OF,
    OPTION_SPECIFICALLYDESCRIBESOPTIONS_PRODUCT_OVER_FILLED,
    OPTION_SPECIFICALLYDESCRIBESOPTIONS_PRODUCT_UNDER_FILLED,
    OPTION_SPECIFICALLYDESCRIBESOPTIONS_RECONSTITUTION,
    OPTION_MATTERFOREIGNMATERIALOPTIONS_INSIDE_SOLUTION,
    OPTION_MATTERFOREIGNMATERIALOPTIONS_INSIDE_THE_VAPORIZER,
    OPTION_MATTERFOREIGNMATERIALOPTIONS_ON_XTERNAL_SURFACE,
    OPTION_MATTERFOREIGNMATERIALOPTIONS_ON_THE_OUTSIDE,
    OPTION_MATTERFOREIGNMATERIALOPTIONS_ON_THE_OXYGEN,
    OPTION_MATTERFOREIGNMATERIALOPTIONS_ON_THE_TRANSDERMAL,
    OPTION_MATTERFOREIGNMATERIALPIECESOPTIONS_FRANGIBLE,
    OPTION_MATTERFOREIGNMATERIALPIECESOPTIONS_GLASS_PARTICLES,
    OPTION_MATTERFOREIGNMATERIALPIECESOPTIONS_PORT,
    OPTION_MATTERFOREIGNMATERIALPIECESOPTIONS_RUBBER_STOPPER,
    OPTION_MATTERFOREIGNMATERIALPIECESOPTIONS_TUBING,
    OPTION_WHENMATERIALOBSERVEDOPTIONS_AFTER_ADDING_ANOTHER,
    OPTION_WHENMATERIALOBSERVEDOPTIONS_AFTER_PRIOR_TO_SPIKING,
    OPTION_CLOUDINESSOBSERVEDOPTIONS_COLD_THAWED,
    OPTION_CLOUDINESSOBSERVEDOPTIONS_FROZEN,
    OPTION_CLOUDINESSOBSERVEDOPTIONS_PARTIALLY_THAWED,
    OPTION_CLOUDINESSOBSERVEDOPTIONS_ROOM_TEMPERATURE,
    OPTION_PRODUCTTHAWEDOPTIONS_VANTIVE_THAWING,
    OPTION_PRODUCTTHAWEDOPTIONS_LEFT_ON_COUNTER,
    OPTION_PRODUCTTHAWEDOPTIONS_REFRIGERATOR,
    OPTION_DAMAGEISSUEOBSERVEDOPTIONS_YES_EVIDENCE,
    OPTION_DAMAGEISSUEOBSERVEDOPTIONS_YES_LEAK_OBSERVED,
    OPTION_DAMAGEISSUEOBSERVEDOPTIONS_YES_HOLE_OR_INCOMPLETE,
    OPTION_DAMAGEISSUEOBSERVEDOPTIONS_YES_DIFFICULTY_SPIKING,
    OPTION_DAMAGEISSUEOBSERVEDOPTIONS_YES_DIFFICULTY_BREAKING,
    OPTION_DAMAGEISSUEOBSERVEDOPTIONS_YES_THERE_WAS_CRYSTALLIZATION,
    OPTION_DAMAGEISSUEOBSERVEDOPTIONS_YES_THERE_WAS_CLOUDINESS,
    OPTION_DAMAGESPECIFICINFOOPTIONS_PRODUCT_DID_NOT,
    OPTION_DAMAGESPECIFICINFOOPTIONS_UNINTENDED_EFFECT,
    OPTION_SCENARIOSLEAKOPTIONS_OPTION_APPROPRIATEDESCRIPTIONOPTIONS_DAMAGED_SHIPPING,
    OPTION_APPROPRIATEDESCRIPTIONOPTIONS_EXPIRED_PRODUCT_DELIVERED,
    OPTION_APPROPRIATEDESCRIPTIONOPTIONS_EXPIRED_PRODUCT_FOUND,
    OPTION_LABELINGISSUEOPTIONS_BARCODE_ISSUE,
    OPTION_LABELINGISSUEOPTIONS_DIFFICULTIES_SCANNING,
    OPTION_LABELINGISSUEOPTIONS_EXPIRED_PRODUCT_DELIVERED,
    OPTION_LABELINGISSUEOPTIONS_EXPIRED_PRODUCT_INVENTORY,
    OPTION_LABELINGISSUEOPTIONS_EXPIRED_ILLEGIBLE_LABEL,
    OPTION_LABELINGISSUEOPTIONS_INCORRECT_LABEL,
    OPTION_LABELINGISSUEOPTIONS_INCOMPLETE_LABEL,
    OPTION_LABELINGISSUEOPTIONS_ILABEL_TOO_SIMILAR,
    OPTION_LABELINGISSUEOPTIONS_LABELS_PRODUCT,
    OPTION_LABELINGISSUEOPTIONS_MISSING_BARCODE,
    OPTION_DESCOFISSUEOPTIONS_CARTON_BOX,
    OPTION_DESCOFISSUEOPTIONS_DAMAGED_SHIPPING,
    OPTION_DESCOFISSUEOPTIONS_EXTRA_UNITS_WERE_RECEIVED,
    OPTION_DESCOFISSUEOPTIONS_EXPIRED_PRODUCT_DELIVERED,
    OPTION_DESCOFISSUEOPTIONS_EXPIRED_PRODUCT_FOUND,
    OPTION_DESCOFISSUEOPTIONS_PART_OF_THE_CARTON,
    OPTION_DESCOFISSUEOPTIONS_PRODUCT_INFO_ON_THE_CARTON,
    OPTION_DESCOFISSUEOPTIONS_UNITS_WERE_MISSING,
    OPTION_DESCOFISSUEOPTIONS_OTHER,
    OPTION_LABELINGISSUEOPTIONS_MISSING_LABEL,
    OPTION_WHATINCORRECTLYDISPLAYEDOPTIONS_EXPIRATION_DATE,
    OPTION_WHATINCORRECTLYDISPLAYEDOPTIONS_LOT_NUMBER,
    OPTION_WHATINCORRECTLYDISPLAYEDOPTIONS_NDC_NUMBER,
    OPTION_MOISTUREOBSERVEDOPTIONS_DROPLETS_MOISTURE,
    OPTION_MOISTUREOBSERVEDOPTIONS_LEAK,
    OPTION_MOISTUREOBSERVEDOPTIONS_LEAK_OBSERVED,
    OPTION_MOISTUREOBSERVEDOPTIONS_SOLUTION_FLOWING,
    OPTION_MOISTUREOBSERVEDOPTIONS_SOLUTION_INSIDE,
    OPTION_COMPONENTLEAKINGOPTIONS_BETWEEN_OVERPOUCH,
    OPTION_COMPONENTLEAKINGOPTIONS_CONNECTION_BETWEEN,
    OPTION_COMPONENTLEAKINGOPTIONS_CONTAINER_MEMBRANE,
    OPTION_COMPONENTLEAKINGOPTIONS_CONTAINER_INJECTION,
    OPTION_COMPONENTLEAKINGOPTIONS_CONTAINER_HANGER,
    OPTION_COMPONENTLEAKINGOPTIONS_CONTAINER,
    OPTION_COMPONENTLEAKINGOPTIONS_FRANGIBLE,
    OPTION_COMPONENTLEAKINGOPTIONS_RUBBER_STOPPER,
    OPTION_COMPONENTLEAKINGOPTIONS_SHRINKBAND,
    OPTION_COMPONENTLEAKINGOPTIONS_TIP_PROTECTOR,
    OPTION_COMPONENTLEAKINGOPTIONS_UNKNOWN,
    OPTION_COMPONENTLEAKINGOPTIONS_VIAL_ADAPTER,
    OPTION_SCENARIOSLEAKOPTIONS_ADHERED_PORT,
    OPTION_SCENARIOSLEAKOPTIONS_DAMAGE_HOLES,
    OPTION_SCENARIOSLEAKOPTIONS_EXPOSURE_TO_EXTREME,
    OPTION_SCENARIOSLEAKOPTIONS_LEAK_AT_VAPORIZER,
    OPTION_SCENARIOSLEAKOPTIONS_OPENING_SHIPPING,
    OPTION_SCENARIOSLEAKOPTIONS_PETS_CLAWED,
    OPTION_SCENARIOSLEAKOPTIONS_SOLUTION_BAG_UNDER,
    NO_DESCRIBE_THE_COLOR,
    OPTION_LIQUIDSPILLEDOPTIONS_ML,
    OPTION_LIQUIDSPILLEDOPTIONS_GREATER_THAN_ML,
    OPTION_LIQUIDSPILLEDOPTIONS_LESS_THAN_ML,
    OPTION_VISIBLEDEFECTSOPTIONS_BOTTLE,
    OPTION_VISIBLEDEFECTSOPTIONS_CAP,
    OPTION_VISIBLEDEFECTSOPTIONS_VALVE_NECK,
    OPTION_VISIBLEDEFECTSOPTIONS_NONE,
    OPTION_OPTIONCONNECTIONISSUEOPTIONS_CONNECTING,
    OPTION_OPTIONCONNECTIONISSUEOPTIONS_DISCONNECTING,
    OPTION_OPTIONCONNECTIONISSUEOPTIONS_SEPARATION_OF_COMPONENTS,
    OPTION_OPTIONCONNECTIONISSUEOPTIONS_SEPARATION_DISCONNECTION,
    OPTION_WHATCOMPONENTDISCOLOREDOPTIONS_DRIP_CHAMBER,
    OPTION_WHATCOMPONENTDISCOLOREDOPTIONS_TUBING,
    OPTION_WHATCOMPONENTDISCOLOREDOPTIONS_UNKNOWN,
    OPTION_WHATCOMPONENTDISCOLOREDOPTIONS_OTHER_PLEASE_SPECIFY,
    OTHER_PLEASE_SPECIFY,
    OPTION_DESCRIBESDISCOLORATIONOPTIONS_WHITE_CLOUDY,
    OPTION_DESCRIBESDISCOLORATIONOPTIONS_YELLOW_BROWNISH,
    OPTION_DESCRIBESDISCOLORATIONOPTIONS_OTHER_PLEASE_SPECIFY,
    OPTION_WHEREMATTERLOCATEDOPTIONS_IN_THE_PRIMARY_PACKAGING,
    OPTION_WHEREMATTERLOCATEDOPTIONS_INSIDE_THE_IV,
    OPTION_WHEREMATTERLOCATEDOPTIONS_INSIDE_THE_SHIPPING,
    OPTION_WHEREMATTERLOCATEDOPTIONS_ON_THE_EXTERIOR,
    OPTION_WHEREMATTERLOCATEDOPTIONS_OUTSIDE_THE_IV,
    OPTION_EMBEDDEDPLASTICOPTIONS_EMBEDDED,
    OPTION_EMBEDDEDPLASTICOPTIONS_LOOSE,
    OPTION_EMBEDDEDPLASTICOPTIONS_NOT_APPLICABLE,
    OPTION_INFUSATESOLUTIONOPTIONS_DESCRIBE_COLOR,
    OPTION_INFUSATESOLUTIONOPTIONS_YES_CHANGE_IN_COLOR,
    OPTION_INFUSATESOLUTIONOPTIONS_YES_PRECIPITATE,
    OPTION_DAMAGECOMPONENTAFFECTEDOPTIONS_ACCESS_SITE,
    OPTION_DAMAGECOMPONENTAFFECTEDOPTIONS_BURRETTES,
    OPTION_DAMAGECOMPONENTAFFECTEDOPTIONS_CLAMP,
    OPTION_DAMAGECOMPONENTAFFECTEDOPTIONS_DRIP_CHAMBER,
    OPTION_DAMAGECOMPONENTAFFECTEDOPTIONS_TUBING,
    DAMAGECOMPONENTAFFECTEDOPTIONS_UNKNOWN,
    DAMAGECOMPONENTAFFECTEDOPTIONS_OTHER,
    OPTION_DAMAGECOMPONENTAFFECTEDOPTIONS_FILTERS,
    OPTION_DAMAGECOMPONENTAFFECTEDOPTIONS_LUER_CONNECTOR,
    OPTION_DAMAGECOMPONENTAFFECTEDOPTIONS_SPIKE,
    OPTION_WHATTYPEDAMAGEISSUEOPTIONS_CUT_CRACKED_BROKEN,
    OPTION_WHATTYPEDAMAGEISSUEOPTIONS_INCORRECT_COMPONENT_ASSEMBLY,
    OPTION_WHATTYPEDAMAGEISSUEOPTIONS_KINKED_COLLAPSED,
    OPTION_WHATTYPEDAMAGEISSUEOPTIONS_LOOSE_COMPONENT,
    OPTION_WHATTYPEDAMAGEISSUEOPTIONS_MALFORMED_MIS_SHAPED,
    OPTION_WHATTYPEDAMAGEISSUEOPTIONS_MISSING_COMPONENT,
    OPTION_SITUATIONDESCRIBESISSUEOPTIONS_DIFFICULTY_CONNECTING_THE,
    OPTION_SITUATIONDESCRIBESISSUEOPTIONS_DIFFICULTY_DISCONNECTING_THE,
    OPTION_SITUATIONDESCRIBESISSUEOPTIONS_LOOSE_CONNECTION,
    OPTION_SITUATIONDESCRIBESISSUEOPTIONS_SEPARATION_DISCONNECTION,
    OPTION_SITUATIONDESCRIBESISSUEOPTIONS_SEPARATION_BETWEEN_TWO,
    OPTION_SITUATIONDESCRIBESISSUEOPTIONS_UNABLE_TO_CONNECT,
    OPTION_SITUATIONDESCRIBESISSUEOPTIONS_UNABLE_TO_DISCONNECTT,
    OPTION_DESCRIPTIONLABELINGISSUEOPTIONS_BARCODE_ISSUE,
    OPTION_DESCRIPTIONLABELINGISSUEOPTIONS_CHANGE_IN_LABELING,
    OPTION_DESCRIPTIONLABELINGISSUEOPTIONS_DIFFICULTIES_SCANNING,
    OPTION_DESCRIPTIONLABELINGISSUEOPTIONS_OTHER,
    OPTION_DESCRIPTIONLABELINGISSUEOPTIONS_EXPIRED_PRODUCT,
    OPTION_DESCRIPTIONLABELINGISSUEOPTIONS_INCORRECT_INFORMATION_ON_LABEL,
    OPTION_DESCRIPTIONLABELINGISSUEOPTIONS_MISSING_BARCODE_UDI,
    OPTION_DESCRIPTIONLABELINGISSUEOPTIONS_MISSING_INFORMATION_ON_LABEL,
    OPTION_DESCRIPTIONLABELINGISSUEOPTIONS_PRODUCT_WITH_NO_EXPIRATION,
    OPTION_DESCRIPTIONLABELINGISSUEOPTIONS_SMUDGES_ILLEGIBLE_LABELING,
    OPTION_APPROPRIATEDESCISSUEOPTIONS_CARTON_BOX,
    OPTION_APPROPRIATEDESCISSUEOPTIONS_DAMAGED_SHIPPING,
    OPTION_APPROPRIATEDESCISSUEOPTIONS_EXPIRED_PRODUCT_DELIVERED,
    OPTION_APPROPRIATEDESCISSUEOPTIONS_EXPIRED_PRODUCT_FOUND,
    OPTION_APPROPRIATEDESCISSUEOPTIONS_OTHER,
    OPTION_ORDEREDFROMVANTIVEOPTIONS_VANTIVE,
    OPTION_ORDEREDFROMVANTIVEOPTIONS_DISTRIBUTOR,
    OPTION_APPROPRIATEDESCISSUEOPTIONS_EXTRA_UNITS_WERE_RECEIVED,
    OPTION_APPROPRIATEDESCISSUEOPTIONS_PART_OF_THE_CARTON,
    OPTION_APPROPRIATEDESCISSUEOPTIONS_PRODUCT_INFO_ON_THE_CARTON,
    OPTION_APPROPRIATEDESCISSUEOPTIONS_UNITS_WERE_MISSING,
    OPTION_LEAKCOMINGFROMOPTIONS_ACCESS_SITE,
    OPTION_LEAKCOMINGFROMOPTIONS_AIR_VENT,
    OPTION_LEAKCOMINGFROMOPTIONS_BURETTES,
    OPTION_LEAKCOMINGFROMOPTIONS_CAP,
    OPTION_LEAKCOMINGFROMOPTIONS_CLEARLINK_INJECTION_SITES,
    OPTION_LEAKCOMINGFROMOPTIONS_CLAMP,
    OPTION_LEAKCOMINGFROMOPTIONS_DRIP_CHAMBER,
    OPTION_LEAKCOMINGFROMOPTIONS_FILTERS,
    OPTION_LEAKCOMINGFROMOPTIONS_INTERLINK_INJECTION_SITES,
    OPTION_LEAKCOMINGFROMOPTIONS_LUER_CONNECTOR,
    OPTION_LEAKCOMINGFROMOPTIONS_SPIKE,
    OPTION_LEAKCOMINGFROMOPTIONS_TUBING,
    OPTION_LEAKCOMINGFROMOPTIONS_UNKNOWN,
    OPTION_LEAKCOMINGFROMOPTIONS_OTHER,
    OPTION_LEAKCOMINGFROMOPTIONS_LEAK_BETWEEN_THE,
    OPTION_LEAKCOMINGFROMOPTIONS_NEEDLE_BASED,
    OPTION_LEAKCOMINGFROMOPTIONS_ONE_LINK_INJECTION,
    OPTION_LEAKCOMINGFROMOPTIONS_OTHER_INJECTION,
    OPTION_FOLLOWINGSCENARIOSOPTIONS_CRACK_BREAK_IN,
    OPTION_FOLLOWINGSCENARIOSOPTIONS_CUT_SLICE_IN,
    DISCONNECTION_OF_CONNECTABLE,
    OPTION_FOLLOWINGSCENARIOSOPTIONS_DISCONNECTION_OF_CONNECTABLE,
    OPTION_FOLLOWINGSCENARIOSOPTIONS_SEPARATION_OF_BONDED_COMPONENTS,
    OPTION_VISIBLEIRREGULARITIESOPTIONS_YES_DESCRIBE_IRREGULARITIES,
    YES_SPECIFY_THE_TOOL,
    OPTION_SITUATIONFLOWISSUEOPTIONS_BACKFLOW,
    OPTION_SITUATIONFLOWISSUEOPTIONS_CLAMP_FAILURE_DIFFICULT,
    OPTION_SITUATIONFLOWISSUEOPTIONS_CLAMP_FAILURE_UNABLE,
    OPTION_SITUATIONFLOWISSUEOPTIONS_CLAMP_FAILURE_DIFFICULT_UNABLE,
    OPTION_SITUATIONFLOWISSUEOPTIONS_NO_FLOW,
    OPTION_SITUATIONFLOWISSUEOPTIONS_OVER_INFUSION,
    OPTION_SITUATIONFLOWISSUEOPTIONS_RESTRICTED_SLOW,
    OPTION_SITUATIONFLOWISSUEOPTIONS_SIMULTANEOUS_FLOW,
    OPTION_SITUATIONFLOWISSUEOPTIONS_UNABLE_TO_CLEAR,
    OPTION_SITUATIONFLOWISSUEOPTIONS_UNABLE_TO_PRIME,
    OPTION_SITUATIONFLOWISSUEOPTIONS_UNDER_INFUSION,
    OPTION_FLOWINGBACKWARDSOPTIONS_PATIENTS_BLOOD,
    OPTION_FLOWINGBACKWARDSOPTIONS_SOLUTIONS_BLOOD,
    OPTION_SITUATIONSAPPLYEVENTOPTIONS_DAMAGE_HOLE,
    OPTION_SITUATIONSAPPLYEVENTOPTIONS_DISCONNECTION,
    OPTION_SITUATIONSAPPLYEVENTOPTIONS_LEAK,
    OPTION_SITUATIONSAPPLYEVENTOPTIONS_MEDICATION_WAS_BEING,
    OPTION_SITUATIONSAPPLYEVENTOPTIONS_SECONDARY_BAG_WAS_LOWER,
    OPTION_SITUATIONSAPPLYEVENTOPTIONS_SECONDARY_BAG_WAS_AT,
    OPTION_PREVIOUSLYFLOWOBSERVEDOPTIONS_BLOOD_CLOTTING,
    OPTION_PREVIOUSLYFLOWOBSERVEDOPTIONS_CATHETER_WAS,
    OPTION_PREVIOUSLYFLOWOBSERVEDOPTIONS_KINKED_TUBING,
    OPTION_PREVIOUSLYFLOWOBSERVEDOPTIONS_TUBING_INJECTION,
    OPTION_SIMULTANEOUSFLOWOPTIONS_PRIMARY_AND_SECONDARY,
    OPTION_SIMULTANEOUSFLOWOPTIONS_TWO_OR_MORE_LEADS,
    OPTION_SIMULTANEOUSFLOWOPTIONS_TWO_ADMINISTRATION,
    OPTION_HANGERUSEDOPTIONS_VANTIVE_HANGER,
    OPTION_HANGERUSEDOPTIONS_NON_VANTIVE_HANGER,
    OPTION_BAGLOWEROPTIONS_BAGS_WERE_AT,
    OPTION_BAGLOWEROPTIONS_PRIMARY,
    OPTION_BAGLOWEROPTIONS_SECONDARY,
    OPTION_YSITECONNECTEDOPTIONS_MIDDLE,
    OPTION_YSITECONNECTEDOPTIONS_LOWER,
    OPTION_YSITECONNECTEDOPTIONS_UPPER,
    OPTION_WITHPUMPOPTIONS_YES_PROVIDE_NAME,
    OPTION_WHATCLAMPFAILEDOPTIONS_DARK_BLUE,
    OPTION_WHATCLAMPFAILEDOPTIONS_LIGHT_BLUE,
    OPTION_WHATCLAMPFAILEDOPTIONS_NOTCH_CLAMP,
    OPTION_WHATCLAMPFAILEDOPTIONS_ROLLER_CLAMP,
    OPTION_WHATCLAMPFAILEDOPTIONS_WHITE_SLIDE_CLAMP,
    OPTION_ISSUESOBSERVEDCLAMPOPTIONS_YES_THE_CLAMP,
    OPTION_OTHERSITUATIONSPRODUCTOPTIONS_AIR_IN_LINE,
    OPTION_OTHERSITUATIONSPRODUCTOPTIONS_CLAMP_ISSUE,
    OPTION_OTHERSITUATIONSPRODUCTOPTIONS_ODOR,
    OPTION_OTHERSITUATIONSPRODUCTOPTIONS_OTHER,
    OPTION_WHICHCLAMPISSUEOPTIONS_NOTCH_PINCH,
    OPTION_WHICHCLAMPISSUEOPTIONS_ROLLER_CLAMP,
    OPTION_WHICHCLAMPISSUEOPTIONS_SLIDE_CLAMP,
    OPTION_WHICHCLAMPISSUEOPTIONS_UNKNOWN,
    OPTION_WHICHCLAMPISSUEOPTIONS_OTHER,
    OPTION_CLAMPISSUEEXPERIENCEDOPTIONS_CRACKED_BROKEN,
    OPTION_CLAMPISSUEEXPERIENCEDOPTIONS_DIFFICULT_TO_OPEN,
    OPTION_CLAMPISSUEEXPERIENCEDOPTIONS_DIFFICULT_TO_CLOSE,
    OPTION_CLAMPISSUEEXPERIENCEDOPTIONS_MISSING,
    OPTION_CLAMPISSUEEXPERIENCEDOPTIONS_UNABLE_TO_OPEN,
    OPTION_CLAMPISSUEEXPERIENCEDOPTIONS_UNABLE_TO_CLOSE,
    OPTION_CLAMPISSUEEXPERIENCEDOPTIONS_UNABLE_TO_CONTROL,
    OPTION_CLAMPDESCRIBESISSUEOPTIONS_DIFFICULT_TO_SQUEEZE,
    OPTION_CLAMPDESCRIBESISSUEOPTIONS_INSTRUCTIONS_WERE,
    OPTION_CLAMPDESCRIBESISSUEOPTIONS_PRODUCT_WAS_DIFFICULT,
    OPTION_LEAKOCCUROPTIONS_CRACK_BREAK,
    OPTION_LEAKOCCUROPTIONS_CUT_SLICE,
    OPTION_LEAKOCCUROPTIONS_DISCONNECTION_OF_CONNECTABLE,
    OPTION_LEAKOCCUROPTIONS_HOLE_TEA,
    OPTION_LEAKOCCUROPTIONS_SEPARATION_OF_BONDED,
    OPTION_LEAKOCCUROPTIONS_OTHER,
    OPTION_LEAKSCENARIOSOPTIONS_ADHERED_PORT,
    OPTION_LEAKSCENARIOSOPTIONS_DAMAGE_HOLES,
    OPTION_LEAKSCENARIOSOPTIONS_DAMAGED_SHIPPING_CARTON,
    OPTION_LEAKSCENARIOSOPTIONS_EXPOSURE_TO_EXTREME,
    OPTION_LEAKSCENARIOSOPTIONS_OPENING_SHIPPING,
    OPTION_LEAKSCENARIOSOPTIONS_UNKNOWN,
    OPTION_LEAKSCENARIOSOPTIONS_NONE_OF_THE_ABOVE,
    OPTION_LEAKSCENARIOSOPTIONS_PRESSURE_CUFF,
    OPTION_LEAKSCENARIOSOPTIONS_PETS_CLAWED_CHEWED,
    OPTION_PRODUCTDAMAGEDOPTIONS_PRODUCT,
    OPTION_PRODUCTDAMAGEDOPTIONS_SHIPPING_CARTON_BOX,
    OPTION_MATTERFOREIGNLOCATEDOPTIONS_INSIDE_THE_PRODUCT,
    OPTION_MATTERFOREIGNLOCATEDOPTIONS_INSIDE_THE_SHIPPING,
    OPTION_MATTERFOREIGNLOCATEDOPTIONS_ON_THE_OUTSIDE_OF_PRODUCT,
    OPTION_SELOPTIONCONNECTIONISSUEOPTIONS_DIFFICULTIES_CONNECTING,
    OPTION_SELOPTIONCONNECTIONISSUEOPTIONS_DIFFICULTIES_DISCONNECTING,
    OPTION_SELOPTIONCONNECTIONISSUEOPTIONS_LOOSE_CONNECTION,
    OPTION_SELOPTIONCONNECTIONISSUEOPTIONS_SEPARATION_OF_COMPONENTS,
    OPTION_SELOPTIONCONNECTIONISSUEOPTIONS_SEPARATION_DISCONNECTION,
    OPTION_MATTERFOREIGNLOCATEDOPTIONS_ON_THE_EXTERIOR,
    OPTION_MATTERFOREIGNLOCATEDOPTIONS_ON_THE_INSIDE_OF,
    OPTION_MATTERFOREIGNLOCATEDOPTIONS_ON_THE_OUTSIDE_OF,
    OPTION_OPTIONFLOWISSUEOPTIONS_NOT_FLOWING,
    OPTION_OPTIONFLOWISSUEOPTIONS_RESTRICTED_OR,
    OPTION_OPTIONFLOWISSUEOPTIONS_OTHER,
    OPTION_MOSTAPPROLABELINGISSUEOPTIONS_BARCODE_ISSUE,
    OPTION_MOSTAPPROLABELINGISSUEOPTIONS_DIFFICULTIES_SCANNING,
    OPTION_MOSTAPPROLABELINGISSUEOPTIONS_ILLEGIBLE_LABEL,
    OPTION_MOSTAPPROLABELINGISSUEOPTIONS_INCORRECT_LABEL,
    OPTION_MOSTAPPROLABELINGISSUEOPTIONS_INCOMPLETE_LABEL,
    OPTION_MOSTAPPROLABELINGISSUEOPTIONS_LABELS_PRODUCT,
    OPTION_MOSTAPPROLABELINGISSUEOPTIONS_LABEL_TOO_SIMILAR,
    OPTION_MOSTAPPROLABELINGISSUEOPTIONS_MISSING_LABEL,
    OPTION_MOSTAPPROLABELINGISSUEOPTIONS_MISSING_BARCODE,
    OPTION_MOSTAPPROLABELINGISSUEOPTIONS_OTHER,
    OPTION_DESCOFISSUEOPTIONS_FROZEN_PRODUCT,
    OPTION_DESCOFISSUEOPTIONS_THAWED_PRODUCT,
    OPTION_ALARMOPTIONS_YES_ALARM_NOT_KNOWN,
    OPTION_ALARMOPTIONS_YES_SPECIFY,
    OPTION_DIFFICULTINTWISTCLAMPOPTIONS_YES_THE_TRANSFER_FULLY_OPEN,
    OPTION_DIFFICULTINTWISTCLAMPOPTIONS_YES_THE_TRANSFER_FULLY_CLOSED,
    OPTION_DIFFICULTINTWISTCLAMPOPTIONS_YES_THE_TWIST_OPEN_AT_ALL,
    OPTION_DIFFICULTINTWISTCLAMPOPTIONS_YES_THE_TWIST_CLOSE_AT_ALL,
    OPTION_COMPONENTHADISSUEOPTIONS_BOX_OR_OVERPOUCH,
    OPTION_COMPONENTHADISSUEOPTIONS_BLUE_CLAMP_ON,
    OPTION_COMPONENTHADISSUEOPTIONS_CASSETT,
    OPTION_COMPONENTHADISSUEOPTIONS_DRAIN_LINE,
    OPTION_COMPONENTHADISSUEOPTIONS_EFFLUENT_SAMPLE,
    OPTION_COMPONENTHADISSUEOPTIONS_LINES,
    OPTION_COMPONENTHADISSUEOPTIONS_LUER_SPIKE,
    OPTION_COMPONENTHADISSUEOPTIONS_ORGANIZER,
    OPTION_COMPONENTHADISSUEOPTIONS_PULL_RING_PATIENT_LINE,
    OPTION_COMPONENTHADISSUEOPTIONS_PULL_RING_PROTECTORS,
    OPTION_COMPONENTHADISSUEOPTIONS_RED_CLAMP_ON,
    OPTION_COMPONENTHADISSUEOPTIONS_TACK_WELD,
    OPTION_COMPONENTHADISSUEOPTIONS_WHITE_CLAMP_ON_SUPPLY,
    OPTION_SELECTCOMPONENTHADISSUEOPTIONS_BEIGE_CATHETER,
    OPTION_SELECTCOMPONENTHADISSUEOPTIONS_CHIP_INSERT,
    OPTION_SELECTCOMPONENTHADISSUEOPTIONS_DARK_BLUE_CONNECTOR,
    OPTION_SELECTCOMPONENTHADISSUEOPTIONS_LIGHT_BLUE_MAIN,
    OPTION_SELECTCOMPONENTHADISSUEOPTIONS_LIGHT_BLUE_PULL,
    OPTION_SELECTCOMPONENTHADISSUEOPTIONS_LIGHT_BLUE_OCCLUDER,
    OPTION_SELECTCOMPONENTHADISSUEOPTIONS_SILICONE_TUBING,
    OPTION_SELECTCOMPONENTHADISSUEOPTIONS_TITANIUM_SPIKE,
    OPTION_SELECTCOMPONENTHADISSUEOPTIONS_UV_FLASH_SPIKE,
    OPTION_SELECTCOMPONENTHADISSUEOPTIONS_WHITE_TWIST_CLAMP,
    OPTION_ANYCOMPONENTDAMAGEDOPTIONS_YES_DESCRIBE_THE_DAMAGE,
    OPTION_MONTHOPTIONS_JAN,
    OPTION_MONTHOPTIONS_FEB,
    OPTION_MONTHOPTIONS_MAR,
    OPTION_MONTHOPTIONS_APR,
    OPTION_MONTHOPTIONS_MAY,
    OPTION_MONTHOPTIONS_JUN,
    OPTION_MONTHOPTIONS_JUL,
    OPTION_MONTHOPTIONS_AUG,
    OPTION_MONTHOPTIONS_SEP,
    OPTION_MONTHOPTIONS_OCT,
    OPTION_MONTHOPTIONS_NOV,
    OPTION_MONTHOPTIONS_DEC,
    OPTION_SCENARIOSWITHLEAKOPTIONS_ADHERED_PORT,
    OPTION_SCENARIOSWITHLEAKOPTIONS_DAMAGE_HOLES,
    OPTION_SCENARIOSWITHLEAKOPTIONS_DAMAGED_SHIPPING,
    OPTION_SCENARIOSWITHLEAKOPTIONS_EXPOSURE_TO_EXTREME,
    OPTION_SCENARIOSWITHLEAKOPTIONS_LEAK_AT_VAPORIZER,
    OPTION_SCENARIOSWITHLEAKOPTIONS_OPENING_SHIPPING,
    OPTION_SCENARIOSWITHLEAKOPTIONS_PETS_CLAWED,
    OPTION_SCENARIOSWITHLEAKOPTIONS_SOLUTION_BAG_UNDER,
    OPTION_SCENARIOSWITHLEAKOPTIONS_UNKNOWN,
    OPTION_SCENARIOSWITHLEAKOPTIONS_NONE_OF_THE_ABOVE,
    OPTION_MATTERFOREIGNMATERIALOPTIONS_IN_THE_SECONDARY,
    OPTION_MATTERFOREIGNMATERIALOPTIONS_INSIDE_THE_SHIPPING,
    OPTION_MATTERFOREIGNMATERIALOPTIONS_ON_THE_EXTERIOR,
    OPTION_MATTERFOREIGNMATERIALOPTIONS_OTHER,
    OPTION_PROBLEMOPTIONS_OTHER,
    OPTION_REPORTEDTOOPTIONS_OTHER,
    OPTION_DIFFICULTTOUSEOPTIONS_OTHER,
    OPTION_DIFFICULTIESMINICAPOPTIONS_OTHER,
    OPTION_BLOCKINGFLOWOPTIONS_OTHER,
    OPTION_DESCRIBEISSUEOPTIONS_OTHER,
    OPTION_MATERIALLOCATEDOPTIONS_OTHER,
    OPTION_OBSERVEDDAMAGEOPTIONS_OTHER,
    OPTION_TYPEOBSERVEDDAMAGEOPTIONS_OTHER,
    OPTION_PRODUCTDISCOLOREDOPTIONS_OTHER,
    OPTION_SPECIFICALLYDESCRIBESOPTIONS_OTHER,
    OPTION_MATTERFOREIGNMATERIALPIECESOPTIONS_OTHER,
    OPTION_PRODUCTTHAWEDOPTIONS_OTHER,
    OPTION_DAMAGEISSUEOBSERVEDOPTIONS_OTHER,
    OPTION_DAMAGESPECIFICINFOOPTIONS_OTHER,
    OPTION_APPROPRIATEDESCRIPTIONOPTIONS_OTHER,
    OPTION_LABELINGISSUEOPTIONS_OTHER,
    OPTION_WHATINCORRECTLYDISPLAYEDOPTIONS_OTHER,
    OPTION_MOISTUREOBSERVEDOPTIONS_OTHER,
    OPTION_COMPONENTLEAKINGOPTIONS_OTHER,
    OPTION_WHATTYPEDAMAGEISSUEOPTIONS_OTHER,
    OPTION_SITUATIONDESCRIBESISSUEOPTIONS_OTHER,
    OPTION_FOLLOWINGSCENARIOSOPTIONS_OTHER,
    OPTION_SITUATIONFLOWISSUEOPTIONS_OTHER,
    OPTION_SITUATIONSAPPLYEVENTOPTIONS_OTHER,
    OPTION_SIMULTANEOUSFLOWOPTIONS_OTHER,
    OPTION_WHATCLAMPFAILEDOPTIONS_OTHER,
    OPTION_CLAMPISSUEEXPERIENCEDOPTIONS_OTHER,
    OPTION_CLAMPDESCRIBESISSUEOPTIONS_DIFFICULT_OTHER,
    OPTION_PRODUCTDAMAGEDOPTIONS_OTHER,
    OPTION_COMPONENTHADISSUEOPTIONS_OTHER,
    OPTION_FOLLOWINGOCCUROPTIONS_NONE_OF_THE_ABOVE,
    OPTION_PREVIOUSLYREPORTEDOPTIONS_NO,
    OPTION_PREVIOUSLYREPORTEDOPTIONS_UNKNOWN,
    OPTION_PREVIOUSLYREPORTEDOPTIONS_YES,
    OPTION_ADDANOTHERFACILITYOPTIONS_NO,
    OPTION_ADDANOTHERFACILITYOPTIONS_YES,
    OPTION_PATIENINVOLVEMENTOPTIONS_NO,
    OPTION_PATIENINVOLVEMENTOPTIONS_UNKNOWN,
    OPTION_PATIENINVOLVEMENTOPTIONS_YES,
    OPTION_OTHERFACILITYREPORTOPTIONS_NO,
    OPTION_OTHERFACILITYREPORTOPTIONS_YES,
    OPTION_AVAILABILITYOPTIONSDISTRIBUTOR_ASKED_UNKNOWN,
    OPTION_AVAILABILITYOPTIONSDISTRIBUTOR_NO,
    OPTION_AVAILABILITYOPTIONSDISTRIBUTOR_UNKNOWN,
    OPTION_AVAILABILITYOPTIONSDISTRIBUTOR_YES,
    OPTION_AVAILABILITYOPTIONS_NO,
    OPTION_AVAILABILITYOPTIONS_YES,
    OPTION_MEDIAAVAILABILITYOPTIONS_NO,
    OPTION_MEDIAAVAILABILITYOPTIONS_YES,
    OPTION_MEDIAAVAILABILITYDISTRIBUTOROPTIONS_NO,
    OPTION_MEDIAAVAILABILITYDISTRIBUTOROPTIONS_UNKNOWN,
    OPTION_MEDIAAVAILABILITYDISTRIBUTOROPTIONS_YES,
    OPTION_UNUSEDAVAILABILITYOPTIONS_NO,
    OPTION_UNUSEDAVAILABILITYOPTIONS_YES,
    OPTION_SELFNEGATIVEIMPACTOPTIONS_NO,
    OPTION_SELFNEGATIVEIMPACTOPTIONS_YES,
    OPTION_PATIENTNEGATIVEIMPACTOPTIONS_NO,
    OPTION_PATIENTNEGATIVEIMPACTOPTIONS_YES,
    OPTION_COUNTERACTIONOPTIONS_NO,
    OPTION_COUNTERACTIONOPTIONS_YES,
    OPTION_DRUGUSEDOPTIONS_NO,
    OPTION_DRUGUSEDOPTIONS_YES,
    OPTION_SHARECONTACTOPTIONS_NO,
    OPTION_SHARECONTACTOPTIONS_YES,
    OPTION_EXPLICITINVESTIGATIONREQUESTOPTIONS_NO,
    OPTION_EXPLICITINVESTIGATIONREQUESTOPTIONS_YES,
    OPTION_DIRECTORDEROPTIONS_NO,
    OPTION_DIRECTORDEROPTIONS_YES,
    OPTION_EXCESSIVEFORCEOPTIONS_NO,
    OPTION_EXCESSIVEFORCEOPTIONS_UNKNOWN,
    OPTION_EXCESSIVEFORCEOPTIONS_YES,
    OPTION_TWISTCLAMPOPTIONS_NO,
    OPTION_TWISTCLAMPOPTIONS_UNKNOWN,
    OPTION_TWISTCLAMPOPTIONS_YES,
    OPTION_DIFFICULTIESMINICAPOPTIONS_NO,
    OPTION_DIFFICULTIESMINICAPOPTIONS_UNKNOWN,
    OPTION_ENVIRONMENTOPTIONS_NO,
    OPTION_ENVIRONMENTOPTIONS_UNKNOWN,
    OPTION_ENVIRONMENTOPTIONS_YES,
    OPTION_SPONGEVISIBLEOPTIONS_NO,
    OPTION_SPONGEVISIBLEOPTIONS_UNKNOWN,
    OPTION_SPONGEVISIBLEOPTIONS_YES,
    OPTION_MATERIALEMBEDDEDOPTIONS_NO,
    OPTION_MATERIALEMBEDDEDOPTIONS_UNKNOWN,
    OPTION_MATERIALEMBEDDEDOPTIONS_YES,
    OPTION_PIECESMATERIALOPTIONS_NO,
    OPTION_PIECESMATERIALOPTIONS_UNKNOWN,
    OPTION_PIECESMATERIALOPTIONS_YES,
    OPTION_DISPOSABLECONNECTIONOPTIONS_NO,
    OPTION_DISPOSABLECONNECTIONOPTIONS_UNKNOWN,
    OPTION_DISPOSABLECONNECTIONOPTIONS_YES,
    OPTION_INITIALCONNECTIONOPTIONS_NO,
    OPTION_INITIALCONNECTIONOPTIONS_UNKNOWN,
    OPTION_INITIALCONNECTIONOPTIONS_YES,
    OPTION_SPIKELUERCONNECTORSOPTIONS_NO,
    OPTION_SPIKELUERCONNECTORSOPTIONS_UNKNOWN,
    OPTION_SPIKELUERCONNECTORSOPTIONS_YES,
    OPTION_PETSORANIMALSOPTIONS_NO,
    OPTION_PETSORANIMALSOPTIONS_UNKNOWN,
    OPTION_PETSORANIMALSOPTIONS_YES,
    OPTION_MINICAPTWISTEDOPTIONS_NO,
    OPTION_MINICAPTWISTEDOPTIONS_UNKNOWN,
    OPTION_MINICAPTWISTEDOPTIONS_YES,
    OPTION_TRANSFERSETOPTIONS_NO,
    OPTION_TRANSFERSETOPTIONS_UNKNOWN,
    OPTION_TRANSFERSETOPTIONS_YES,
    OPTION_RESIDUETHREADSOPTIONS_NO,
    OPTION_RESIDUETHREADSOPTIONS_UNKNOWN,
    OPTION_DAMAGECAUSELEAKOPTIONS_NO,
    OPTION_DAMAGECAUSELEAKOPTIONS_UNKNOWN,
    OPTION_DAMAGECAUSELEAKOPTIONS_YES,
    OPTION_SHIPPINGCARTONOPENOPTIONS_NO,
    OPTION_SHIPPINGCARTONOPENOPTIONS_UNKNOWN,
    OPTION_SHIPPINGCARTONOPENOPTIONS_YES,
    OPTION_ADAPTERDEVICEOPTIONS_NO,
    OPTION_ADAPTERDEVICEOPTIONS_UNKNOWN,
    OPTION_ADAPTERDEVICEOPTIONS_YES,
    OPTION_SQUEEZINGSOLUTIONOPTIONSS_NO,
    OPTION_SQUEEZINGSOLUTIONOPTIONSS_UNKNOWN,
    OPTION_SQUEEZINGSOLUTIONOPTIONSS_YES,
    OPTION_FORTHMOTIONOPTIONS_NO,
    OPTION_FORTHMOTIONOPTIONS_UNKNOWN,
    OPTION_FORTHMOTIONOPTIONS_YES,
    OPTION_ALARMNOFLOWOPTIONS_NO,
    OPTION_ALARMNOFLOWOPTIONS_UNKNOWN,
    OPTION_ALARMNOFLOWOPTIONS_YES,
    OPTION_DISCOLORATIONMARKINGSOPTIONS_NO,
    OPTION_DISCOLORATIONMARKINGSOPTIONS_UNKNOWN,
    OPTION_DISCOLORATIONMARKINGSOPTIONS_YES,
    OPTION_BROKENACTIVATEDOPTIONS_NO,
    OPTION_BROKENACTIVATEDOPTIONS_UNKNOWN,
    OPTION_BROKENACTIVATEDOPTIONS_YES,
    OPTION_vaporizerSightGlassOptions_NO,
    OPTION_vaporizerSightGlassOptions_UNKNOWN,
    OPTION_vaporizerSightGlassOptions_YES,
    OPTION_PRODUCTHEATOPTIONS_NO,
    OPTION_PRODUCTHEATOPTIONS_UNKNOWN,
    OPTION_PRODUCTHEATOPTIONS_YES,
    OPTION_DAMAGEPRIORACTIVATIONOPTIONS_NO,
    OPTION_DAMAGEPRIORACTIVATIONOPTIONS_UNKNOWN,
    OPTION_DAMAGEPRIORACTIVATIONOPTIONS_YES,
    OPTION_LEAKOBSERVEDOPTIONS_NO,
    OPTION_LEAKOBSERVEDOPTIONS_UNKNOWN,
    OPTION_LEAKOBSERVEDOPTIONS_YES,
    OPTION_EMBEDDEDINTHEPRODUCTOPTIONS_NO,
    OPTION_EMBEDDEDINTHEPRODUCTOPTIONS_UNKNOWN,
    OPTION_EMBEDDEDINTHEPRODUCTOPTIONS_YES,
    OPTION_WASSOLUTIONADDEDPRODUCTOPTIONS_NO,
    OPTION_WASSOLUTIONADDEDPRODUCTOPTIONS_UNKNOWN,
    OPTION_WASSOLUTIONADDEDPRODUCTOPTIONS_YES,
    OPTION_CLOUDINESSGOAWAYOPTIONS_NO,
    OPTION_CLOUDINESSGOAWAYOPTIONS_UNKNOWN,
    OPTION_CLOUDINESSGOAWAYOPTIONS_YES,
    OPTION_AGITATEUNITOPTIONS_NO,
    OPTION_AGITATEUNITOPTIONS_UNKNOWN,
    OPTION_AGITATEUNITOPTIONS_YES,
    OPTION_PRECIPITATEDISSOLVEOPTIONS_NO,
    OPTION_PRECIPITATEDISSOLVEOPTIONS_UNKNOWN,
    OPTION_PRECIPITATEDISSOLVEOPTIONS_YES,
    OPTION_TEMPERATURELOGSFREEZEROPTIONS_NO,
    OPTION_TEMPERATURELOGSFREEZEROPTIONS_UNKNOWN,
    OPTION_TEMPERATURELOGSFREEZEROPTIONS_YES,
    OPTION_STORAGEUNITCALIBRATEDOPTIONSS_NO,
    OPTION_STORAGEUNITCALIBRATEDOPTIONSS_UNKNOWN,
    OPTION_STORAGEUNITCALIBRATEDOPTIONSS_YES,
    OPTION_RECENTPRESCRIPTIONOPTIONS_NO,
    OPTION_RECENTPRESCRIPTIONOPTIONS_UNKNOWN,
    OPTION_RECENTPRESCRIPTIONOPTIONS_YES,
    OPTION_EXPIREDPRODUCTOPTIONS_NO,
    OPTION_EXPIREDPRODUCTOPTIONS_UNKNOWN,
    OPTION_EXPIREDPRODUCTOPTIONS_YES,
    OPTION_ABNORMALITIESDAMAGEOPTIONS_NO,
    OPTION_ABNORMALITIESDAMAGEOPTIONS_UNKNOWN,
    OPTION_ABNORMALITIESDAMAGEOPTIONS_YES,
    OPTION_OVERPOUCHPOUCHSCANNINGOPTIONS_NO,
    OPTION_OVERPOUCHPOUCHSCANNINGOPTIONS_UNKNOWN,
    OPTION_OVERPOUCHPOUCHSCANNINGOPTIONS_YES,
    OPTION_LABELSSAMEINFORMATIONOPTIONS_NO,
    OPTION_LABELSSAMEINFORMATIONOPTIONS_UNKNOWN,
    OPTION_LABELSSAMEINFORMATIONOPTIONS_YES,
    OPTION_BARCODESCANNEROPTIONS_NO,
    OPTION_BARCODESCANNEROPTIONS_UNKNOWN,
    OPTION_BARCODESCANNEROPTIONS_YES,
    OPTION_FRANGIBLEOBSERVEDOPTIONS_NO,
    OPTION_FRANGIBLEOBSERVEDOPTIONS_UNKNOWN,
    OPTION_FRANGIBLEOBSERVEDOPTIONS_YES,
    OPTION_FRANGIBLEDAMAGEDEFECTOPTIONS_NO,
    OPTION_FRANGIBLEDAMAGEDEFECTOPTIONS_UNKNOWN,
    OPTION_FRANGIBLEDAMAGEDEFECTOPTIONS_YES,
    OPTION_FRANGIBLEBROKENOPTIONS_NO,
    OPTION_FRANGIBLEBROKENOPTIONS_UNKNOWN,
    OPTION_FRANGIBLEBROKENOPTIONS_YES,
    OPTION_MOISTURECLEAROPTIONS_UNKNOWN,
    OPTION_MOISTURECLEAROPTIONS_YES,
    OPTION_DIFFICULTYSPIKINGOPTIONS_NO,
    OPTION_DIFFICULTYSPIKINGOPTIONS_UNKNOWN,
    OPTION_DIFFICULTYSPIKINGOPTIONS_YES,
    OPTION_WASFRANGIBLEDAMAGEOPTIONS_NO,
    OPTION_WASFRANGIBLEDAMAGEOPTIONS_UNKNOWN,
    OPTION_WASFRANGIBLEDAMAGEOPTIONS_YES,
    OPTION_PRESSURECUFFOPTIONS_NO,
    OPTION_PRESSURECUFFOPTIONS_UNKNOWN,
    OPTION_PRESSURECUFFOPTIONS_YES,
    OPTION_LIQUIDSPILLEDOPTIONS_UNKNOWN,
    OPTION_BOTTLEINTOVAPORIZEROPTIONS_NO,
    OPTION_BOTTLEINTOVAPORIZEROPTIONS_UNKNOWN,
    OPTION_BOTTLEINTOVAPORIZEROPTIONS_YES,
    OPTION_REMOVEDFROMPACKAGEOPTIONS_NO,
    OPTION_REMOVEDFROMPACKAGEOPTIONS_UNKNOWN,
    OPTION_REMOVEDFROMPACKAGEOPTIONS_YES,
    OPTION_ADDINGMEDICATIONOPTIONS_NO,
    OPTION_ADDINGMEDICATIONOPTIONS_UNKNOWN,
    OPTION_ADDINGMEDICATIONOPTIONS_YES,
    OPTION_PATIENTCONNECTEDPRODUCTOPTIONS_NO,
    OPTION_PATIENTCONNECTEDPRODUCTOPTIONS_UNKNOWN,
    OPTION_PATIENTCONNECTEDPRODUCTOPTIONS_YES,
    OPTION_WASPRODUCTREPLACEDOPTIONS_NO,
    OPTION_WASPRODUCTREPLACEDOPTIONS_UNKNOWN,
    OPTION_WASPRODUCTREPLACEDOPTIONS_YES,
    OPTION_WASPOWERINJECTOROPTIONS_NO,
    OPTION_WASPOWERINJECTOROPTIONS_UNKNOWN,
    OPTION_WASPOWERINJECTOROPTIONS_YES,
    OPTION_INJECTIONSITEOPENINGOPTIONS_NO,
    OPTION_INJECTIONSITEOPENINGOPTIONS_UNKNOWN,
    OPTION_INJECTIONSITEOPENINGOPTIONS_YES,
    OPTION_INJECTIONSITEOPENINGOPTIONS_OTHER,
    OPTION_VISIBLEIRREGULARITIESOPTIONS_NO,
    OPTION_VISIBLEIRREGULARITIESOPTIONS_UNKNOWN,
    OPTION_EVENTUALLYESTABLISHEDOPTIONS_NO,
    OPTION_EVENTUALLYESTABLISHEDOPTIONS_UNKNOWN,
    OPTION_EVENTUALLYESTABLISHEDOPTIONS_YES,
    OPTION_TOOLUSEDASSISTOPTIONS_NO,
    OPTION_TOOLUSEDASSISTOPTIONS_UNKNOWN,
    OPTION_SECUREPRIORUSEOPTIONS_NO,
    OPTION_SECUREPRIORUSEOPTIONS_UNKNOWN,
    OPTION_SECUREPRIORUSEOPTIONS_YES,
    OPTION_PRIORDISCONNECTINGOPTIONS_NO,
    OPTION_PRIORDISCONNECTINGOPTIONS_UNKNOWN,
    OPTION_PRIORDISCONNECTINGOPTIONS_YES,
    OPTION_FLOWPREVIOUSLYSEENOPTIONS_NO,
    OPTION_FLOWPREVIOUSLYSEENOPTIONS_UNKNOWN,
    OPTION_FLOWPREVIOUSLYSEENOPTIONS_YES,
    OPTION_YSITECONNECTEDOPTIONS_UNKNOWN,
    OPTION_COMPONENTSETREPLACEDOPTIONS_NO,
    OPTION_COMPONENTSETREPLACEDOPTIONS_UNKNOWN,
    OPTION_COMPONENTSETREPLACEDOPTIONS_YES,
    OPTION_WITHPUMPOPTIONS_NO,
    OPTION_WITHPUMPOPTIONS_UNKNOWN,
    OPTION_CLAMPFAILOPTIONS_NO,
    OPTION_CLAMPFAILOPTIONS_UNKNOWN,
    OPTION_CLAMPFAILOPTIONS_YES,
    OPTION_ISSUESOBSERVEDCLAMPOPTIONS_NO,
    OPTION_ISSUESOBSERVEDCLAMPOPTIONS_UNKNOWN,
    OPTION_WASMATERIALEMBEDDEDOPTIONS_NO,
    OPTION_WASMATERIALEMBEDDEDOPTIONS_UNKNOWN,
    OPTION_WASMATERIALEMBEDDEDOPTIONS_YES,
    OPTION_APPEARPRODUCTMATERIALOPTIONS_NO,
    OPTION_APPEARPRODUCTMATERIALOPTIONS_UNKNOWN,
    OPTION_APPEARPRODUCTMATERIALOPTIONS_YES,
    OPTION_SHIPPINGCARTONDAMAGEDOPTIONS_NO,
    OPTION_SHIPPINGCARTONDAMAGEDOPTIONS_UNKNOWN,
    OPTION_SHIPPINGCARTONDAMAGEDOPTIONS_YES,
    OPTION_GELPACKSOPTIONS_NO,
    OPTION_GELPACKSOPTIONS_YES,
    OPTION_EXPIREDPRODUCTUSEOPTIONS_NO,
    OPTION_EXPIREDPRODUCTUSEOPTIONS_UNKNOWN,
    OPTION_EXPIREDPRODUCTUSEOPTIONS_YES,
    OPTION_ALARMOPTIONS_NO,
    OPTION_ALARMOPTIONS_UNKNOWN,
    OPTION_CLEANINGSOLUTIONSOPTIONS_NO,
    OPTION_CLEANINGSOLUTIONSOPTIONS_UNKNOWN,
    OPTION_CLEANINGSOLUTIONSOPTIONS_YES,
    OPTION_DIFFICULTINTWISTCLAMPOPTIONS_NO,
    OPTION_DIFFICULTINTWISTCLAMPOPTIONS_UNKNOWN,
    OPTION_TRANSFERREPLACEDOPTIONS_NO,
    OPTION_TRANSFERREPLACEDOPTIONS_UNKNOWN,
    OPTION_TRANSFERREPLACEDOPTIONS_YES,
    OPTION_FULLYTIGHTENEDOPTIONS_NO,
    OPTION_FULLYTIGHTENEDOPTIONS_UNKNOWN,
    OPTION_FULLYTIGHTENEDOPTIONS_YES,
    OPTION_ANYCOMPONENTDAMAGEDOPTIONSS_NO,
    OPTION_ANYCOMPONENTDAMAGEDOPTIONSS_UNKNOWN,
    OPTION_ISSUERESULTLEAKOPTIONS_NO,
    OPTION_ISSUERESULTLEAKOPTIONS_UNKNOWN,
    OPTION_ISSUERESULTLEAKOPTIONS_YES,
    OPTION_ISSUERESULTLEAKOPTIONS_OTHER,
    OPTION_SAMPLESAVAILABLEFOREVALUATIONOPTIONS_NO,
    OPTION_SAMPLESAVAILABLEFOREVALUATIONOPTIONS_YES,
    OPTION_EXPLICITLYREQUESTOPTIONS_NO,
    OPTION_EXPLICITLYREQUESTOPTIONS_UNKNOWN,
    OPTION_EXPLICITLYREQUESTOPTIONS_YES,
    OPTION_WEREPATIENTUSINGPRODUCTOPTIONS_NO,
    OPTION_WEREPATIENTUSINGPRODUCTOPTIONS_UNKNOWN,
    OPTION_WEREPATIENTUSINGPRODUCTOPTIONS_YES,
    OPTION_PATIENINVOLVEMENTOPTIONS_ASKED_UNKNOWN,
    OPTION_MEDIAAVAILABILITYDISTRIBUTOROPTIONS_ASKED_UNKNOWN,
    OPTION_CHAMBERDISCOLOREDOPTIONS_UNKNOWN,
    OPTION_MATTERFOREIGNMATERIALPIECESOPTIONS_UNKNOWN,
    OPTION_DAMAGEISSUEOBSERVEDOPTIONS_NO,
    OPTION_DAMAGEISSUEOBSERVEDOPTIONS_UNKNOWN,
    OPTION_SCENARIOSLEAKOPTIONS_UNKNOWN,
    OPTION_SCENARIOSLEAKOPTIONS_NONE_OF_THE_ABOVE,
    OPTION_MOISTURECLEAROPTIONS_NO_DESCRIBE_THE_COLOR,
    OPTION_EMBEDDEDPLASTICOPTIONS_UNKNOWN,
    OPTION_WHATTYPEDAMAGEISSUEOPTIONS_UNKNOWN,
    OPTION_TOOLUSEDASSISTOPTIONS_YES_SPECIFY_THE_TOOL,
    OPTION_SITUATIONSAPPLYEVENTOPTIONS_SEPARATION,
    OPTION_HANGERUSEDOPTIONS_UNKNOWN,
    OPTION_HANGERUSEDOPTIONS_NONE,
    OPTION_BAGLOWEROPTIONS_UNKNOWN,
    OPTION_ISSUESOBSERVEDCLAMPOPTIONS_YES_OTHER,
    OPTION_CLAMPISSUEEXPERIENCEDOPTIONS_UNKNOWN,
    OPTION_MATTERFOREIGNMATERIALPIECESOPTIONS_NO,
    OPTION_WEIGHTUNITOPTIONS_KILOGRAM,
    OPTION_WEIGHTUNITOPTIONS_POUND,
    OPTION_INFUSATESOLUTIONOPTIONS_NO,
    OPTION_INFUSATESOLUTIONOPTIONS_UNKNOWN,
    PLEASE_ENTER_THE_VALUE,
    PLEASE_SELECT_THE_VALUE,
    PLEASE_SELECT_THE_DATE,
    PLEASE_CHOOSE_THE_VALUE,
    OPTION_MEDIAAVAILABILITYOPTIONS_UNKNOWN,
    OPTION_COUNTRYOPTIONS_GREAT_BRITAIN,
    OPTION_COUNTRYOPTIONS_KOSOVO,
    OPTION_COUNTRYOPTIONS_NORTHERN_IRELAND,
    OPTION_COUNTRYOPTIONS_AFGHANISTAN,
    OPTION_COUNTRYOPTIONS_ÅLAND_ISLANDS,
    OPTION_COUNTRYOPTIONS_ALBANIA,
    OPTION_COUNTRYOPTIONS_ALGERIA,
    OPTION_COUNTRYOPTIONS_AMERICAN_SAMOA,
    OPTION_COUNTRYOPTIONS_ANDORRA,
    OPTION_COUNTRYOPTIONS_ANGOLA,
    OPTION_COUNTRYOPTIONS_ANGUILLA,
    OPTION_COUNTRYOPTIONS_ANTARCTICA,
    OPTION_COUNTRYOPTIONS_ANTIGUA_AND_BARBUDA,
    OPTION_COUNTRYOPTIONS_ARGENTINA,
    OPTION_COUNTRYOPTIONS_ARMENIA,
    OPTION_COUNTRYOPTIONS_ARUBA,
    OPTION_COUNTRYOPTIONS_AUSTRALIA,
    OPTION_COUNTRYOPTIONS_AUSTRIA,
    OPTION_COUNTRYOPTIONS_AZERBAIJAN,
    OPTION_COUNTRYOPTIONS_BAHAMAS,
    OPTION_COUNTRYOPTIONS_BAHRAIN,
    OPTION_COUNTRYOPTIONS_BANGLADESH,
    OPTION_COUNTRYOPTIONS_BARBADOS,
    OPTION_COUNTRYOPTIONS_BELARUS,
    OPTION_COUNTRYOPTIONS_BELGIUM,
    OPTION_COUNTRYOPTIONS_BELIZE,
    OPTION_COUNTRYOPTIONS_BENIN,
    OPTION_COUNTRYOPTIONS_BERMUDA,
    OPTION_COUNTRYOPTIONS_BHUTAN,
    OPTION_COUNTRYOPTIONS_BOLIVIA,
    OPTION_COUNTRYOPTIONS_BOSNIA_AND_HERZEGOVINA,
    OPTION_COUNTRYOPTIONS_BOTSWANA,
    OPTION_COUNTRYOPTIONS_BOUVET_ISLAND,
    OPTION_COUNTRYOPTIONS_BRAZIL,
    OPTION_COUNTRYOPTIONS_BRITISH_INDIAN_OCEAN_TERRITORY,
    OPTION_COUNTRYOPTIONS_BRUNEI_DARUSSALAM,
    OPTION_COUNTRYOPTIONS_BULGARIA,
    OPTION_COUNTRYOPTIONS_BURKINA_FASO,
    OPTION_COUNTRYOPTIONS_BURUNDI,
    OPTION_COUNTRYOPTIONS_CAMBODIA,
    OPTION_COUNTRYOPTIONS_CAMEROON,
    OPTION_COUNTRYOPTIONS_CANADA,
    OPTION_COUNTRYOPTIONS_CAPE_VERDE,
    OPTION_COUNTRYOPTIONS_CAYMAN_ISLANDS,
    OPTION_COUNTRYOPTIONS_CENTRAL_AFRICAN_REPUBLIC,
    OPTION_COUNTRYOPTIONS_CHAD,
    OPTION_COUNTRYOPTIONS_CHILE,
    OPTION_COUNTRYOPTIONS_CHINA,
    OPTION_COUNTRYOPTIONS_CHRISTMAS_ISLAND,
    OPTION_COUNTRYOPTIONS_COCOS_KEELING_ISLANDS,
    OPTION_COUNTRYOPTIONS_COLOMBIA,
    OPTION_COUNTRYOPTIONS_COMOROS,
    OPTION_COUNTRYOPTIONS_CONGO,
    OPTION_COUNTRYOPTIONS_CONGO_THE_DEMOCRATIC_REPUBLIC_OF_THE,
    OPTION_COUNTRYOPTIONS_COOK_ISLANDS,
    OPTION_COUNTRYOPTIONS_COSTA_RICA,
    OPTION_COUNTRYOPTIONS_CÔTE_DIVOIRE_IVORY_COAST,
    OPTION_COUNTRYOPTIONS_CROATIA,
    OPTION_COUNTRYOPTIONS_CUBA,
    OPTION_COUNTRYOPTIONS_CYPRUS,
    OPTION_COUNTRYOPTIONS_CZECH_REPUBLIC,
    OPTION_COUNTRYOPTIONS_DENMARK,
    OPTION_COUNTRYOPTIONS_DJIBOUTI,
    OPTION_COUNTRYOPTIONS_DOMINICA,
    OPTION_COUNTRYOPTIONS_DOMINICAN_REPUBLIC,
    OPTION_COUNTRYOPTIONS_ECUADOR,
    OPTION_COUNTRYOPTIONS_EGYPT,
    OPTION_COUNTRYOPTIONS_EL_SALVADOR,
    OPTION_COUNTRYOPTIONS_EQUATORIAL_GUINEA,
    OPTION_COUNTRYOPTIONS_ERITREA,
    OPTION_COUNTRYOPTIONS_ESTONIA,
    OPTION_COUNTRYOPTIONS_ETHIOPIA,
    OPTION_COUNTRYOPTIONS_FALKLAND_ISLANDS_MALVINAS,
    OPTION_COUNTRYOPTIONS_FAROE_ISLANDS,
    OPTION_COUNTRYOPTIONS_FIJI,
    OPTION_COUNTRYOPTIONS_FINLAND,
    OPTION_COUNTRYOPTIONS_FRANCE,
    OPTION_COUNTRYOPTIONS_FRENCH_GUIANA,
    OPTION_COUNTRYOPTIONS_FRENCH_POLYNESIA,
    OPTION_COUNTRYOPTIONS_FRENCH_SOUTHERN_TERRITORIES,
    OPTION_COUNTRYOPTIONS_GABON,
    OPTION_COUNTRYOPTIONS_GAMBIA,
    OPTION_COUNTRYOPTIONS_GEORGIA,
    OPTION_COUNTRYOPTIONS_GERMANY,
    OPTION_COUNTRYOPTIONS_GHANA,
    OPTION_COUNTRYOPTIONS_GIBRALTAR,
    OPTION_COUNTRYOPTIONS_GREECE,
    OPTION_COUNTRYOPTIONS_GREENLAND,
    OPTION_COUNTRYOPTIONS_GRENADA,
    OPTION_COUNTRYOPTIONS_GUADELOUPE,
    OPTION_COUNTRYOPTIONS_GUAM,
    OPTION_COUNTRYOPTIONS_GUATEMALA,
    OPTION_COUNTRYOPTIONS_GUERNSEY,
    OPTION_COUNTRYOPTIONS_GUINEA,
    OPTION_COUNTRYOPTIONS_GUINEA_BISSAU,
    OPTION_COUNTRYOPTIONS_GUYANA,
    OPTION_COUNTRYOPTIONS_HAITI,
    OPTION_COUNTRYOPTIONS_HEARD_ISLAND_AND_MCDONALD_ISLANDS,
    OPTION_COUNTRYOPTIONS_HOLY_SEE_VATICAN_CITY_STATE,
    OPTION_COUNTRYOPTIONS_HONDURAS,
    OPTION_COUNTRYOPTIONS_HONG_KONG,
    OPTION_COUNTRYOPTIONS_HUNGARY,
    OPTION_COUNTRYOPTIONS_ICELAND,
    OPTION_COUNTRYOPTIONS_INDIA,
    OPTION_COUNTRYOPTIONS_INDONESIA,
    OPTION_COUNTRYOPTIONS_IRAN_ISLAMIC_REPUBLIC_OF,
    OPTION_COUNTRYOPTIONS_IRAQ,
    OPTION_COUNTRYOPTIONS_IRELAND,
    OPTION_COUNTRYOPTIONS_ISLE_OF_MAN,
    OPTION_COUNTRYOPTIONS_ISRAEL,
    OPTION_COUNTRYOPTIONS_ITALY,
    OPTION_COUNTRYOPTIONS_JAMAICA,
    OPTION_COUNTRYOPTIONS_JAPAN,
    OPTION_COUNTRYOPTIONS_JERSEY,
    OPTION_COUNTRYOPTIONS_JORDAN,
    OPTION_COUNTRYOPTIONS_KAZAKHSTAN,
    OPTION_COUNTRYOPTIONS_KENYA,
    OPTION_COUNTRYOPTIONS_KIRIBATI,
    OPTION_COUNTRYOPTIONS_KOREA_DEMOCRATIC_PEOPLES_REPUBLIC_OF,
    OPTION_COUNTRYOPTIONS_KOREA_REPUBLIC_OF,
    OPTION_COUNTRYOPTIONS_KUWAIT,
    OPTION_COUNTRYOPTIONS_KYRGYZSTAN,
    OPTION_COUNTRYOPTIONS_LAO_PEOPLES_DEMOCRATIC_REPUBLIC,
    OPTION_COUNTRYOPTIONS_LATVIA,
    OPTION_COUNTRYOPTIONS_LEBANON,
    OPTION_COUNTRYOPTIONS_LESOTHO,
    OPTION_COUNTRYOPTIONS_LIBERIA,
    OPTION_COUNTRYOPTIONS_LIBYAN_ARAB_JAMAHIRIYA,
    OPTION_COUNTRYOPTIONS_LIECHTENSTEIN,
    OPTION_COUNTRYOPTIONS_LITHUANIA,
    OPTION_COUNTRYOPTIONS_LUXEMBOURG,
    OPTION_COUNTRYOPTIONS_MACAO,
    OPTION_COUNTRYOPTIONS_MACEDONIA_THE_FORMER_YUGOSLAV_REPUBLIC_OF,
    OPTION_COUNTRYOPTIONS_MADAGASCAR,
    OPTION_COUNTRYOPTIONS_MALAWI,
    OPTION_COUNTRYOPTIONS_MALAYSIA,
    OPTION_COUNTRYOPTIONS_MALDIVES,
    OPTION_COUNTRYOPTIONS_MALI,
    OPTION_COUNTRYOPTIONS_MALTA,
    OPTION_COUNTRYOPTIONS_MARSHALL_ISLANDS,
    OPTION_COUNTRYOPTIONS_MARTINIQUE,
    OPTION_COUNTRYOPTIONS_MAURITANIA,
    OPTION_COUNTRYOPTIONS_MAURITIUS,
    OPTION_COUNTRYOPTIONS_MAYOTTE,
    OPTION_COUNTRYOPTIONS_MEXICO,
    OPTION_COUNTRYOPTIONS_MICRONESIA_FEDERATED_STATES_OF,
    OPTION_COUNTRYOPTIONS_MOLDOVA,
    OPTION_COUNTRYOPTIONS_MONACO,
    OPTION_COUNTRYOPTIONS_MONGOLIA,
    OPTION_COUNTRYOPTIONS_MONTENEGRO,
    OPTION_COUNTRYOPTIONS_MONTSERRAT,
    OPTION_COUNTRYOPTIONS_MOROCCO,
    OPTION_COUNTRYOPTIONS_MOZAMBIQUE,
    OPTION_COUNTRYOPTIONS_MYANMAR,
    OPTION_COUNTRYOPTIONS_NAMIBIA,
    OPTION_COUNTRYOPTIONS_NAURU,
    OPTION_COUNTRYOPTIONS_NEPAL,
    OPTION_COUNTRYOPTIONS_NETHERLANDS,
    OPTION_COUNTRYOPTIONS_NEW_CALEDONIA,
    OPTION_COUNTRYOPTIONS_NEW_ZEALAND,
    OPTION_COUNTRYOPTIONS_NICARAGUA,
    OPTION_COUNTRYOPTIONS_NIGER,
    OPTION_COUNTRYOPTIONS_NIGERIA,
    OPTION_COUNTRYOPTIONS_NIUE,
    OPTION_COUNTRYOPTIONS_NORFOLK_ISLAND,
    OPTION_COUNTRYOPTIONS_NORTHERN_MARIANA_ISLANDS,
    OPTION_COUNTRYOPTIONS_NORWAY,
    OPTION_COUNTRYOPTIONS_OMAN,
    OPTION_COUNTRYOPTIONS_PAKISTAN,
    OPTION_COUNTRYOPTIONS_PALAU,
    OPTION_COUNTRYOPTIONS_PALESTINIAN_TERRITORY_OCCUPIED,
    OPTION_COUNTRYOPTIONS_PANAMA,
    OPTION_COUNTRYOPTIONS_PAPUA_NEW_GUINEA,
    OPTION_COUNTRYOPTIONS_PARAGUAY,
    OPTION_COUNTRYOPTIONS_PERU,
    OPTION_COUNTRYOPTIONS_PHILIPPINES,
    OPTION_COUNTRYOPTIONS_PITCAIRN,
    OPTION_COUNTRYOPTIONS_POLAND,
    OPTION_COUNTRYOPTIONS_PORTUGAL,
    OPTION_COUNTRYOPTIONS_PUERTO_RICO,
    OPTION_COUNTRYOPTIONS_QATAR,
    OPTION_COUNTRYOPTIONS_RÉUNION,
    OPTION_COUNTRYOPTIONS_ROMANIA,
    OPTION_COUNTRYOPTIONS_RUSSIAN_FEDERATION,
    OPTION_COUNTRYOPTIONS_RWANDA,
    OPTION_COUNTRYOPTIONS_SAINT_BARTHÉLEMY,
    OPTION_COUNTRYOPTIONS_SAINT_HELENA,
    OPTION_COUNTRYOPTIONS_SAINT_KITTS_AND_NEVIS,
    OPTION_COUNTRYOPTIONS_SAINT_LUCIA,
    OPTION_COUNTRYOPTIONS_SAINT_MARTIN,
    OPTION_COUNTRYOPTIONS_SAINT_PIERRE_AND_MIQUELON,
    OPTION_COUNTRYOPTIONS_SAINT_VINCENT_AND_THE_GRENADINES,
    OPTION_COUNTRYOPTIONS_SAMOA,
    OPTION_COUNTRYOPTIONS_SAN_MARINO,
    OPTION_COUNTRYOPTIONS_SAO_TOME_AND_PRINCIPE,
    OPTION_COUNTRYOPTIONS_SAUDI_ARABIA,
    OPTION_COUNTRYOPTIONS_SENEGAL,
    OPTION_COUNTRYOPTIONS_SERBIA,
    OPTION_COUNTRYOPTIONS_SEYCHELLES,
    OPTION_COUNTRYOPTIONS_SIERRA_LEONE,
    OPTION_COUNTRYOPTIONS_SINGAPORE,
    OPTION_COUNTRYOPTIONS_SLOVAKIA,
    OPTION_COUNTRYOPTIONS_SLOVENIA,
    OPTION_COUNTRYOPTIONS_SOLOMON_ISLANDS,
    OPTION_COUNTRYOPTIONS_SOMALIA,
    OPTION_COUNTRYOPTIONS_SOUTH_AFRICA,
    OPTION_COUNTRYOPTIONS_SOUTH_GEORGIA_AND_THE_SOUTH_SANDWICH_ISLANDS,
    OPTION_COUNTRYOPTIONS_SPAIN,
    OPTION_COUNTRYOPTIONS_SRI_LANKA,
    OPTION_COUNTRYOPTIONS_SUDAN,
    OPTION_COUNTRYOPTIONS_SURINAME,
    OPTION_COUNTRYOPTIONS_SVALBARD_AND_JAN_MAYEN,
    OPTION_COUNTRYOPTIONS_SWAZILAND,
    OPTION_COUNTRYOPTIONS_SWEDEN,
    OPTION_COUNTRYOPTIONS_SWITZERLAND,
    OPTION_COUNTRYOPTIONS_SYRIAN_ARAB_REPUBLIC,
    OPTION_COUNTRYOPTIONS_TAIWAN_ROC,
    OPTION_COUNTRYOPTIONS_TAJIKISTAN,
    OPTION_COUNTRYOPTIONS_TANZANIA_UNITED_REPUBLIC_OF,
    OPTION_COUNTRYOPTIONS_THAILAND,
    OPTION_COUNTRYOPTIONS_TIMOR_LESTE,
    OPTION_COUNTRYOPTIONS_TOGO,
    OPTION_COUNTRYOPTIONS_TOKELAU,
    OPTION_COUNTRYOPTIONS_TONGA,
    OPTION_COUNTRYOPTIONS_TRINIDAD_AND_TOBAGO,
    OPTION_COUNTRYOPTIONS_TUNISIA,
    OPTION_COUNTRYOPTIONS_TURKEY,
    OPTION_COUNTRYOPTIONS_TURKMENISTAN,
    OPTION_COUNTRYOPTIONS_TURKS_AND_CAICOS_ISLANDS,
    OPTION_COUNTRYOPTIONS_TUVALU,
    OPTION_COUNTRYOPTIONS_UGANDA,
    OPTION_COUNTRYOPTIONS_UKRAINE,
    OPTION_COUNTRYOPTIONS_UNITED_ARAB_EMIRATES,
    OPTION_COUNTRYOPTIONS_UNITED_KINGDOM,
    OPTION_COUNTRYOPTIONS_UNITED_STATES,
    OPTION_COUNTRYOPTIONS_UNITED_STATES_MINOR_OUTLYING_ISLANDS,
    OPTION_COUNTRYOPTIONS_URUGUAY,
    OPTION_COUNTRYOPTIONS_UZBEKISTAN,
    OPTION_COUNTRYOPTIONS_VANUATU,
    OPTION_COUNTRYOPTIONS_VENEZUELA,
    OPTION_COUNTRYOPTIONS_VIET_NAM,
    OPTION_COUNTRYOPTIONS_VIRGIN_ISLANDS_BRITISH,
    OPTION_COUNTRYOPTIONS_VIRGIN_ISLANDS_US,
    OPTION_COUNTRYOPTIONS_WALLIS_AND_FUTUNA,
    OPTION_COUNTRYOPTIONS_WESTERN_SAHARA,
    OPTION_COUNTRYOPTIONS_YEMEN,
    OPTION_COUNTRYOPTIONS_ZAMBIA,
    OPTION_COUNTRYOPTIONS_ZIMBABWE,
    LANDING_TERMS_I_HAVE_READ,
    LANDING_TERMS_THE_USE_DISCLOSURE,
    LANDING_TERMS_THE_TRANSFER_OF,
    LANDING_TERMS_I_UNDERSTAND_THAT,
    OPTION_DOESTHEPARTICULATEMATTER_NO,
    OPTION_DOESTHEPARTICULATEMATTER_UNKNOWN,
    OPTION_DOESTHEPARTICULATEMATTER_YES,
    I_HAVE_READ_AND_UNDERSTAND_THE_LINKED_PRIVACY_NOTICE,
    PRODUCT_LOT,
    SHIPPING_DISTRIBUTION_LABEL,
    CARTON_LABEL,
    INTERNAL_PRODUCT_LABEL,
    TITLE_PD_RENAL,
    TITLE_SOLUTIONS,
    TITLE_ACCESS,
    TITLE_ALL_OTHER_PRODUCT,
    REPORTED_PROBLEM,
    LOGIN,
    SYSTEM_MENU,
    INITIATE_PRODUCT_FEEDBACK,
    FEEDBACK_STATUS,
    OKTACALLBACK,
    VALID_EMAIL,
    VALID_NUMERIC,
    PLEASE_UPLOAD_IMAGE,
    VALID_DATE,
    QUANTITY,
    EDIT,
    DELETE,
    LOT_SERIAL_NO,
    LOT_NUMBER_NOT_FOUND,
    SEARCHING_LOT_NUMBER,
    PRODUCT_CODE_NOT_FOUND,
    SEARCHING_PRODUCT_CODE,
    FILE_OF_TYPES_ARE_NOT_ALLOWED,
    THE_FILE_YOU_ARE_ATTEMPTING,
    IMAGE_ICON,
    LOGIN_TO_ACCOUNT,
    SIGN_IN_TO_YOUR_ACCOUNT,
    PASSWORD,
    SIGN_IN,
    UNKNOWN,
    ASKED_UNKNOWN,
    DD_MMM_YYYY,
    DD,
    MMM,
    YYYY,
    SELECT_COUNTRY,
    CHINESE_SIMPLIFIED_CHINESE,
    DUTCH,
    ENGLISH,
    FRENCH,
    GERMAN,
    ITALIAN,
    JAPANESE,
    KOREAN,
    MANDARIN_TRADITIONAL_CHINESE,
    POLISH,
    PORTUGUESE,
    SPANISH,
    THAI,
    TURKISH,
    VIETNAMESE,
    BROWSE,
    FEEDBACK_SUBMITTED,
    YOUR_PRODUCT_EXPERIENCE_FEEDBACK,
    IF_YOU_HAVE_QUESTIONS_OR_ADDITIONAL_INFORMATION,
    CLOSE,
    PATIENT_AGE,
    ENTER_AGE,
    PATIENT_DOB,
    RELEVANT_ATTACHMENTS,
    VANTIVE_ACCOUNT_CREDENTIALS,
    GET_PRODUCT_DETAILS,
    USE_THE_DIAGRAM_ABOVE_FIGURE_2,
    FACILITY_ADDRESS,
    LABEL_ANOTHER_FACILITY_ADDRESS,
    CHOOSE_PRODUCT_CODE,
    PRIVACY_NOTICE,
    DECLINE,
    OPTION_COUNTRYOPTIONS_BONAIRE_SINT_EUSTATIUS_AND_SABA,
    OPTION_COUNTRYOPTIONS_CURAÇAO,
    OPTION_COUNTRYOPTIONS_SOUTH_SUDAN,
    OPTION_COUNTRYOPTIONS_ESWATINI,
    FORM_HELP_TEXT,
    YOUR_FIRST_NAME,
    YOUR_LAST_NAME,
    MY_FIRST_NAME,
    MY_LAST_NAME,
    PATIENT_FIRST_NAME,
    PATIENT_LAST_NAME,
    REPORTER_FIRST_NAME,
    REPORTER_LAST_NAME,
    EMPLOYEE_FIRST_NAME,
    EMPLOYEE_LAST_NAME,
    END_USER_CUSTOMER_FIRST_NAME,
    END_USER_CUSTOMER_LAST_NAME,
    ADDITIONAL_CONTACT_FIRST_NAME,
    ADDITIONAL_CONTACT_LAST_NAME,
    COPYRIGHT_VANTIVE,
    COPYRIGHT_VERSION,
    ADD_ADDITIONAL_CONTACT,
    CONTACT_ME,
    DO_NOT_CONTACT,
    END_USER_CUSTOMER_FACILITY_NAME,
    END_USER_CUSTOMER_PHONE,
    END_USER_CUSTOMER_EMAIL,
    END_USER_CUSTOMER_FACILITY_ADDRESS,
    SAME_AS_PATIENT_ADDRESS,
    SAME_AS_REPORTER_ADDRESS,
    SAME_AS_END_USER_CUSTOMER_ADDRESS,
    USE_THE_DIAGRAM_ABOVE_FIGURE_3,
    CONTACT_US,
    LANDING_BRIEF_FOR_DEVICE,
    PATIENT_SEX,
    OPTION_PATIENTGENDEROPTIONS_CISGENDER_CISGENDER_MAN_BOY,
    OPTION_PATIENTGENDEROPTIONS_CISGENDER_CISGENDER_WOMAN_GIRL,
    OPTION_PATIENTGENDEROPTIONS_CISGENDER_TRANSGENDER_MAN_TRANS_MAN_FEMALE_TO_MALE_FTM,
    OPTION_PATIENTGENDEROPTIONS_CISGENDER_TRANSGENDER_WOMAN_TRANS_WOMAN_MALE_TO_FEMALE_MTF,
    OPTION_PATIENTGENDEROPTIONS_CISGENDER_OTHER_GENDER_CATEGORY_PLEASE_SPECIFY,
    OPTION_PATIENTGENDEROPTIONS_CISGENDER_DECLINE_TO_ANSWER,
    ATTENTION_NEEDED,
    SUBMIT_ERR_MSG,
    SUBMIT_RETRY_MSG,
    OK,
} from '@translations';

let lang: any = {};
let translations: any = {};
lang.translations = translations;

translations[APP_TITLE] = "Portail Retour d'Expérience Produit";
translations[LANDING_BRIEF] = "Le Portail Retour d'Expérience Produit est destiné à collecter des informations confidentielles et des commentaires sur les produits Vantive.";
translations[LANDING_LANGUAGE_SELECTOR] = "Sélectionner vos préférences linguistiques";
translations[LANDING_COUNTRY_SELECTOR] = "Sélectionner le pays de survenue l'événement";
translations[LANDING_TERMS] = "J'ai lu et j'accepte les conditions d'utilisation et la déclaration de confidentialité du Portail Retour d'Expérience Produit.";
translations[LANDING_TERMS_ERROR] = "Vous devez lire et accepter le contenu des Conditions d'utilisation, de la Déclaration de confidentialité et de la Conditions d'utilisation supplémentaires et de la déclaration de confidentialité du Portail Retour d'Expérience Produit.";
translations[LANDING_CAPTCHA_ERROR] = "Veuillez vérifier que vous n'êtes pas un robot.";
translations[APP_DESCRIPTION] = "Le Portail Retour d'Expérience Produit est destiné à la soumission d'informations sur les produits Vantive. Si vous avez rencontré un problème avec un produit Vantive, nous vous encourageons à partager les détails de cet événement. Vos commentaires sont essentiels afin de nous permettre d'atteindre notre objectif d'amélioration continue et la satisfaction des utilisateurs.";
translations[LANDING_TERMS_I_HAVE_READ] = "J'ai lu l'avis de confidentialité lié au Portail Retour d'Expérience Produit Vantive et je comprends queVantive Healthcare Corporation (« Vantive ») sollicite mon consentement pour utiliser, divulguer et traiter mes données personnelles aux fins et telles que décrites dans la Politique de confidentialité. Je consens par la présente à :";
translations[LANDING_TERMS_THE_USE_DISCLOSURE] = "L'utilisation, la divulgation, le stockage et le traitement de mes données personnelles (y compris toutes les données sensibles, telles que les données relatives à la santé, que je choisis de fournir) aux fins décrites dans la déclaration de confidentialité.";
translations[LANDING_TERMS_THE_TRANSFER_OF] = "Le transfert de mes données personnelles (y compris les données sensibles, telles que les données relatives à la santé, que je choisis de fournir) hors de mon pays vers un autre pays qui peut avoir des lois moins strictes, voire aucune, sur la protection des données.";
translations[LANDING_TERMS_I_UNDERSTAND_THAT] = "Je comprends que ce consentement est volontaire et que je peux changer d'avis à tout moment et révoquer mon consentement en contactant Vantive en utilisant les coordonnées fournies dans l'avis de confidentialité. Je comprends que le retrait de mon consentement n'affectera pas la licéité du traitement effectué avant son retrait.";
translations[MENU_FEEDBACK_FORM] = "Commencer la soumission du retour d'expérience";
translations[MENU_FEEDBACK_STATUS] = "Vérifier l'état du retour d'expérience";
translations[MENU_FORM_INTAKE] = "Reporter/Coordonnées";
translations[MENU_FORM_EVENT_DETAILS] = "Détails de l'événement";
translations[MENU_FORM_PRODUCT_INFO] = "Informations sur le produit";
translations[SYSTEM_FEEDBACK_FORM] = "Commencer à remplir  le formulaire de retour d'expérience";
translations[SYSTEM_FEEDBACK_STATUS] = "Vérifier l'état du retour d'expérience";
translations[SUBMIT_FEEDBACK] = "Cliquez ici pour soumettre vos commentaires.";
translations[CHECK_SUBMITTED_FEEDBACK] = "Cliquez ici pour vérifier l'état de votre retour d'expérience précédemment soumis.";
translations[BTN_LAUNCH_FORM] = "Commencer le formulaire";
translations[BTN_CHECK_STATUS] = "Vérifier le statut";
translations[FORM_TITLE] = "Questionnaire Retour d'Expérience Produit";
translations[FORM_SUB_TITLE] = "Si plusieurs patients sont affectés, veuillez s'il-vous-plaît remplir une forme/un questionnaire par patient.";
translations[FORM_MANDATORY_FIELDS] = "Tous les champs avec * sont obligatoires";
translations[BUTTON_PREV] = "Précédent";
translations[BUTTON_NEXT] = "Suivant";
translations[BUTTON_SUBMIT] = "Soumettre";
translations[SELECT_RESPONSE] = "Sélectionner une réponse";
translations[FUNCTION_ROLE] = "Fonction/Rôle";
translations[CUSTOMER_ACCOUNT_NUMBER] = "Numéro de compte client";
translations[ENTER_CUSTOMER_ACCOUNT] = "Saisir un compte client";
translations[HELP_CUSTOMER_ACCOUNT_NUMBER] = "Quel est le numéro de compte du client impliqué dans l'événement signalé ?";
translations[EVENT_REPORTED] = "Cet événement a-t-il déjà été signalé (à Vantive ou à toute autre entité) ?";
translations[REFERENCE_NUMBER] = "Numéro de référence associé à cet événement";
translations[ENTER_REFERENCE] = "Saisir la référence";
translations[WHO_REPORTED_TO] = "À qui cela a-t-il été signalé ?";
translations[WHO_WAS_NOTIFIED] = "Indiquez le nom de qui a été notifié ?";
translations[ENTER_NAME] = "Entrer le nom";
translations[YOUR_NAME] = "Votre nom";
translations[OCCUPATION] = "Profession";
translations[PHONE_NUMBER] = "Numéro de téléphone";
translations[ENTER_PHONE_NUMBER] = "Entrer le numéro de téléphone";
translations[ENTER_EMAIL] = "Saisir un e-mail";
translations[EMAIL_ADDRESS] = "Adresse e-mail";
translations[ENTER_ADDRESS] = "Saisir une adresse e-mail";
translations[ENTER_NA_IF_UNKNOWN] = "Entrez NA si elle est inconnue";
translations[FACILITY_HOSPITAL] = "Nom de l'établissement/de l'hôpital ou du distributeur (le cas échéant)";
translations[ENTER_FACILITY] = "Entrer le nom de l'établissement";
translations[ADDRESS_1] = "Adresse (début)";
translations[ADDRESS_2] = "Adresse (suite)";
translations[CITY] = "Localité";
translations[STATE] = "Etat/Region";
translations[POSTAL_CODE] = "Code postal";
translations[COUNTRY] = "Pays";
translations[END_USER_CUSTOMER] = "Ce problème a-t-il été découvert par un utilisateur final/client ?";
translations[ADDITIONAL_CONTACT_PERSON] = "Personne de contact de l'établissement additionel";
translations[ADDITIONAL_PHONE] = "Numéro de téléphone du contact de l'établissement additionel";
translations[ADDITIONAL_EMAIL] = "E-mail de l'établissement additionnel";
translations[ANOTHER_FACILITY_ADDRESS] = "Ajouter un autre établissement/adresse";
translations[ANOTHER_FACILITY_HOSPITAL] = "Nom d'établissement, hôpital ou distributeur additionnel (le cas échéant)";
translations[ANOTHER_ENTER_FACILITY] = "Entrer le nom de l'établissement";
translations[ANOTHER_ADDRESS_1] = "Adresse (début)";
translations[ANOTHER_ADDRESS_2] = "Adresse (suite)";
translations[ANOTHER_CITY] = "Localité";
translations[ANOTHER_STATE] = "Etat/Region";
translations[ANOTHER_POSTAL_CODE] = "Code postal";
translations[ANOTHER_COUNTRY] = "Pays";
translations[LOT_SERIAL_NUMBER] = "Numéro de lot / Numéro de série";
translations[ENTER_LOT_SERIAL_NUMBER] = "Entrer le numéro de lot ou le numéro de série";
translations[HELP_LOT_SERIAL_NUMBER] = "Sélectionnez 'Inconnu' si vous ne connaissez pas le numéro de lot ou le numéro de série ou si vous avez demandé à l'utilisateur et qu'il ne le savait pas.";
translations[OPTION_WHATINCORRECTLYDISPLAYEDOPTIONS_PRODUCT_CODE] = "Code produit";
translations[PRODUCT_CODE] = "Code produit";
translations[ENTER_PRODUCT_CODE] = "Saisir le code produit";
translations[HELP_PRODUCT_CODE] = "Sélectionnez 'Inconnu' si vous ne connaissez pas le code produit ou si vous avez demandé à l'utilisateur et qu'il ne le savait pas.";
translations[NDC] = "Numéro du Code national des médicaments (NDC)";
translations[ENTER_NDC] = "Entrer NDC (Code National du Médicament)";
translations[UDI] = "Identificateur de périphérique unique (UDI)";
translations[ENTER_UDI] = "Saisir UDI (Identification Unique du Dispositif médical)";
translations[PRODUCT_NAME] = "Nom du produit";
translations[ENTER_PRODUCT_NAME] = "Saisir le nom du produit";
translations[HELP_PRODUCT_NAME] = "Indiquez le nom ou une description du produit";
translations[BEST_DESCRIBES] = "Veuillez faire une sélection qui décrit le mieux le problème signalé";
translations[QUANTITY_TO_SELECT] = "Quantité à sélectionner";
translations[ENTER_QUANTITY] = "Saisir la quantité";
translations[HELP_QUANTITY] = "Nombre de produits présentant le problème signalé";
translations[UNIT] = "Unité";
translations[AVAILABLE_TO_RETURNED] = "Le produit présentant le problème signalé peut-il être retourné à Vantive pour évaluation ?";
translations[PHOTOGRAPH_AVAILABLE] = "Une photo ou une vidéo du produit est-elle disponible ?";
translations[HELP_PHOTOGRAPH_AVAILABLE] = "Assurez-vous que le problème signalé est visible sur la photo ou la vidéo.";
translations[UPLOAD_IMAGES] = "Télécharger des photographies/vidéos";
translations[REPORTER_NAME] = "Nom du contact";
translations[REPORTER_FACILITY] = "Etablissement du contact";
translations[REPORTER_OCCUPATION] = "Profession du contact";
translations[ENTER_NUMBER] = "Entrer le numéro";
translations[REPORTER_PHONE_NUMBER] = "Numéro de téléphone du contact";
translations[REPORTER_EMAIL_ADDRESS] = "Adresse e-mail du contact";
translations[EMPLOYEE_NAME] = "Nom de l'employé";
translations[EMPLOYEE_PHONE_NUMBER] = "Numéro de téléphone de l'employé";
translations[EMPLOYEE_EMAIL_ADDRESS] = "Adresse e-mail de l'employé";
translations[RETURNING_FOR_INVESTIGATION] = "Combien d'échantillons (en unités) avec le problème signalé retournez-vous pour enquête ?";
translations[HELP_RETURNING_FOR_INVESTIGATION] = "Ces échantillons doivent présenter le problème signalé.";
translations[UNUSED_VANTIVE_PRODUCT] = "Y a-t-il un produit Vantive non utilisé du même lot disponible pour être retourné à Vantive pour évaluation ?";
translations[YOU_INDICATED_SAMPLES] = "Vous avez indiqué que des échantillons étaient disponibles pour évaluation, pouvez-vous les apporter à votre fournisseur de soins de santé ?";
translations[SAMPLE_RETURN_KIT] = "Vous avez indiqué que des échantillons étaient disponibles pour évaluation, veuillez confirmer l'adresse à laquelle le kit de retour peut être livré :";
translations[A_BOX_WITH_A_PREPAID_LABEL] = "Une boîte avec une étiquette prépayée sera envoyée à cette adresse pour retourner l'échantillon";
translations[SAME_AS_MY_ADDRESS] = "Identique à mon adresse";
translations[OTHER_CONTACT_NAME] = "Nom de l'autre contact";
translations[OTHER_CONTACT_OCCUPATION] = "Profession de l'autre contact";
translations[OTHER_CONTACT_PHONE_NUMBER] = "Numéro de téléphone de l'autre contact";
translations[OTHER_CONTACT_EMAIL_ADDRESS] = "Adresse e-mail de l'autre contact";
translations[MANUFACTURED_BY_ANOTHER_COMPANY] = "Le produit que vous avez sélectionné est fabriqué par une autre entreprise. Pouvons-nous leur fournir vos coordonnées s'ils ont des questions supplémentaires concernant votre rapport ?";
translations[CUSTOMER_EXPLICITLY_REQUEST] = "Le client a-t-il explicitement demandé les résultats de l'enquête ?";
translations[EXPLICITLY_REQUEST_CREDIT] = "Le client a-t-il explicitement demandé un crédit ?";
translations[PRODUCT_FROM_VANTIVE] = "Le client commande-t-il directement le produit auprès de Vantive ?";
translations[QUANTITY_REQUESTED_CREDIT] = "Numéro (s) de lot et quantité demandées pour crédit :";
translations[ENTER_OCCUPATION] = "Entrer la profession";
translations[LOT_QUANTITY_NUMBER] = "Entrer le numéro de lot et la quantité";
translations[WHOLESALERS_NAME] = "Quel est le nom et la localisation du grossiste ou revendeur (ville, département/région) ";
translations[PLACE_WHOLESALERS_NAME] = "Quel est le nom et la localisation du grossiste ou revendeur (ville, département/région) ";
translations[ADD_PRODUCT_TO_THE_GRID] = "Ajouter un produit au tableur";
translations[SAVE] = "Enregistrer";
translations[CANCEL] = "Annuler";
translations[ADD_MORE_PRODUCTS] = "Ajouter des produits";
translations[REPORTER_ADDRESS] = "Adresse du  contact";
translations[ATTACHMENTS] = "Pièces jointes";
translations[DATE_OF_EVENT] = "Date de survenue de l'événement";
translations[DATE_OF_EVENT_MSG] = "La date de l'événement ne peut pas être postérieure à la date de la première notification de l'employé Vantive. Veuillez entrer une date valide.";
translations[HELP_DATE_OF_EVENT] = "S'il y a plusieurs dates connues de survenue de l'événement, veuillez remplir un formulaire pour chaque date.";
translations[DATE_VANTIVE_EMPLOYEE] = "Date de la première notification à un employé Vantive";
translations[DURING_WHAT_PROCESS] = "Au cours de quelle étape de l'utilisation l'événement s'est-il produit ?";
translations[WAS_THE_PATIENT] = "Le patient était-il connecté (traitement en cours) au moment de l'événement ?";
translations[WERE_YOU_CONNECTED] = "Etiez-vous connecté (traitement en cours) au moment de l'évènement?";
translations[PROVIDE_ANY_ADDITIONAL] = "Veuillez fournir tous les détails supplémentaires liés à l'événement/problème rapporté";
translations[HELP_YOU_IDENTIFIED_MORE] = "Vous avez identifié plus d'un produit et un problème, veuillez préciser quels produits ont rencontré quels problèmes signalés.";
translations[ENTER_DETAILS] = "Entrer les détails";
translations[PROVIDE_ANY_ATTACHMENT] = "Télécharger vos documents/fichiers (le cas échéant)";
translations[WAS_NEGATIVE_MEDICAL] = "L'événement a-t-il eu un impact médical négatif sur le patient et/ou l'utilisateur?";
translations[WAS_MEDICAL_INTERVENTION] = "Un traitement particulier ou une intervention médicale ont-ils pris place suite à l'événement signalé ?";
translations[PROVIDE_DETAILS] = "Fournir des détails";
translations[REQUIRED_TREATMENT] = "Traitement et intervention médicale requis";
translations[ENTER_TREATMENT] = "Spécifier le traitement ";
translations[RELEVANT_TESTS] = "Tests pertinents, y compris les données de laboratoire :";
translations[HELP_RELEVANT_TESTS] = "Saisisser les tests pertinents et les résultats de ceux-ci";
translations[RELEVANT_MEDICAL_HISTORY] = "Antécédents médicaux pertinents, y compris les conditions médicales préexistantes :";
translations[ENTER_HISTORY] = "Entrer l'historique médical du patient (si pertinent)";
translations[PATIENT_NAME] = "Nom du patient";
translations[PATIENT_INITIALS] = "Initiales du patient ou nom complet. Si plusieurs patients sont affectés, veuillez s'il-vous-plaît remplir une forme/un questionnaire par patient.";
translations[PATIENT_PHONE_NUMBER] = "Numéro de téléphone du patient";
translations[I_DO_NOT_WISH_TO_PROVIDE] = "Je ne souhaite pas répondre.";
translations[PATIENT_EMAIL_ADDRESS] = "Adresse e-mail du patient";
translations[PATIENT_ADDRESS] = "Adresse du patient";
translations[SAME_ADDRESS] = "Adresse identique";
translations[DRUG_BEING_USED] = "Est-ce qu'un médicament Vantive était utilisé au moment de l'événement ?";
translations[PATIENT_IDENTIFIER] = "Identifiant patient";
translations[PATIENT_AGE_OR_DOB] = "Âge du patient ou date de naissance";
translations[ENTER_PATIENT_AGE] = "mm/jj/aaaa, entrez l'âge du patient";
translations[PATIENT_GENDER] = "Genre du patient";
translations[PATIENT_WEIGHT] = "Poids du patient";
translations[ENTER_WEIGHT] = "Entrer le poids";
translations[PATIENT_WEIGHT_UNIT] = "Unité de poids du patient";
translations[MY_NAME] = "Mon nom";
translations[ENTER_IN_YOUR_CONTACT] = "Saisissez vos coordonnées";
translations[MY_PHONE_NUMBER] = "Mon numéro de téléphone";
translations[MY_EMAIL_ADDRESS] = "Mon adresse e-mail";
translations[MY_ADDRESS] = "Mon adresse";
translations[NAME_OF_VANTIVE_DRUG] = "Nom du médicament Vantive";
translations[ENTER_DRUG_NAME] = "Entrer le nom du médicament";
translations[PLEASE_PROVIDE_THE_NAME] = "Veuillez fournir le nom ou le code produit du médicament Vantive. Indiquez le nom de tous les médicaments Vantive utilisés au moment du problème signalé.";
translations[SELECT_THE_COMPONENT] = "Sélectionnez le composant ayant rencontré le problème";
translations[USE_THE_DIAGRAM] = "Utilisez le diagramme ci-dessus (Figure 1) pour déterminer l'emplacement du défaut sur le dispositif.";
translations[TYPE_OF_DAMAGE] = "Veuillez décrire le type de dommage/déterioration";
translations[PLEASE_ENTER_VALUE] = "Veuillez saisir la valeur";
translations[WAS_THE_PRODUCT_KINKED] = "Le produit a-t-il été plié, fissuré, coupé, etc. ?";
translations[WERE_ANY_CLEANING] = "Des solutions de nettoyage, des solvants ou des désinfectants ont-ils été utilisés sur le produit ?";
translations[WHAT_WAS_THE_DISINFECTANT] = "Quel était le nom/la marque du désinfectant et comment a-t-il été utilisé ?";
translations[NOTE_VANTIVE_LABELING] = "Les instructions d'utilisation Vantive indiquent de ne pas appliquer d'eau de Javel, de peroxyde d'hydrogène, d'alcool ou d'antiseptique contenant de l'aclool sur le dispositif. L'utilisation de ces produits peut provoquer des fissures du produit.";
translations[SELECT_ALL_THAT_APPLY] = "Sélectionnez toutes les options qui s'appliquent";
translations[DID_FOLLOWING_OCCUR] = "L'un des événements suivants s'est-il produit ?";
translations[SELECT_THE_LOCATION] = "Sélectionnez l'emplacement avec les dégâts sur la Minicap";
translations[WAS_THE_PRODUCT_EXPOSED] = "Le produit a-t-il été exposé à une force excessive (c'est-à-dire cogné, heurté, tombé, etc.) avant que le problème ne se produise ?";
translations[HOW_LONG_TRANSFER] = "Depuis combien de temps le transfert est-il utilisé ?";
translations[WAS_THERE_DIFFICULTY] = "Y a-t-il eu des difficultés lors de l'ouverture ou de la fermeture du dispositif de serrage ?";
translations[WAS_DEVICE_OR_TOOL] = "Un appareil ou un outil a-t-il été utilisé pour ouvrir ou fermer le dispositif de serrage ?";
translations[DESCRIBE_HOW_PRODUCT] = "Décrivez comment le produit a été difficile à utiliser (sélectionnez toutes les options qui s'appliquent)";
translations[DID_YOU_OBSERVE] = "Avez-vous observé des dommages (p. ex. coupure, trou, fissure) ?";
translations[WERE_DIFFICULTIES_PUTTING] = "Y a-t-il eu des difficultés à mettre le Minicap sur le transfert set et à le tordre dans le sens des aiguilles d'une montre jusqu'à ce qu'il soit fermement fixé ?";
translations[WAS_THE_TRANSFER] = "Le transfert set a-t-il été remplacé à cause de cet événement ?";
translations[SELECT_TYPE_OF_FLOW] = "Sélectionner le type de problème de flux";
translations[WAS_ANYTHING_BLOCKING] = "Y a-t-il eu quelque chose qui bloquait le flux ?";
translations[WAS_ANY_ALARM] = "Y a-t-il eu une alarme ?";
translations[SELECT_BEST_DESCRIBE] = "Sélectionnez l'option qui décrit le mieux le problème";
translations[WERE_THE_MINICAPS] = "Les Minicaps ont-ils été exposés ou stockés dans un environnement chaud/froid ?";
translations[WAS_THE_SPONGE_VISIBLE] = "L'éponge était-elle visible à l'intérieur du Minicap ?";
translations[WHERE_PARTICULATE_MATTERFOREIGN] = "Où se trouvent les particules/matières étrangères ?";
translations[DESCRIBE_THE_EXACT_LOCATION] = "Décrivez l'emplacement exact, la taille, la forme et la couleur de la particule ou de la matière étrangère :";
translations[WAS_THE_PARTICULATE_MATTER] = "Les particules et/ou les matières étrangères ont-elles été incorporées dans le produit ?";
translations[DOES_THE_PARTICULATE_MATER] = "La particule ou la matière étrangère semble-t-elle être des morceaux du matériau du produit ?";
translations[WHAT_COMPONENT_DOES] = "De quel composant la particule semble-t-elle provenir ?";
translations[SELECT_CONNECTION_ISSUE] = "Sélectionnez l'option qui décrit le mieux le problème de connexion";
translations[WERE_ASSIST_DEVICES] = "Des dispositifs ou des outils tierces ont-ils été utilisés pour réaliser la connexion ?";
translations[WERE_ANY_DIFFICULTIES] = "Des difficultés ont-elles été remarquées au cours de la connexion initiale ou de la déconnexion ?";
translations[PROVIDE_PRODUCT_INFORMATION] = "Veuillez fournir les informations concernant le second produit impliqué dans le problème de connexion";
translations[WERE_THE_SPIKE_LUER] = "Les connecteurs Spike/Luer ont-ils tourné dans le sens des aiguilles d'une montre jusqu'à ce qu'ils soient fermement fixés ?";
translations[VANTIVE_LABELING_STATES] = "Les instructions d'utilisation Vantive mentionne la nécessité de s'assurer que toutes les connexions du dispositif sont sécurisées et ajustées avant de commencer le traitement.";
translations[WERE_PETS_OR_ANIMALS] = "Y a-t-il des animaux de compagnie qui auraient pu endomager le dispositif ?";
translations[VANTIVE_LABELING_CONTAMINATION] = "Les instructions d'utilisation Vantive indiquent qu'une contamination des lignes peut se produire si un animal mord les dispositifs. Pour réduire ce risque, n'effectuez pas de dialyse dans la même pièce que des animaux domestiques.";
translations[WERE_OTHER_ISSUES] = "Y a-t-il eu d'autres problèmes ou difficultés associés à la connectique (c.-à-d. fissuré, déformé, plié, etc.) ?";
translations[WAS_MINICAP_TWISTED] = "Le Minicap a-t-il été inséré dans le sens des aiguilles d'une montre sur le connecteur du transfert set jusqu'à ce qu'il soit fermement fixé ?";
translations[WERE_DIFFICULTIES_TRANSFER_SET] = "Y a-t-il eu des difficultés à mettre le Minicap sur le transfert set?";
translations[DID_TRANSFER_SET_CONNECTORS] = "Les connecteurs du transfert set ont-ils subi des dommages ou des résidus sont-ils visibles au niveau du filetage ?";
translations[WHAT_WAS_THE_ALARM] = "Quelle a été l'alarme ?";
translations[WHERE_OBSERVED_DAMAGE] = "Où ont été les dommages observés (sélectionnez tout ce qui s'applique) ?";
translations[SELECT_THE_TYPE_OBSERVED] = "Sélectionnez le type de dommage observé (sélectionnez tous les éléments qui s'appliquent) :";
translations[DID_DAMAGE_CAUSE_LEAK] = "Les dommages ont-ils causé une fuite ?";
translations[WAS_THE_SHIPPING_CARTON] = "Le carton d'expédition a-t-il été ouvert avec un objet tranchant ?";
translations[SELECT_FLOW_ISSUE_OBSERVED] = "Sélectionner le type de problème d'écoulement observé";
translations[HOW_LONG_WAS_STORAGE] = "Combien de temps le produit a-t-il été conservé avant qu'il ne soit identifié comme exprié ?";
translations[WAS_THERE_AN_ADAPTER] = "Y a-t-il eu un adaptateur, ou tout autre accessoire utilisé avec le produit ?";
translations[NAME_AND_MODEL] = "Quel est le nom et le modèle de l'adaptateur ou de tout autre appareil utilisé ?";
translations[NAME_VAPORIZER] = "Quel est le nom et le modèle du vaporisateur ?";
translations[WAS_VIAL_INVERTED] = "Le flacon attaché a-t-il été inversé avant de presser la solution dans le flacon ?";
translations[WHAT_VIAL_USED] = "Quelles sont les informations sur le produit du flacon utilisé ?";
translations[DRUG_NAME_MANUFACTURER] = "Nom du médicament, fabricant, taille du flacon";
translations[WERE_BREAK_FRANGIBLE] = "Avez-vous réussi à briser correctement le frangible à l'aide d'un mouvement de va-et-vient ?";
translations[WAS_ALARM_ASSOCIATED] = "Y a-t-il eu une alarme associée à l'absence d'écoulement ?";
translations[WHAT_PART_DISCOLORED] = "Quelle partie du produit est décolorée ? (sélectionnez toutes les options qui s'appliquent)";
translations[DESCRIBE_DISCOLORATION] = "Décrivez la décoloration (décrivez la couleur, la teinte, etc.) :";
translations[HOW_PRODUCT_STORED] = "Comment le produit a-t-il été stocké ?";
translations[DOES_DISCOLORATION_APPEAR] = "La décoloration semble-t-elle être opaque, trouble et/ou présente des marques circulaires/hexagonales ?";
translations[WHICH_CHAMBER_DISCOLORED] = "Quel compartiment de la poche a été décoloré ?";
translations[WAS_PEEL_SEAL_INTERCHAMBER] = "Le joint d'étanchéité ou le frangible inter-chambres était-il déjà cassé/activé ?";
translations[WAS_DISCOLORATION_NOTICED] = "La décoloration a-t-elle été remarquée à travers la vitre du vaporisateur ?";
translations[SELECT_SPECIFICALLY_DESCRIBES] = "Sélectionnez l'option qui décrit le plus précisément le problème :";
translations[WHAT_DEVICE_HAD_ALARM] = "Quel appareil a généré l'alarme ?";
translations[WHAT_MISSING_MISASSEMBLED] = "Quel composant était manquant ou mal assemblé ?";
translations[RECONSTITUTION_ISSUE] = "Fournissez une description plus précise du problème de reconstitution";
translations[WHAT_MEDICATION_SOLUTION] = "Avec quel médicament/solution le produit a-t-il été reconstitué ?";
translations[WHAT_VOLUME_MEDICATION] = "Quel est le volume de médicament/solution utilisé pour reconstituer ?";
translations[WHAT_DEVICES_RECONSTITUTION] = "Quels autres appareils ont été utilisés pendant la reconstitution (nom/fabricant, taille/jauge de l'aiguille, etc.)";
translations[WAS_PRODUCT_EXPOSED_HEAT] = "Le produit a-t-il été exposé à la chaleur ?";
translations[DESCRIBE_EXPOSURE] = "Décrire l'exposition (température, pendant combien de temps, etc.)";
translations[WHAT_USED_ACTIVATE_SOLUTION] = "Quelle technique a été utilisée pour activer la solution ?";
translations[WAS_DAMAGE_OBSERVED] = "Y a-t-il eu des dommages/dégats au produit avant son activation ?";
translations[DESCRIBE_THE_DAMAGE] = "Décrivez les dégâts :";
translations[APPROXIMATELY_SOLUTION_POWDER] = "Quelle quantité (approxiamtive) de solution ou de poudre a été sous-remplie ou surremplie ?";
translations[WAS_LEAK_OBSERVED] = "Avez-vous observé une fuite ?";
translations[WHAT_FEATUR_DIFFICULT_USE] = "Quels composants ou caractéristiques du produit sont difficiles à utiliser ?";
translations[HOW_WAS_DIFFICULT_USE] = "En quoi le produit a-t-il été difficile à utiliser ?";
translations[WHERE_MATTER_FOREIGN] = "Où se trouvaient la particule ou la matière étrangère ?";
translations[DOES_PARTICULATE_MATTER] = "Les particules ou les matières étrangères semblent-elles être des morceaux de matériau produit ?";
translations[DESCRIBE_EXACT_LOCATION] = "Décrivez l'emplacement exact, la couleur, la taille, la forme et la texture de la particule ou de la matière étrangère :";
translations[WAS_MATTER_FOREIGN] = "Les particules ou les matières étrangères sont-elles incorporées dans le matérieau du produit (ne se déplaçant pas librement) ?";
translations[WHEN_MATTER_FOREIGN] = "Quand les particules ou les matières étrangères ont-elles été observées ?";
translations[PROVIDE_INFORMATION_MEDICATION] = "Fournissez des informations concernant le médicament/produit ajouté :";
translations[PRODUCT_NAME_CODE_NUMBER] = "Nom du produit, code produit, numéro de lot du produit, fabricant du produit, etc.";
translations[DESCRIBE_SPIKING] = "Décrivez la technique de perçage ou de reconstitution utilisée :";
translations[INCLUDE_NEEDLE] = "Comprend la taille/jauge de l'aiguille, l'angle de perçage, le nombre de tentatives, etc.";
translations[WHAT_ADMINISTRATION_RECONSTITUTION] = "Quel dispositif de reconstitution a été utilisé ?";
translations[INCLUDE_MANUFACTURER] = "Inclure le fabricant, le nom du produit, le code produit, le lot du produit";
translations[WAS_MEDICATION_ADDITIVE] = "Un médicament, un additif ou une solution de reconstitution ont-ils été ajoutés au produit ?";
translations[WHAT_MEDICATION_ADDITIVE] = "Quels médicaments, additifs ou solutions de reconstitution ont été ajoutés ?";
translations[WHAT_STATE_OF_PRODUCT] = "Quel était l'état du produit lorsque le trouble / la précipitation a été observé ?";
translations[AFTER_UNITS_SAT] = "Une fois que le produit a atteint la température ambiante, est-ce que la précipitation et/ou la solution trouble ont-ils disparu ?";
translations[DID_ATTEMPT_AGITATE] = "Avez-vous tenté d'agiter l'unité ?";
translations[DID_PRECIPITATE_DISSOLVE] = "Le précipité s'est-il dissous ?";
translations[WHAT_STORAGE_TEMPERATURE] = "Quelles étaient la température et les conditions de stockage du produit ?";
translations[PROVIDE_TEMPERATURE_LOCATION] = "Fournir la température, l'emplacement, entreposé à l'intérieur ou à l'extérieur du plastique de protection/carton, etc.";
translations[ARE_TEMPERATURE_LOGS] = "Les registres de température du ou des congélateurs dans lesquels le produit est stocké sont-ils disponibles ?";
translations[LOGS_CAN_BE_ATTACHED] = "Les fichiers mémoires (logs) peuvent être joints directement à ce formulaire (si disponibles).";
translations[IS_THE_STORAGE_UNIT] = "L'unité de stockage (congélateur ou réfrigérateur) est-elle étalonnée et est-ce que la température est contrôlée ?";
translations[HOW_PRODUCT_THAWED] = "Comment le produit a-t-il été décongelé ?";
translations[WHAT_STORAGE_CONDITIONS] = "Quelles étaient les conditions de stockage du produit ? (température, emplacement, entreposé à l'intérieur ou à l'extérieur du film de protection ou de la boîte)";
translations[WAS_ANY_DAMAGE] = "Y a-t-il eu des dommages au produit ou un problème observé ?";
translations[MORE_SPECIFIC_INFORMATION] = "Veuillez fournir des informations plus spécifiques :";
translations[WHAT_PURPOSE_INDICATION] = "Quel était l'objectif ou l'indication du traitement pour le patient ?";
translations[WHAT_ROUTE_ADMINISTRATION] = "Quelle était la voie d'administration ?";
translations[WHAT_DATE_ADMINISTRATION] = "Quelle était la date d'administration et la durée ?";
translations[WHAT_DOSAGE_STRENGTH] = "Quelle est la posologie ou la dose administrée au patient ?";
translations[WAS_RECENT_PRESCRIPTION] = "Y a-t-il eu un changement récent de prescription ?";
translations[WHAT_WAS_STORAGE_TEMPERATURE] = "Quels étaient les détails de stockage/température du produit (emplacement de stockage/réfrigérateur/congélateur, etc.) ?";
translations[WERE_ANY_ADJUSTMENTS] = "Y a-t-il eu des ajustements apportés à la solution ou aux additifs avant l'administration ?";
translations[SELECT_APPROPRIATE_DESCRIPTION] = "Sélectionnez la description la plus appropriée du problème :";
translations[SELECT_LABELING_ISSUE] = "Sélectionnez la description la plus appropriée du problème d'étiquetage/d'identification :";
translations[WAS_CONNECTION_SECURE] = "La connexion était-elle sécurisée et entièrement serrée ?";
translations[WAS_EXPIRED_PRODUCT] = "Le produit expiré a-t-il été administré à un patient ?";
translations[WAS_COMPONENT_DAMAGED] = "Y a-t-il eu des composants endommagés ?";
translations[WERE_ABNORMALITIES_DAMAGE] = "Y a-t-il eu des anomalies/dommages au produit ?";
translations[WHAT_PURCHASE_ORDER_NUMBER] = "Quel est votre numéro de commande ?";
translations[WHAT_DATE_OF_ADMINISTRATION] = "Quelle était la date de l'administration ?";
translations[WHAT_WAS_EXPIRATION_DATE] = "Quelle était la date d'expiration du produit ?";
translations[DESCRIBE_WAS_INCORRECT] = "Décrivez ce qui était incorrect, incomplet, manquant, illisible sur l'étiquette ou ce qui était trop similaire (à un autre produit) sur l'étiquette :";
translations[WHAT_SCANNER_USED] = "Quel type de scanner a été utilisé ?";
translations[WAS_OVERPOUCH_POUCH] = "Le produit était-il toujours dans la pochette durant le scan ?";
translations[WHAT_BACKGROUND_COLOR] = "Quelle était la couleur d'arrière-plan lors ddu scan ?";
translations[DO_ALL_OF_THE_LABELS] = "Toutes les étiquettes (produit, boîte/carton, expédition/distribution) ont-elles les mêmes informations sur le produit ?";
translations[PRODUCT_INFORMATION] = "Informations sur le produit";
translations[IS_A_BARCODE_SCANNER] = "Un lecteur de codes-barres est-il utilisé dans votre établissement ?";
translations[HOW_ARE_THESE_PRODUCTS] = "Comment ces produits sont-ils stockés dans l'établissement ?";
translations[WHAT_INFORMATION_INCORRECTLY] = "Quelles informations ont été mal affichées lors du scan ?";
translations[WAS_THERE_LEAK] = "Y a-t-il eu une fuite ou de l'humidité observée ?";
translations[WHERE_LEAK_OBSERVED] = "Où la fuite a-t-elle été observée, quel composant fuyait ?";
translations[WAS_FRANGIBLE_OBSERVED] = "Le frangible a-t-il été brisé ?";
translations[IS_MOISTURE_CLEAR] = "Les traces d'humidité sont-elles claires/translucides ?";
translations[WHO_IS_YOUR_DISTRIBUTOR] = "Qui est votre distributeur ?";
translations[WHAT_MANUFACTURER_MEDICATION] = "Quel est le fabricant, le nom du médicament et la taille du flacon utilisés ?";
translations[WHAT_GAUGE_NEEDLE] = "Quelle est la jauge de l'aiguille utilisée, le fabricant et le nombre de fois où le site a été perforé ?";
translations[WHAT_ADMINISTRATION_SET] = "Quel dispositif d'administration a été utilisé ?";
translations[WAS_DIFFICULTY_SPIKING] = "Y a-t-il eu des difficultés à percer le dispositif ?";
translations[WERE_FOLLOWING_SCENARIOS] = "Est-ce que l'un des scénarios suivants s'est produit avec la fuite ?";
translations[WAS_FRANGIBLE_OBSERVED_DEFECT] = "Le frangible était-il endommagé ou défectueux ?";
translations[WHAT_AMOUNT_PRESSURE] = "Quelle quantité de pression a été appliquée et pendant quelle durée ?";
translations[WAS_BAG_COMPLETELY] = "La poche a-t-elle été complètement et correctement insérée dans le brassard de pression (est-ce qu'une extrémité se trouvait à l'extérieur du brassard de pression) ?";
translations[WHAT_MANUFACTURER_MODEL] = "Quel est le fabricant, le modèle et la taille de la manchette de pression ?";
translations[WHAT_PRESSURE_PRIOR] = "Quelle était la pression avant la détection de la fuite ?";
translations[LIST_THE_VAPORIZER] = "Liste du fabricant et nom/modèle du vaporisateur";
translations[APPROXIMATELY_HOW_MUCH] = "Quelle quantité de liquide a été déversée ?";
translations[WAS_THE_BOTTLE_DIFFICULT] = "La bouteille était-elle difficile à insérer dans le vaporisateur ?";
translations[WERE_VISIBLE_DEFECTS] = "Y a-t-il eu des défauts visibles ?";
translations[SELECT_THE_OPTION] = "Sélectionnez l'option qui décrit le mieux le problème de connexion";
translations[PROVIDE_INVOLVED_CONNECTION_ISSUE] = "Veuillez fournir les informations concernant le second produit impliqué dans le problème de connexion";
translations[WHICH_PART_SEPARATED] = "Quelle (s) partie (s) du produit est séparée ?";
translations[WHAT_COMPONENT_DISCOLORED] = "Quel composant est décoloré ?";
translations[SELECT_DESCRIBES_DISCOLORATION] = "Sélectionnez l'option qui décrit le mieux la décoloration :";
translations[WAS_THE_SET_DISCOLORED] = "L'ensemble a-t-il été décoloré lorsqu'il a été retiré du paquet ?";
translations[DID_SET_CHANGE_COLOR] = "L'ensemble a-t-il changé de couleur après avoir ajouté un médicament ?";
translations[WHAT_MEDICATION_ADDED] = "Quels médicaments ont été ajoutés avant le changement de couleur ?";
translations[WHERE_MATERIAL_LOCATED] = "Où se trouvaient les particules/matières étrangères ?";
translations[DESCRIBE_APPEARANCE_COLOR_SIZE] = "Décrire les particules ou les matières étrangères (apparence/couleur/taille) :";
translations[WAS_EMBEDDED_PLASTIC] = "Les particules et les matières étrangères sont-elles en libre mouvement ou incorporées dans le plastique ?";
translations[WAS_THERE_A_PRECIPITATE] = "Y a-t-il eu une précipitation ou un changement de couleur de la solution qui n'était pas attendu ?";
translations[WHAT_MEDICATIONS_SOLUTIONS] = "Quels médicaments/solutions ont été infusés dans le produit ?";
translations[WHERE_DAMAGE_COMPONENT_AFFECTED] = "Où ont été les dommages ou quels composants ont été affectés (sélectionnez tous les éléments qui s'appliquent) ?";
translations[WHAT_DAMAGE_ISSUE] = "Quel type de dommages/problème a été observé (sélectionnez tout ce qui s'applique) ?";
translations[DID_ISSUE_RESULT] = "Ce problème a-t-il entraîné une fuite ?";
translations[WAS_PATIENT_CONNECTED] = "Le patient était-il connecté au produit ?";
translations[WAS_PRODUCT_REPLACED] = "Le produit a-t-il été remplacé par un nouveau produit ?";
translations[WHICH_SITUATION_BEST] = "Quelle situation décrit le mieux le problème de séparation/connexion";
translations[SELECT_MOST_LABELING_ISSUE] = "Sélectionnez la description la plus appropriée du problème d'étiquetage/d'identification :";
translations[WHAT_INFORMATION_DISPLAYED] = "Quelles informations ont été affichées ?";
translations[WHAT_SCANNER_WAS_USED] = "Quel type de scanner a été utilisé ?";
translations[INCLUDE_THE_MODEL_NAME] = "Inclure le nom du modèle";
translations[WAS_PRODUCT_ORDERED] = "Le produit a-t-il été commandé directement auprès de Vantive ou d'un autre distributeur ?";
translations[WHERE_LEAK_COMING] = "D'où vient la fuite (sélectionnez tout ce qui s'applique) ?";
translations[DID_SCENARIOS_OCCURRED_LEAK] = "L'un des scénarios suivants s'est-il produit avec la fuite ?";
translations[WAS_POWER_INJECTOR] = "Le produit a-t-il été utilisé avec dispositif d'aide à l'injection ?";
translations[WHAT_INJECTOR_USED] = "Quel dispositif d'aide à l'injection a été utilisé ?";
translations[MANUFACTURER_NAME_CODE_LOT] = "Fabricant, nom du produit, code produit, lot de produits";
translations[DESCRIBE_INCORRECT_INCOMPLETE] = "Décrivez ce qui était incorrect, incomplet, manquant, illisible ou modifié sur l'étiquette :";
translations[PROVIDE_INFORMATION_SECOND_PRODUCT] = "Fournir les informations sur le produit du deuxième produit impliqué dans la déconnexion";
translations[WHICH_COMPONENTS_WERE_FOUND] = "Quels sont les composants qui présentaient une fissure ou une rupture ?";
translations[DESCRIBE_CUT_HOLE_SLICE] = "Décrivez l'emplacement exact sur la tubulure qui présentait le dégat :";
translations[WAS_LEAK_ORIGINATING] = "Est-ce que la fuite provient du site d'injection suite à son ouverture ?";
translations[PROVIDE_DISCONNECTION_CONNECTION] = "Veuillez fournir les informations sur le deuxième produit impliqué dans le problème de déconnexion ou de connexion";
translations[WHICH_SPECIFIC_BONDED] = "Quels composants collés ont été trouvés séparés ?";
translations[WERE_VISIBLE_IRREGULARITIES] = "Y a-t-il eu des irrégularités ou des dommages visibles sur le produit/les composants concernés";
translations[WAS_SUCCESSFUL_CONNECTION] = "Une connexion ou une déconnexion réussies a-t-elle finalement été réussie (sans avoir à remplacer le produit) ?";
translations[WAS_TOOL_USED_ASSIST] = "Un outil a-t-il été utilisé pour faciliter la connexion ou la déconnexion ?";
translations[WERE_LUER_CONNECTIONS] = "Toutes les connexions Luer ont-elles été vérifiées pour s'assurer qu'elles étaient sécurisées avant utilisation (comme indiqué dans les instructions)?";
translations[WAS_PRODUCT_SECURELY] = "Le produit était-il connecté en toute sécurité à un autre produit avant de le déconnecter ?";
translations[WHICH_DESCRIBES_FLOW_ISSUE] = "Quelle est la situation qui décrit le mieux le problème d'écoulement ?";
translations[WHAT_FLOWING_BACKWARDS] = "Qu'est-ce qui coulait dans le mauvais sens ?";
translations[DESCRIBE_COMPONENTS_BACKFLOW] = "Décrivez les composants d'où le refoulement a commencé jusqu'à l'endroit où il s'est arrêté :";
translations[DO_SITUATIONS_APPLY] = "L'une de ces situations s'applique-t-elle à cet événement ?";
translations[WHICH_SPECIFIC_AREA] = "Quelle zone spécifique de l'ensemble ou du composant a été associée aux problèmes d'écoulement ?";
translations[WAS_FLOW_PREVIOUSLY_SEEN] = "L'écoulement a-t-il déjà été vu à travers l'ensemble ou le composant ?";
translations[WAS_ANY_FOLLOWING_OBSERVED] = "L'un des éléments suivants a-t-il été observé :";
translations[WHERE_SIMULTANEOUS_FLOW] = "Où était l'écoulement simultané entre les deux ?";
translations[WHAT_TYPE_HANGER] = "Quel type de crochet a été utilisé ?";
translations[WHAT_WAS_HANGER_LENGTH] = "Quelle était la longueur du crochet et/ou le fabricant ?";
translations[WHICH_BAG_LOWER] = "Quelle poche était le plus bas ?";
translations[WHAT_Y_SITE_WAS] = "À quel niveau le set secondaire a-t-il été connecté ?";
translations[WHAT_COMPONENT_WITHIN] = "Quel composant de l'ensemble ne peut pas être drainé de la solution ou du sang ?";
translations[WAS_COMPONENT_SET_REPLACED] = "Le composant/ensemble a-t-il été remplacé après qu'il n'a pas pu être drainé ?";
translations[WHAT_VOLUME_FLUID_PERIOD_TIME] = "Quel était le volume de liquide à infuser au patient et la période prescrite ?";
translations[WHAT_VOLUME_FLUID_OVER_TIME] = "Quel est le volume de liquide réellement infusé chez le patient & durant quelle période ?";
translations[WAS_USED_WITH_PUMP] = "Le set a-t-il été utilisé avec une pompe ?";
translations[DID_CLAMP_FAIL] = "Est-ce qu'un clamp a échoué à arrêter ou à contrôler le débit ?";
translations[WHAT_CLAMP_FAILED] = "Quel clamp a échoué ?";
translations[WAS_ISSUES_OBSERVED_CLAMP] = "Y a-t-il eu des problèmes observés avec le clamp ?";
translations[DO_OTHER_SITUATIONS_DESCRIBE] = "L'une de ces autres situations décrivent-elles le problème du produit (sélectionnez toutes les situations qui s'appliquent) ?";
translations[DESCRIBE_ALARM_OBSERVED] = "Décrivez l'alarme observée :";
translations[INCLUDE_ANY_MESSAGES] = "Inclure tous les messages et codes d'erreur associés à l'alarme";
translations[WHICH_CLAMP_HAD_ISSUE] = "Quel clamp a eu le problème ?";
translations[WHICH_TYPE_CLAMP_ISSUE] = "Quel type de problème de serrage a été rencontré (sélectionnez tout ce qui s'applique) ?";
translations[SELECT_BEST_DESCRIBES_ISSUE] = "Sélectionnez le scénario qui décrit le mieux le problème :";
translations[PROVIDE_MORE_DETAILS] = "Fournissez plus de détails sur la façon dont le produit était difficile à utiliser :";
translations[PROVIDE_MORE_DETAILS_INSTRUCTIONS] = "Donnez plus de détails sur les instructions difficiles à suivre/à comprendre :";
translations[DESCRIBE_THE_SMELL] = "Décrivez l'odeur et d'où elle venait :";
translations[WAS_ISSUES_WITH_SET] = "Y a-t-il eu des problèmes observés avec l'ensemble ?";
translations[WHERE_LEAK_LOCATED] = "Où se trouvait la fuite sur le produit ?";
translations[DID_OCCUR_WITH_LEAK] = "L'un des événements suivants s'est-il produit avec la fuite ?";
translations[PROVIDE_INVOLVED_DISCONNECTION] = "Fournir les informations sur le produit du deuxième produit impliqué dans la déconnexion";
translations[DID_OCCURRED_WITH_THE_LEAK] = "L'un des scénarios suivants s'est-il produit avec la fuite ?";
translations[WHERE_WAS_PRODUCT_DAMAGED] = "Où le produit a-t-il été endommagé ?";
translations[SELECT_ALL_APPLY] = "Sélectionnez toutes les options qui s'appliquent";
translations[DESCRIBE_OBSERVED_DAMAGE] = "Décrire les dommages observés";
translations[WHAT_COMPONENT_IS_DISCOLORED] = "Quel composant du produit a été décoloré ?";
translations[DESCRIBE_HUE_TINT_SHADE] = "Décrire la couleur observée (teinte, etc.) :";
translations[INSIDE_OUTSIDE_OVERPOUCH] = "A l'intérieur ou à l'extérieur du plastique de protection, température, exposition à la lumière, etc.";
translations[DESCRIBE_EXACT_LOCATION_SIZE] = "Décrivez l'emplacement exact, la taille, la forme et la couleur de la particule ou de la matière étrangère :";
translations[DOES_THE_PARTICULATE_MATTER] = "Les particules ou les matières étrangères semblent-elles être des matières provenant du produit lui-même ?";
translations[WAS_PARTICULATE_MATERIAL_EMBEDDED] = "Les particules et les matières étrangères étaient-elles incorporée dans la matière du dispositif ?";
translations[DOES_APPEAR_PRODUCT_MATERIAL] = "La particule ou la matière étrangère semble-t-elle être des morceaux du matériau du produit ?";
translations[WHERE_DID_THE_ISSUE_OCCUR] = "Où le problème s'est-il produit sur le produit ?";
translations[LIST_COMPONENTS_IF] = "Lister les composants. Si un deuxième produit a été impliqué, indiquer le fabricant, le nom du produit, le code produit et le lot du produit";
translations[WERE_THERE_VISIBLE_IRREGULARITIES] = "Y a-t-il eu des irrégularités ou des dommages visibles observés ?";
translations[SELECT_OPTION_FLOW_ISSUE] = "Sélectionnez l'option qui décrit le mieux le problème d'écoulement";
translations[DESCRIBE_IRREGULARITIES] = "Décrivez les irrégularités/défauts et si des défauts ont été observés avant la connexion ou la déconnexion ou s'il s'est produit pendant la connexion/déconnexion";
translations[HOW_PRODUCT_SETUP] = "Comment le produit a-t-il été installé/configuré ?";
translations[SELECT_MOST_APPROPRIATE_DESCRIPTION] = "Sélectionnez la description la plus appropriée du problème d'étiquetage :";
translations[DESCRIBE_WHAT_INCORRECT_INCOMPLETE] = "Décrivez ce qui était incorrect, incomplet, manquant, illisible sur l'étiquette ou ce qui était trop similaire (à un autre produit) sur l'étiquette :";
translations[WAS_SHIPPING_CARTON_DAMAGED] = "Le produit contenu dans le carton d'expédition a-t-il été endommagé ?";
translations[WHAT_PRODUCT_WAS_SUPPOSED] = "Quel produit devait être reçu ?";
translations[IF_PRODUCT_CODE_NOT] = "Si le code produit n'est pas disponible, veuillez fournir une description du produit";
translations[WAS_THE_CASE_MISSING] = "Est-ce que de la glace carbonique ou du gel réfrigéré manquait dans la boîte?";
translations[WHAT_CARRIER_DELIVERED] = "Quel transporteur a livré votre produit ?";
translations[WHAT_IS_PURCHASE_ORDER_NUMBER] = "Quel est le numéro de commande fournisseur ?";
translations[WHAT_QUANTITY_MISSING_UNITS] = "Quelle est la quantité d'unités manquantes ?";
translations[WAS_EXPIRED_PRODUCT_USE] = "le produit expiré a-t-il été utilisé ?";
translations[APPLY_TO_EACH_UNIT] = "Si cet évènement est survenu avec plus d'une unités, les questions ci-dessous s'appliquent à l'ensemble des unités affectées.";
translations[TERMS_CONDITIONS] = "Conditions générales ";
translations[PRIVACY_POLICY] = "Politique de confidentialité ";
translations[PRIVACY_NOTICE] = "Avis de Confidentialité";
translations[COOKIE_POLICY] = "Politique de cookies";
translations[OPTION_REPORTEROCCUPATIONOPTIONS_ASKED_UNKNOWN] = "Demandé mais inconnu";
translations[OPTION_FUNCTIONOPTIONS_VANTIVE_EMPLOYEE] = "Employé Vantive";
translations[OPTION_FUNCTIONOPTIONS_CAREGIVER] = "Personnel soignant";
translations[OPTION_FUNCTIONOPTIONS_DISTRIBUTOR] = "Distributeur";
translations[OPTION_FUNCTIONOPTIONS_HEALTHCARE_PROFESSIONAL] = "Professionnel de la santé";
translations[OPTION_FUNCTIONOPTIONS_PATIENT] = "Patient";
translations[OPTION_FUNCTIONOPTIONS_OTHER] = "Autre";
translations[OPTION_PROCESSSTEPOPTIONS_AFTER_USE] = "Après utilisation";
translations[OPTION_PROCESSSTEPOPTIONS_BEFORE_USE] = "Avant utilisation";
translations[OPTION_PROCESSSTEPOPTIONS_DURING_SETUP_PREPARATION] = "Pendant l'installation/préparation";
translations[OPTION_PROCESSSTEPOPTIONS_DURING_THERAPY] = "Pendant le traitement";
translations[OPTION_PROCESSSTEPOPTIONS_MULTIPLE_STEPS] = "Plusieurs étapes";
translations[OPTION_PROCESSSTEPOPTIONS_NOT_SPECIFIED] = "Non spécifié";
translations[OPTION_OCCUPATIONOPTIONS_FAMILY_MEMBER] = "Membre de la famille";
translations[OPTION_OCCUPATIONOPTIONS_NURSE] = "Infirmière (hôpital)";
translations[OPTION_OCCUPATIONOPTIONS_NURSE_PRACTITIONER] = "Infirmière libérale";
translations[OPTION_OCCUPATIONOPTIONS_OTHER_HEALTH_CARE_PROFESSIONAL] = "Autre professionnel de la santé";
translations[OPTION_OCCUPATIONOPTIONS_PHYSICIAN] = "Médecin";
translations[OPTION_UNITOPTIONS_BOXES] = "Boîte(s)";
translations[OPTION_UNITOPTIONS_PALLETS] = "Pallette(s)";
translations[OPTION_UNITOPTIONS_UNITS] = "Unités";
translations[OPTION_PROBLEMOPTIONS_ALARM_CONDITION] = "Problème lié à la survenue d''alarme";
translations[OPTION_PROBLEMOPTIONS_DAMAGE] = "Dommages";
translations[OPTION_PROBLEMOPTIONS_DIFFICULT_TO_USE] = "Difficulté d'utilisation";
translations[OPTION_PROBLEMOPTIONS_DISCOLORED] = "Décoloration/Coloration";
translations[OPTION_PROBLEMOPTIONS_FLOW_ISSUES] = "Problème d'écoulement";
translations[OPTION_PROBLEMOPTIONS_LABELING_ISSUES] = "Problème d'identification/étiquette";
translations[OPTION_PROBLEMOPTIONS_LEAK_EXCESSIVE_MOISTURE] = "Fuite / Présence d'humidité";
translations[OPTION_PROBLEMOPTIONS_PARTICULATE_MATTER_FOREIGN_MATERIAL] = "Présence de particule ou corps étranger";
translations[OPTION_PROBLEMOPTIONS_PATIENT_REACTION_ADVERSE_EVENT] = "Réaction/Symptôme patient";
translations[OPTION_PROBLEMOPTIONS_PRODUCT_INQUIRY] = "Demande d'information produit";
translations[OPTION_PROBLEMOPTIONS_SEPARATION_CONNECTION] = "Problème de connection et/our déconnection";
translations[OPTION_PROBLEMOPTIONS_SHIPPING_ISSUES_EXPIRED_PRODUCT] = "Problème d'envoi et/ou Produit expiré";
translations[OPTION_PATIENTSEXOPTIONS_FEMALE] = "Femme";
translations[OPTION_PATIENTSEXOPTIONS_UNDIFFERENTIATE] = "Indifférencié";
translations[OPTION_PATIENTSEXOPTIONS_MALE] = "Homme";
translations[OPTION_PATIENTSEXOPTIONS_DECLINETOANSWER] = "Refuser de répondre à";
translations[OPTION_REPORTEROCCUPATIONOPTIONS_ADMINISTRATOR_SUPERVISOR] = "Administrateur/Superviseur";
translations[OPTION_REPORTEROCCUPATIONOPTIONS_BIOMEDICAL_ENGINEER] = "Technicien Médical";
translations[OPTION_REPORTEROCCUPATIONOPTIONS_COMPANY_REPRESENTATIVE] = "Représentant Commercial";
translations[OPTION_REPORTEROCCUPATIONOPTIONS_DENTIST] = "Dentiste";
translations[OPTION_REPORTEROCCUPATIONOPTIONS_DISTRIBUTOR] = "Distributeur";
translations[OPTION_REPORTEROCCUPATIONOPTIONS_FAMILY_MEMBER] = "Membre de la famille";
translations[OPTION_REPORTEROCCUPATIONOPTIONS_LAY_USER] = "Utilisateur";
translations[OPTION_REPORTEROCCUPATIONOPTIONS_NURSE] = "Infirmière (hôpital)";
translations[OPTION_REPORTEROCCUPATIONOPTIONS_NURSE_PRACTITIONER] = "Infirmière libérale";
translations[OPTION_REPORTEROCCUPATIONOPTIONS_OTHER_HEALTH_CARE_PROFESSIONAL] = "Autre professionnel de la santé";
translations[OPTION_REPORTEROCCUPATIONOPTIONS_PHARMACIST] = "Pharmacien";
translations[OPTION_REPORTEROCCUPATIONOPTIONS_PHARMACY_TECHNICIAN] = "Technicien en pharmacie";
translations[OPTION_REPORTEROCCUPATIONOPTIONS_PHYSICIAN] = "Médecin";
translations[OPTION_REPORTEROCCUPATIONOPTIONS_PATIENT] = "Patient";
translations[OPTION_REPORTEROCCUPATIONOPTIONS_RISK_MANAGER] = "Responsable Risque";
translations[OPTION_REPORTEROCCUPATIONOPTIONS_OTHER] = "Autres";
translations[OPTION_PRODUCTSURVEILLANCECONTACTOPTIONS_CONTACT_ADDITIONAL_CONTACT_PERSON] = "Contactez la personne de contact supplémentaire";
translations[OPTION_PRODUCTSURVEILLANCECONTACTOPTIONS_CONTACT_ME] = "Contactez-moi";
translations[OPTION_PRODUCTSURVEILLANCECONTACTOPTIONS_CONTACT_OTHER] = "Contactez quelqu'un d'autre";
translations[OPTION_REPORTEDTOOPTIONS_VANTIVE] = "Vantive";
translations[OPTION_REPORTEDTOOPTIONS_CHINA_FDA] = "China FDA";
translations[OPTION_REPORTEDTOOPTIONS_EMA] = "EMA";
translations[OPTION_REPORTEDTOOPTIONS_FDA] = "FDA";
translations[OPTION_REPORTEDTOOPTIONS_HEALTH_CANADA] = "Santé Canada";
translations[OPTION_REPORTEDTOOPTIONS_PMDA_JAPAN] = " PMDA (Japon)";
translations[OPTION_REPORTEDTOOPTIONS_TUV] = "TUV";
translations[OPTION_REPORTEDTOOPTIONS_TGA_AUSTRALIA] = "TGA (Australie)";
translations[OPTION_FOLLOWINGOCCUROPTIONS_A_PET_OR_ANIMAL] = "Un animal de compagnie oaurait pu causer le problème";
translations[OPTION_FOLLOWINGOCCUROPTIONS_A_SHARP_OBJECT] = "Un objet pointu ou un outil a été utilisé pour ouvrir le carton ou le surpochette.";
translations[OPTION_FOLLOWINGOCCUROPTIONS_THE_PRODUCT_PROBLEM_OCCURRED] = "Le produit a été exposé à une force excessive (c'est-à-dire cogné, heurté, etc.) avant que le problème ne se produise.";
translations[OPTION_FOLLOWINGOCCUROPTIONS_THE_PRODUCT_COLD_ENVIRONMENT] = "Le produit a été exposé ou stocké dans un environnement chaud/froid";
translations[OPTION_DAMAGEMINICAPOPTIONS_CARTON] = "Boîte";
translations[OPTION_DAMAGEMINICAPOPTIONS_MINICAP] = "Capuchon Minicap";
translations[OPTION_DAMAGEMINICAPOPTIONS_POUCH] = "Pochette de protection";
translations[OPTION_DIFFICULTTOUSEOPTIONS_THE_TRANSFER_TIGHT] = "Le transfert set était trop serré";
translations[OPTION_DIFFICULTTOUSEOPTIONS_THE_TRANSFER_LOOSE] = "Le transfert set n'était pas assez serré";
translations[OPTION_DIFFICULTTOUSEOPTIONS_THE_TRANSFER_CLOSE] = "Le transfert set n'a pas pu se fermer complètement.";
translations[OPTION_DIFFICULTTOUSEOPTIONS_THE_TRANSFER_OPEN] = "Le transfert set n'a pas pu s'ouvrir complètement";
translations[OPTION_DIFFICULTTOUSEOPTIONS_THE_TWIST_CLAMP_OPEN] = "Le composant à tourner était si serrée que le transfert set ne pouvait pas s'ouvrir";
translations[OPTION_DIFFICULTTOUSEOPTIONS_THE_TWIST_LAMP_CLOSE] = "Le composant à tourner était si serrée que le transfert set ne pouvait pas se fermer";
translations[OPTION_DIFFICULTIESMINICAPOPTIONS_YES_THERE_WAS_DAMAGE] = "Oui - il y a eu des dommages ou défaut avec le filetage du transfert set empêchant une fermeture correcte";
translations[OPTION_DIFFICULTIESMINICAPOPTIONS_YES_THE_MINICAP] = "Oui, le Minicap a été trop serré à la main sur le transfert set ou un outil/dispositif d'assistance au serrage a été utilisé";
translations[OPTION_FLOWISSUEOPTIONS_COMPLETELY_STOPPED] = "Complètement arrêté sans écoulement de liquide";
translations[OPTION_FLOWISSUEOPTIONS_RESTRICTED_OR_PARTIALLY] = "Ecoulement restreint ou partiel (débit lent)";
translations[OPTION_BLOCKINGFLOWOPTIONS_CLOTTED_BLOOD] = "Sang coagulé";
translations[OPTION_BLOCKINGFLOWOPTIONS_FIBRIN] = "Fibrin";
translations[OPTION_BLOCKINGFLOWOPTIONS_KINK] = "Pli";
translations[OPTION_BLOCKINGFLOWOPTIONS_PARTICULATE] = "Particule";
translations[OPTION_BLOCKINGFLOWOPTIONS_PRODUCT_MATERIAL] = "Matière du produit";
translations[OPTION_DESCRIBEISSUEOPTIONS_EXCESS_IODINE] = "Excès d'iode (brun) identifié lors de la connexion ou dans l'emballage";
translations[OPTION_DESCRIBEISSUEOPTIONS_EXCESS_MOISTURE] = "Excès d'humidité (gouttelettes transparentes) identifié dans l'emballage";
translations[OPTION_DESCRIBEISSUEOPTIONS_FOIL_POUCH] = "Pochette en aluminium endommagée avant ouverture";
translations[OPTION_DESCRIBEISSUEOPTIONS_PACKAGE_BOX] = "Paquet/boîte ouverte ou endommagée avant utilisation";
translations[OPTION_DESCRIBEISSUEOPTIONS_SPONGE_DRIED_OUT_AND_WHITE] = "Éponge séchée et blanche";
translations[OPTION_DESCRIBEISSUEOPTIONS_SPONGE_DRIED_OUT_BROWNISH_COLOR] = "Éponge séchée de couleur brûnatre";
translations[OPTION_MATERIALLOCATEDOPTIONS_IN_THE_SECONDARY] = "Dans l'emballage/surpochette de protection";
translations[OPTION_MATERIALLOCATEDOPTIONS_INSIDE_THE_PRODUCT_FLUID] = "Au niveau du passage de la solution (contact direct avec le fluide possible)";
translations[OPTION_MATERIALLOCATEDOPTIONS_INSIDE_THE_SHIPPING] = "À l'intérieur du carton d'expédition ";
translations[OPTION_MATERIALLOCATEDOPTIONS_ON_THE_OUTSIDE_OF_PRODUCT] = "A l'extérieur du dispositif";
translations[OPTION_MATERIALLOCATEDOPTIONS_ON_THE_OUTSIDE_OF_OVERPOUCH] = "À l'extérieur de l'emballage/de la pochette secondaire de protection";
translations[OPTION_MATERIALLOCATEDOPTIONS_ON_THE_EXTERIOR] = "À l'extérieur du carton d'expédition";
translations[OPTION_CONNECTIONISSUEOPTIONS_DIFFICULTIES_CONNECTING] = "Difficultés de raccordement du produit à un autre produit";
translations[OPTION_CONNECTIONISSUEOPTIONS_DIFFICULTIES_DISCONNECTING] = "Difficultés de déconnexion du produit d'un autre produit";
translations[OPTION_CONNECTIONISSUEOPTIONS_SEPARATION_OF_COMPONENTS] = "Séparation des composants d'un seul produit";
translations[OPTION_CONNECTIONISSUEOPTIONS_SEPARATION_DISCONNECTION] = "Séparation/déconnexion involontaire du produit d'un autre produit";
translations[OPTION_RESIDUETHREADSOPTIONS_YES_RESIDUE] = "Oui - présence de résidus sur le pas de vis";
translations[OPTION_RESIDUETHREADSOPTIONS_YES_VISIBLE] = "Oui - défaut visible";
translations[OPTION_RESIDUETHREADSOPTIONS_YES_OTHER] = "Oui - Autre (à préciser)";
translations[OPTION_OBSERVEDDAMAGEOPTIONS_FRANGIBLE] = "Frangible";
translations[OPTION_OBSERVEDDAMAGEOPTIONS_HANGER_HOLE] = "Trou pour permettre la suspension";
translations[OPTION_OBSERVEDDAMAGEOPTIONS_INJECTION_FILLING_PORT] = "Port d'injection/Port de remplissage ";
translations[OPTION_OBSERVEDDAMAGEOPTIONS_MEMBRANE_PORT] = "Membrane du port d'injection";
translations[OPTION_OBSERVEDDAMAGEOPTIONS_OVERPOUCH_POUCH] = "Surpochette/Pochette de protection";
translations[OPTION_OBSERVEDDAMAGEOPTIONS_PATCH] = "Patch";
translations[OPTION_OBSERVEDDAMAGEOPTIONS_RUBBER_STOPPER] = "Bouchon en caoutchouc ";
translations[OPTION_OBSERVEDDAMAGEOPTIONS_SHIPPING_CARTON] = "Boite/Carton d'expédition";
translations[OPTION_OBSERVEDDAMAGEOPTIONS_SHRINKBAND] = "Plastique de protection";
translations[OPTION_OBSERVEDDAMAGEOPTIONS_SOLUTION_CONTAINER] = "Poche principale contenant la solution";
translations[OPTION_OBSERVEDDAMAGEOPTIONS_TIP_PROTECTOR] = "Protecteur/Capuchon d'embout ";
translations[OPTION_OBSERVEDDAMAGEOPTIONS_TAMPER_EVIDENT_SEAL] = "Scellé de protection (plastique translucide)";
translations[OPTION_TYPEOBSERVEDDAMAGEOPTIONS_BENT] = "Légèrement plié";
translations[OPTION_TYPEOBSERVEDDAMAGEOPTIONS_BROKEN] = "Cassé";
translations[OPTION_TYPEOBSERVEDDAMAGEOPTIONS_CRACKED] = "Fissuré";
translations[OPTION_TYPEOBSERVEDDAMAGEOPTIONS_CUT] = "Coupé";
translations[OPTION_TYPEOBSERVEDDAMAGEOPTIONS_DEFORMED] = "Déformé";
translations[OPTION_TYPEOBSERVEDDAMAGEOPTIONS_FLAKING] = "Ecaillé";
translations[OPTION_TYPEOBSERVEDDAMAGEOPTIONS_HOLE] = "Tranché";
translations[OPTION_TYPEOBSERVEDDAMAGEOPTIONS_KINKED] = "Fortement plié";
translations[OPTION_TYPEOBSERVEDDAMAGEOPTIONS_MELTED] = "Fondu";
translations[OPTION_TYPEOBSERVEDDAMAGEOPTIONS_PATCH_LAYER_SEPARATION] = "Séparation de couche multiples";
translations[OPTION_TYPEOBSERVEDDAMAGEOPTIONS_SHATTERED_GLASS] = "Brisé (verre) ";
translations[OPTION_TYPEOBSERVEDDAMAGEOPTIONS_SLICED] = "Perforé";
translations[OPTION_TYPEOBSERVEDDAMAGEOPTIONS_TORN] = "Déchiré";
translations[OPTION_FLOWISSUEOBSERVEDOPTIONS_SOLUTION_WOULD_NOT_FLOW] = "La solution ne coulait pas du tout";
translations[OPTION_FLOWISSUEOBSERVEDOPTIONS_SOLUTION_WOULD_FLOW] = "La solution s'écoulait très lentement";
translations[OPTION_FLOWISSUEOBSERVEDOPTIONS_SOLUTION_WOULD_COMPOUNDING] = " La solution ne coulait pas (ou coule lentement) durant la reconstitution/préparation";
translations[OPTION_PRODUCTDISCOLOREDOPTIONS_BOTTLE] = "Bouteille/Flacon";
translations[OPTION_PRODUCTDISCOLOREDOPTIONS_CONTAINER] = "Container";
translations[OPTION_PRODUCTDISCOLOREDOPTIONS_HANGER_HOLE] = "Trou pour permettre la suspension de la poche";
translations[OPTION_PRODUCTDISCOLOREDOPTIONS_LINER] = "Doublure";
translations[OPTION_PRODUCTDISCOLOREDOPTIONS_OVERPOUCH_POUCH] = "Surpochette/Pochette de protection";
translations[OPTION_PRODUCTDISCOLOREDOPTIONS_OXYGEN_INDICATOR] = "Indicateur de présence d'oxygène";
translations[OPTION_PRODUCTDISCOLOREDOPTIONS_PATCH] = "Patch";
translations[OPTION_PRODUCTDISCOLOREDOPTIONS_PORTS] = "Ports";
translations[OPTION_PRODUCTDISCOLOREDOPTIONS_SOLUTION] = "Solution";
translations[OPTION_PRODUCTDISCOLOREDOPTIONS_TIP_PROTECTOR] = "Protecteur/Capuchon d'embout ";
translations[OPTION_CHAMBERDISCOLOREDOPTIONS_AMINO_ACID_CHAMBER] = "Compartiment Acides Aminés";
translations[OPTION_CHAMBERDISCOLOREDOPTIONS_DEXTROSE_CHAMBER] = "Compartiment Dextrose";
translations[OPTION_CHAMBERDISCOLOREDOPTIONS_LIPID_CHAMBER] = "Compartiment Lipides";
translations[OPTION_CHAMBERDISCOLOREDOPTIONS_LOWER_CHAMBER] = "Compartiment du dessous";
translations[OPTION_CHAMBERDISCOLOREDOPTIONS_UPPER_CHAMBER] = "Compartiment du dessus";
translations[OPTION_SPECIFICALLYDESCRIBESOPTIONS_BURST_RUPTURED_SEAL] = "Rupture/Fuite au niveau de la soudure";
translations[OPTION_SPECIFICALLYDESCRIBESOPTIONS_MISASSEMBLED_PRODUCT_PART] = "Produit/Composant mal assemblé";
translations[OPTION_SPECIFICALLYDESCRIBESOPTIONS_MISSING_COMPONENT] = "Composant manquant ";
translations[OPTION_WHATTYPEDAMAGEISSUEOPTIONS_SEPARATION_DISCONNECTION_OF] = "Composant séparé/déconnecté";
translations[OPTION_SPECIFICALLYDESCRIBESOPTIONS_PRODUCT_OVER_FILLED] = "Produit trop rempli";
translations[OPTION_SPECIFICALLYDESCRIBESOPTIONS_PRODUCT_UNDER_FILLED] = "Produit pas assez rempli";
translations[OPTION_SPECIFICALLYDESCRIBESOPTIONS_RECONSTITUTION] = "Problème de reconstitution/activation";
translations[OPTION_MATTERFOREIGNMATERIALOPTIONS_IN_THE_SECONDARY] = "Dans la surpochette/pochette de protection";
translations[OPTION_MATTERFOREIGNMATERIALOPTIONS_INSIDE_THE_SHIPPING] = "Dans le carton d'expédition ";
translations[OPTION_MATTERFOREIGNMATERIALOPTIONS_ON_THE_EXTERIOR] = "À l'extérieur du carton d'expédition";
translations[OPTION_MATTERFOREIGNMATERIALOPTIONS_OTHER] = "Autre (à préciser)";
translations[OPTION_MATTERFOREIGNMATERIALOPTIONS_INSIDE_SOLUTION] = "Dans la solution/Au niveau du passage de la solution";
translations[OPTION_MATTERFOREIGNMATERIALOPTIONS_INSIDE_THE_VAPORIZER] = "À l'intérieur du carter du vaporisateur (visible à travers la vitre)";
translations[OPTION_MATTERFOREIGNMATERIALOPTIONS_ON_XTERNAL_SURFACE] = "À l'extérieur du produit";
translations[OPTION_MATTERFOREIGNMATERIALOPTIONS_ON_THE_OUTSIDE] = "À l'extérieur de la surpochette/pochette de protection";
translations[OPTION_MATTERFOREIGNMATERIALOPTIONS_ON_THE_OXYGEN] = "Sur l'absorbeur d'oxygène";
translations[OPTION_MATTERFOREIGNMATERIALOPTIONS_ON_THE_TRANSDERMAL] = "Sur le Patch transdermique";
translations[OPTION_MATTERFOREIGNMATERIALPIECESOPTIONS_FRANGIBLE] = "Frangible";
translations[OPTION_MATTERFOREIGNMATERIALPIECESOPTIONS_GLASS_PARTICLES] = "Particules de verre";
translations[OPTION_MATTERFOREIGNMATERIALPIECESOPTIONS_PORT] = "Port";
translations[OPTION_MATTERFOREIGNMATERIALPIECESOPTIONS_RUBBER_STOPPER] = "Bouchon en caoutchouc ";
translations[OPTION_MATTERFOREIGNMATERIALPIECESOPTIONS_TUBING] = "Tube/Ligne";
translations[OPTION_WHENMATERIALOBSERVEDOPTIONS_AFTER_ADDING_ANOTHER] = "Après avoir ajouté un autre médicament ou après la reconstitution (flacons)";
translations[OPTION_WHENMATERIALOBSERVEDOPTIONS_AFTER_PRIOR_TO_SPIKING] = "Avant de percer ou avant la reconstitution";
translations[OPTION_CLOUDINESSOBSERVEDOPTIONS_COLD_THAWED] = " Froid (décongelé mais pas encore à température ambiante)";
translations[OPTION_CLOUDINESSOBSERVEDOPTIONS_FROZEN] = "Congelé";
translations[OPTION_CLOUDINESSOBSERVEDOPTIONS_PARTIALLY_THAWED] = "Partiellement décongelé (cristaux de glace dans de la solution) ";
translations[OPTION_CLOUDINESSOBSERVEDOPTIONS_ROOM_TEMPERATURE] = "Température ambiante";
translations[OPTION_PRODUCTTHAWEDOPTIONS_VANTIVE_THAWING] = "Unité de décongélation - Vantive (VTU)";
translations[OPTION_PRODUCTTHAWEDOPTIONS_LEFT_ON_COUNTER] = "Laissé à température ambiante";
translations[OPTION_PRODUCTTHAWEDOPTIONS_REFRIGERATOR] = "Réfrigérateur";
translations[OPTION_DAMAGEISSUEOBSERVEDOPTIONS_YES_EVIDENCE] = "Oui - il y a eu des preuves de dégats durant l'expédition";
translations[OPTION_DAMAGEISSUEOBSERVEDOPTIONS_YES_LEAK_OBSERVED] = "Oui - une fuite a été observée";
translations[OPTION_DAMAGEISSUEOBSERVEDOPTIONS_YES_HOLE_OR_INCOMPLETE] = "Oui - il y avait un trou ou une soudure incomplète dans le surpochette";
translations[OPTION_DAMAGEISSUEOBSERVEDOPTIONS_YES_DIFFICULTY_SPIKING] = "Oui - il y avait de la difficulté à percer ou effectuer une reconstitution";
translations[OPTION_DAMAGEISSUEOBSERVEDOPTIONS_YES_DIFFICULTY_BREAKING] = "Oui - il y avait de la difficulté à briser le frangible";
translations[OPTION_DAMAGEISSUEOBSERVEDOPTIONS_YES_THERE_WAS_CRYSTALLIZATION] = "Oui - il y a eu de la cristallisation ou des précipitations de la solution";
translations[OPTION_DAMAGEISSUEOBSERVEDOPTIONS_YES_THERE_WAS_CLOUDINESS] = "Oui - le produit était trouble / nuageux";
translations[OPTION_DAMAGESPECIFICINFOOPTIONS_PRODUCT_DID_NOT] = "Le produit n'a mené à l'effet escompté ou a été inefficace (absence d'effet) ";
translations[OPTION_DAMAGESPECIFICINFOOPTIONS_UNINTENDED_EFFECT] = "Effet ou réaction non souhaité -  Veuillez préciser: ";
translations[OPTION_SCENARIOSLEAKOPTIONS_OPTION_APPROPRIATEDESCRIPTIONOPTIONS_DAMAGED_SHIPPING] = "Carton d'expédition endommagé pendant la livraison ";
translations[OPTION_APPROPRIATEDESCRIPTIONOPTIONS_EXPIRED_PRODUCT_DELIVERED] = "Produit expiré livré ";
translations[OPTION_APPROPRIATEDESCRIPTIONOPTIONS_EXPIRED_PRODUCT_FOUND] = "Produit expiré trouvé";
translations[OPTION_LABELINGISSUEOPTIONS_BARCODE_ISSUE] = "Problème de code-barres - Informations incorrectes affichées lors de la numérisation";
translations[OPTION_LABELINGISSUEOPTIONS_DIFFICULTIES_SCANNING] = "Difficultés de numérisation du code-barres /code-barres non scannable";
translations[OPTION_LABELINGISSUEOPTIONS_EXPIRED_PRODUCT_DELIVERED] = "Produit expiré livré ";
translations[OPTION_LABELINGISSUEOPTIONS_EXPIRED_PRODUCT_INVENTORY] = "Produit expiré trouvé  ";
translations[OPTION_LABELINGISSUEOPTIONS_EXPIRED_ILLEGIBLE_LABEL] = "Étiquette illisible ";
translations[OPTION_LABELINGISSUEOPTIONS_INCORRECT_LABEL] = "Étiquette incorrecte ";
translations[OPTION_LABELINGISSUEOPTIONS_INCOMPLETE_LABEL] = "Étiquette incomplète ";
translations[OPTION_LABELINGISSUEOPTIONS_ILABEL_TOO_SIMILAR] = "Etiquette trop similaire à un autre produit ";
translations[OPTION_LABELINGISSUEOPTIONS_LABELS_PRODUCT] = "Étiquettes (produit, boîte/carton, liste d'expédition) n'ont pas les mêmes informations";
translations[OPTION_LABELINGISSUEOPTIONS_MISSING_BARCODE] = "Code-barres manquant Produit";
translations[OPTION_DESCOFISSUEOPTIONS_CARTON_BOX] = "La boîte contient un produit incorrect";
translations[OPTION_DESCOFISSUEOPTIONS_DAMAGED_SHIPPING] = "Carton d'expédition endommagé pendant la livraison";
translations[OPTION_DESCOFISSUEOPTIONS_EXTRA_UNITS_WERE_RECEIVED] = "Des unités supplémentaires ont été reçues";
translations[OPTION_DESCOFISSUEOPTIONS_EXPIRED_PRODUCT_DELIVERED] = "Un produit expiré a été livré";
translations[OPTION_DESCOFISSUEOPTIONS_EXPIRED_PRODUCT_FOUND] = "Un produit expiré a été identifié";
translations[OPTION_DESCOFISSUEOPTIONS_PART_OF_THE_CARTON] = "Une partie du carton a été ouverte ou était non scellée";
translations[OPTION_DESCOFISSUEOPTIONS_PRODUCT_INFO_ON_THE_CARTON] = "Les informations sur le carton et la note d'expédition ne correspondent pas au produit à l'intérieur du carton ";
translations[OPTION_DESCOFISSUEOPTIONS_UNITS_WERE_MISSING] = "Des unités étaient manquantes";
translations[OPTION_DESCOFISSUEOPTIONS_OTHER] = "Autre (à préciser)";
translations[OPTION_LABELINGISSUEOPTIONS_MISSING_LABEL] = "Étiquette manquante";
translations[OPTION_WHATINCORRECTLYDISPLAYEDOPTIONS_EXPIRATION_DATE] = "Date d'expiration";
translations[OPTION_WHATINCORRECTLYDISPLAYEDOPTIONS_LOT_NUMBER] = "Numéro de lot ";
translations[OPTION_WHATINCORRECTLYDISPLAYEDOPTIONS_NDC_NUMBER] = "Numéro National du Médicament (National Drug Code - NDC)";
translations[OPTION_MOISTUREOBSERVEDOPTIONS_DROPLETS_MOISTURE] = "Gouttelettes/humidité à l'intérieur du surpochette sans fuite observée";
translations[OPTION_MOISTUREOBSERVEDOPTIONS_LEAK] = "Fuite";
translations[OPTION_MOISTUREOBSERVEDOPTIONS_LEAK_OBSERVED] = "Fuite observée lorsque le sac est pressé";
translations[OPTION_MOISTUREOBSERVEDOPTIONS_SOLUTION_FLOWING] = "Solution passant à travers le frangible";
translations[OPTION_MOISTUREOBSERVEDOPTIONS_SOLUTION_INSIDE] = "Solution à l'intérieur du surpochette sans fuite observée";
translations[OPTION_COMPONENTLEAKINGOPTIONS_BETWEEN_OVERPOUCH] = "Entre le surpochette et la poche principale";
translations[OPTION_COMPONENTLEAKINGOPTIONS_CONNECTION_BETWEEN] = "Connexion entre deux produits ";
translations[OPTION_COMPONENTLEAKINGOPTIONS_CONTAINER_MEMBRANE] = "Poche principale - Membrane du port / Tube";
translations[OPTION_COMPONENTLEAKINGOPTIONS_CONTAINER_INJECTION] = "Poche principale - Port pour injection ou addition";
translations[OPTION_COMPONENTLEAKINGOPTIONS_CONTAINER_HANGER] = "Poche principale - Trou pour suspension";
translations[OPTION_COMPONENTLEAKINGOPTIONS_CONTAINER] = "Container";
translations[OPTION_COMPONENTLEAKINGOPTIONS_FRANGIBLE] = "Frangible";
translations[OPTION_COMPONENTLEAKINGOPTIONS_RUBBER_STOPPER] = "Bouchon en caoutchouc ";
translations[OPTION_COMPONENTLEAKINGOPTIONS_SHRINKBAND] = "Film plastique";
translations[OPTION_COMPONENTLEAKINGOPTIONS_TIP_PROTECTOR] = "Capuchon/Protecteur d'embout";
translations[OPTION_COMPONENTLEAKINGOPTIONS_UNKNOWN] = "Inconnu";
translations[OPTION_COMPONENTLEAKINGOPTIONS_VIAL_ADAPTER] = "Adaptateur de connection flacon";
translations[OPTION_SCENARIOSLEAKOPTIONS_ADHERED_PORT] = "Port collapsé sur lui-même";
translations[OPTION_SCENARIOSLEAKOPTIONS_DAMAGE_HOLES] = "Degats (trous, déchirures) à l'emballage secondaire ou au carton intermédiaire";
translations[OPTION_SCENARIOSLEAKOPTIONS_EXPOSURE_TO_EXTREME] = "Exposition à une chaleur extrême ou au froid";
translations[OPTION_SCENARIOSLEAKOPTIONS_LEAK_AT_VAPORIZER] = "Fuite à l'interface du vaporisateur";
translations[OPTION_SCENARIOSLEAKOPTIONS_OPENING_SHIPPING] = "Ouverture du carton d'expédition avec un objet tranchant ";
translations[OPTION_SCENARIOSLEAKOPTIONS_PETS_CLAWED] = "Animaux de compagnie (produit griffé/mâché)";
translations[OPTION_SCENARIOSLEAKOPTIONS_SOLUTION_BAG_UNDER] = "Sac de solution sous pression avec un manchette de pression ou un autre dispositif";
translations[OPTION_SCENARIOSWITHLEAKOPTIONS_ADHERED_PORT] = "Port adhéré";
translations[OPTION_SCENARIOSWITHLEAKOPTIONS_DAMAGE_HOLES] = "Défaut (trous, déchirures, etc.) de l'emballage secondaire ou du carton intermédiaire ";
translations[OPTION_SCENARIOSWITHLEAKOPTIONS_DAMAGED_SHIPPING] = "Carton d'expédition endommagé pendant la livraison";
translations[OPTION_SCENARIOSWITHLEAKOPTIONS_EXPOSURE_TO_EXTREME] = "Exposition à la chaleur ou au froid";
translations[OPTION_SCENARIOSWITHLEAKOPTIONS_LEAK_AT_VAPORIZER] = "Fuite à l'interface du vaporisateur";
translations[OPTION_SCENARIOSWITHLEAKOPTIONS_OPENING_SHIPPING] = "Ouverture du carton d'expédition avec un coupe-boîte/objet tranchant ";
translations[OPTION_SCENARIOSWITHLEAKOPTIONS_PETS_CLAWED] = "Animaux de compagnie (produit griffé/mâché)";
translations[OPTION_SCENARIOSWITHLEAKOPTIONS_SOLUTION_BAG_UNDER] = "Sac de solution sous pression avec un manchette de pression ou un autre dispositif";
translations[OPTION_SCENARIOSWITHLEAKOPTIONS_UNKNOWN] = "Inconnu";
translations[OPTION_SCENARIOSWITHLEAKOPTIONS_NONE_OF_THE_ABOVE] = "Aucun des éléments ci-dessus.";
translations[NO_DESCRIBE_THE_COLOR] = "Non - décrire la couleur (à préciser)";
translations[OPTION_LIQUIDSPILLEDOPTIONS_ML] = " 1 à 10 ml";
translations[OPTION_LIQUIDSPILLEDOPTIONS_GREATER_THAN_ML] = " Plus de 10 mL";
translations[OPTION_LIQUIDSPILLEDOPTIONS_LESS_THAN_ML] = "Moins de 1 mL";
translations[OPTION_VISIBLEDEFECTSOPTIONS_BOTTLE] = "Bouteille/Flacon";
translations[OPTION_VISIBLEDEFECTSOPTIONS_CAP] = "Capûchon";
translations[OPTION_VISIBLEDEFECTSOPTIONS_VALVE_NECK] = "Valve";
translations[OPTION_VISIBLEDEFECTSOPTIONS_NONE] = "Aucun";
translations[OPTION_OPTIONCONNECTIONISSUEOPTIONS_CONNECTING] = "Difficultés de raccordement du produit à un autre produit";
translations[OPTION_OPTIONCONNECTIONISSUEOPTIONS_DISCONNECTING] = "Difficultés de déconnexion du produit d'un autre produit";
translations[OPTION_OPTIONCONNECTIONISSUEOPTIONS_SEPARATION_OF_COMPONENTS] = "Séparation des composants d'un seul produit";
translations[OPTION_OPTIONCONNECTIONISSUEOPTIONS_SEPARATION_DISCONNECTION] = "Séparation/déconnexion involontaire du produit d'un autre produit";
translations[OPTION_WHATCOMPONENTDISCOLOREDOPTIONS_DRIP_CHAMBER] = "Chambre d'égouttement";
translations[OPTION_WHATCOMPONENTDISCOLOREDOPTIONS_TUBING] = "Ligne";
translations[OPTION_WHATCOMPONENTDISCOLOREDOPTIONS_UNKNOWN] = "Inconnu";
translations[OPTION_WHATCOMPONENTDISCOLOREDOPTIONS_OTHER_PLEASE_SPECIFY] = "Autre - Veuillez préciser (texte libre)";
translations[OTHER_PLEASE_SPECIFY] = "Autre - Veuillez préciser (texte libre)";
translations[OPTION_DESCRIBESDISCOLORATIONOPTIONS_WHITE_CLOUDY] = "Blanc/Trouble/Nuageux";
translations[OPTION_DESCRIBESDISCOLORATIONOPTIONS_YELLOW_BROWNISH] = "Jaune/Brun";
translations[OPTION_DESCRIBESDISCOLORATIONOPTIONS_OTHER_PLEASE_SPECIFY] = "Autre - Veuillez préciser";
translations[OPTION_WHEREMATTERLOCATEDOPTIONS_IN_THE_PRIMARY_PACKAGING] = "Dans le sachet d'emballage principal/blister";
translations[OPTION_WHEREMATTERLOCATEDOPTIONS_INSIDE_THE_IV] = "Au niveau du passage du fluide (dans le tube)";
translations[OPTION_WHEREMATTERLOCATEDOPTIONS_INSIDE_THE_SHIPPING] = "À l'intérieur du carton d'expédition ";
translations[OPTION_WHEREMATTERLOCATEDOPTIONS_ON_THE_EXTERIOR] = "À l'extérieur du carton d'expédition";
translations[OPTION_WHEREMATTERLOCATEDOPTIONS_OUTSIDE_THE_IV] = "À l'extérieur de la trajectoire du fluide  (extérieur du tube)";
translations[OPTION_EMBEDDEDPLASTICOPTIONS_EMBEDDED] = "Incrusté";
translations[OPTION_EMBEDDEDPLASTICOPTIONS_LOOSE] = "Libre (= non attachée)";
translations[OPTION_EMBEDDEDPLASTICOPTIONS_NOT_APPLICABLE] = "Non applicable";
translations[OPTION_INFUSATESOLUTIONOPTIONS_DESCRIBE_COLOR] = "Décrire la couleur (texte libre)";
translations[OPTION_INFUSATESOLUTIONOPTIONS_YES_CHANGE_IN_COLOR] = "Oui - Changement de couleur";
translations[OPTION_INFUSATESOLUTIONOPTIONS_YES_PRECIPITATE] = "Oui - Précipitation";
translations[OPTION_DAMAGECOMPONENTAFFECTEDOPTIONS_ACCESS_SITE] = "Connecteur patient";
translations[OPTION_DAMAGECOMPONENTAFFECTEDOPTIONS_BURRETTES] = "Burrettes";
translations[OPTION_DAMAGECOMPONENTAFFECTEDOPTIONS_CLAMP] = "Clamp";
translations[OPTION_DAMAGECOMPONENTAFFECTEDOPTIONS_DRIP_CHAMBER] = "Chambre d'égouttage";
translations[OPTION_DAMAGECOMPONENTAFFECTEDOPTIONS_TUBING] = "Ligne";
translations[DAMAGECOMPONENTAFFECTEDOPTIONS_UNKNOWN] = "Inconnu";
translations[DAMAGECOMPONENTAFFECTEDOPTIONS_OTHER] = "Autre (à préciser)";
translations[OPTION_DAMAGECOMPONENTAFFECTEDOPTIONS_FILTERS] = "Filtres";
translations[OPTION_DAMAGECOMPONENTAFFECTEDOPTIONS_LUER_CONNECTOR] = "Connecteur Luer";
translations[OPTION_DAMAGECOMPONENTAFFECTEDOPTIONS_SPIKE] = "Spike";
translations[OPTION_WHATTYPEDAMAGEISSUEOPTIONS_CUT_CRACKED_BROKEN] = "Composant coupé/fissuré/cassé ";
translations[OPTION_WHATTYPEDAMAGEISSUEOPTIONS_INCORRECT_COMPONENT_ASSEMBLY] = "Composant mal assemblé  (à préciser)";
translations[OPTION_WHATTYPEDAMAGEISSUEOPTIONS_KINKED_COLLAPSED] = "Composant plié";
translations[OPTION_WHATTYPEDAMAGEISSUEOPTIONS_LOOSE_COMPONENT] = "Composant non attaché présent dans le packaging";
translations[OPTION_WHATTYPEDAMAGEISSUEOPTIONS_MALFORMED_MIS_SHAPED] = "Composant mal-formé";
translations[OPTION_WHATTYPEDAMAGEISSUEOPTIONS_MISSING_COMPONENT] = "Composant manquant";
translations[OPTION_SITUATIONDESCRIBESISSUEOPTIONS_DIFFICULTY_CONNECTING_THE] = " Difficulté de connecter le produit à un autre produit";
translations[OPTION_SITUATIONDESCRIBESISSUEOPTIONS_DIFFICULTY_DISCONNECTING_THE] = " Difficulté à déconnecter le produit d'un autre produit";
translations[OPTION_SITUATIONDESCRIBESISSUEOPTIONS_LOOSE_CONNECTION] = " Connection incomplète";
translations[OPTION_SITUATIONDESCRIBESISSUEOPTIONS_SEPARATION_DISCONNECTION] = "Séparation/déconnexion du produit d'un autre produit";
translations[OPTION_SITUATIONDESCRIBESISSUEOPTIONS_SEPARATION_BETWEEN_TWO] = " Séparation entre deux composants collés dans un même produit";
translations[OPTION_SITUATIONDESCRIBESISSUEOPTIONS_UNABLE_TO_CONNECT] = " Impossible de connecter deux produits ensemble";
translations[OPTION_SITUATIONDESCRIBESISSUEOPTIONS_UNABLE_TO_DISCONNECTT] = " Impossible de déconnecter le produit d'un autre produit Connexion";
translations[OPTION_DESCRIPTIONLABELINGISSUEOPTIONS_BARCODE_ISSUE] = "Problème de code-barres - Informations incorrectes affichées lors de la numérisation";
translations[OPTION_DESCRIPTIONLABELINGISSUEOPTIONS_CHANGE_IN_LABELING] = "Changement de l'étiquetage";
translations[OPTION_DESCRIPTIONLABELINGISSUEOPTIONS_DIFFICULTIES_SCANNING] = "Difficultés à scanner le code-barres";
translations[OPTION_DESCRIPTIONLABELINGISSUEOPTIONS_OTHER] = "Autre (à préciser)";
translations[OPTION_DESCRIPTIONLABELINGISSUEOPTIONS_EXPIRED_PRODUCT] = "Produit périmé/expiré";
translations[OPTION_DESCRIPTIONLABELINGISSUEOPTIONS_INCORRECT_INFORMATION_ON_LABEL] = "Informations incorrectes sur l'étiquette ";
translations[OPTION_DESCRIPTIONLABELINGISSUEOPTIONS_MISSING_BARCODE_UDI] = "Code-Barre manquant/Difficultés de numérisation UDI";
translations[OPTION_DESCRIPTIONLABELINGISSUEOPTIONS_MISSING_INFORMATION_ON_LABEL] = "Informations manquantes sur l'étiquette";
translations[OPTION_DESCRIPTIONLABELINGISSUEOPTIONS_PRODUCT_WITH_NO_EXPIRATION] = "Absence de date d'expiration";
translations[OPTION_DESCRIPTIONLABELINGISSUEOPTIONS_SMUDGES_ILLEGIBLE_LABELING] = "Tache(s) sur l'étiquettes/ Etiquette Illisible";
translations[OPTION_APPROPRIATEDESCISSUEOPTIONS_CARTON_BOX] = "La boîte contient un produit incorrect";
translations[OPTION_APPROPRIATEDESCISSUEOPTIONS_DAMAGED_SHIPPING] = "Carton d'expédition endommagé suite à la livraison";
translations[OPTION_APPROPRIATEDESCISSUEOPTIONS_EXPIRED_PRODUCT_DELIVERED] = "Un produit expiré a été livré";
translations[OPTION_APPROPRIATEDESCISSUEOPTIONS_EXPIRED_PRODUCT_FOUND] = "Un produit expiré a été identifié";
translations[OPTION_APPROPRIATEDESCISSUEOPTIONS_OTHER] = "Autre (à préciser)";
translations[OPTION_ORDEREDFROMVANTIVEOPTIONS_VANTIVE] = "Vantive";
translations[OPTION_ORDEREDFROMVANTIVEOPTIONS_DISTRIBUTOR] = "Distributeur";
translations[OPTION_APPROPRIATEDESCISSUEOPTIONS_EXTRA_UNITS_WERE_RECEIVED] = "Des unités additionelles se trouvent dans l'emballage";
translations[OPTION_APPROPRIATEDESCISSUEOPTIONS_PART_OF_THE_CARTON] = "Une partie du carton était ouverte ou non scellée";
translations[OPTION_APPROPRIATEDESCISSUEOPTIONS_PRODUCT_INFO_ON_THE_CARTON] = " Les informations concernant le produit sur le carton et l'étiquette de distribution ne correspondaient pas au produit à l'intérieur du carton ";
translations[OPTION_APPROPRIATEDESCISSUEOPTIONS_UNITS_WERE_MISSING] = "Des unités sont manquantes";
translations[OPTION_LEAKCOMINGFROMOPTIONS_ACCESS_SITE] = "Site d'accès";
translations[OPTION_LEAKCOMINGFROMOPTIONS_AIR_VENT] = "Accès à l'air";
translations[OPTION_LEAKCOMINGFROMOPTIONS_BURETTES] = "Burettes";
translations[OPTION_LEAKCOMINGFROMOPTIONS_CAP] = "Capûchon";
translations[OPTION_LEAKCOMINGFROMOPTIONS_CLEARLINK_INJECTION_SITES] = "Site d'injection Clearlink";
translations[OPTION_LEAKCOMINGFROMOPTIONS_CLAMP] = "Clamp";
translations[OPTION_LEAKCOMINGFROMOPTIONS_DRIP_CHAMBER] = "Chambre compte-gouttes";
translations[OPTION_LEAKCOMINGFROMOPTIONS_FILTERS] = "Filtre";
translations[OPTION_LEAKCOMINGFROMOPTIONS_INTERLINK_INJECTION_SITES] = "Site d'injection Interlink";
translations[OPTION_LEAKCOMINGFROMOPTIONS_LUER_CONNECTOR] = "Conncteur Luer";
translations[OPTION_LEAKCOMINGFROMOPTIONS_SPIKE] = "Percuteur de poche";
translations[OPTION_LEAKCOMINGFROMOPTIONS_TUBING] = "Tube";
translations[OPTION_LEAKCOMINGFROMOPTIONS_UNKNOWN] = "Inconnu";
translations[OPTION_LEAKCOMINGFROMOPTIONS_OTHER] = "Autre (à préciser)";
translations[OPTION_LEAKCOMINGFROMOPTIONS_LEAK_BETWEEN_THE] = "Fuite entre le site d'injection et le tube";
translations[OPTION_LEAKCOMINGFROMOPTIONS_NEEDLE_BASED] = "Site d'injection pour aiguille";
translations[OPTION_LEAKCOMINGFROMOPTIONS_ONE_LINK_INJECTION] = "Site d'injection One-Link";
translations[OPTION_LEAKCOMINGFROMOPTIONS_OTHER_INJECTION] = "Autre type de site d'injection (à préciser)";
translations[OPTION_FOLLOWINGSCENARIOSOPTIONS_CRACK_BREAK_IN] = "Fissure/rupture d'un composant rigide";
translations[OPTION_FOLLOWINGSCENARIOSOPTIONS_CUT_SLICE_IN] = "Fissure/rupture du tube souple";
translations[DISCONNECTION_OF_CONNECTABLE] = "Déconnexion des composants connectables/produits connectés";
translations[OPTION_FOLLOWINGSCENARIOSOPTIONS_DISCONNECTION_OF_CONNECTABLE] = "Déconnexion des composants connectables/produits connectés";
translations[OPTION_FOLLOWINGSCENARIOSOPTIONS_SEPARATION_OF_BONDED_COMPONENTS] = "Séparation de composants collés";
translations[OPTION_VISIBLEIRREGULARITIESOPTIONS_YES_DESCRIBE_IRREGULARITIES] = "Oui - Décrivez le défaut (à préciser)";
translations[YES_SPECIFY_THE_TOOL] = "Oui - Spécifiez l'outil utilisé (à préciser)";
translations[OPTION_SITUATIONFLOWISSUEOPTIONS_BACKFLOW] = "Remontée de l'écoulement (backflow)";
translations[OPTION_SITUATIONFLOWISSUEOPTIONS_CLAMP_FAILURE_DIFFICULT] = "Difficulté liée au clamp - Fermeture difficile";
translations[OPTION_SITUATIONFLOWISSUEOPTIONS_CLAMP_FAILURE_UNABLE] = "Difficulté liée au clamp - Fermeture impossible";
translations[OPTION_SITUATIONFLOWISSUEOPTIONS_CLAMP_FAILURE_DIFFICULT_UNABLE] = "Difficulté liée au clamp - Ouverture difficile/impossible";
translations[OPTION_SITUATIONFLOWISSUEOPTIONS_NO_FLOW] = "Pas d'écoulement";
translations[OPTION_SITUATIONFLOWISSUEOPTIONS_OVER_INFUSION] = "Perfusion excessive/trop rapide";
translations[OPTION_SITUATIONFLOWISSUEOPTIONS_RESTRICTED_SLOW] = "Ecoulement restreint ou lent";
translations[OPTION_SITUATIONFLOWISSUEOPTIONS_SIMULTANEOUS_FLOW] = "Ecoulements simultanés";
translations[OPTION_SITUATIONFLOWISSUEOPTIONS_UNABLE_TO_CLEAR] = "Incapacité d'obtenir un écoulement dans le composant";
translations[OPTION_SITUATIONFLOWISSUEOPTIONS_UNABLE_TO_PRIME] = "Incapacité d'amorcer le dispositif";
translations[OPTION_SITUATIONFLOWISSUEOPTIONS_UNDER_INFUSION] = "Perfusion insufisante/trop lente";
translations[OPTION_FLOWINGBACKWARDSOPTIONS_PATIENTS_BLOOD] = "Sang du patient";
translations[OPTION_FLOWINGBACKWARDSOPTIONS_SOLUTIONS_BLOOD] = "Solution/additif sanguin";
translations[OPTION_SITUATIONSAPPLYEVENTOPTIONS_DAMAGE_HOLE] = "Fuite avec un défaut/trou";
translations[OPTION_SITUATIONSAPPLYEVENTOPTIONS_DISCONNECTION] = "Déconnexion";
translations[OPTION_SITUATIONSAPPLYEVENTOPTIONS_LEAK] = "Fuite";
translations[OPTION_SITUATIONSAPPLYEVENTOPTIONS_MEDICATION_WAS_BEING] = "Les médicaments étaient administrés via une seringue sous pression ou une pompe";
translations[OPTION_SITUATIONSAPPLYEVENTOPTIONS_SECONDARY_BAG_WAS_LOWER] = "La poche secondaire était plus basse que la poche principale";
translations[OPTION_SITUATIONSAPPLYEVENTOPTIONS_SECONDARY_BAG_WAS_AT] = "La poche secondaire était à la même hauteur que la poche principale";
translations[OPTION_PREVIOUSLYFLOWOBSERVEDOPTIONS_BLOOD_CLOTTING] = "Coagulation sanguine";
translations[OPTION_PREVIOUSLYFLOWOBSERVEDOPTIONS_CATHETER_WAS] = "Le catheter n'a pas pû être amorcé avant sa connection au set";
translations[OPTION_PREVIOUSLYFLOWOBSERVEDOPTIONS_KINKED_TUBING] = "Tube plié";
translations[OPTION_PREVIOUSLYFLOWOBSERVEDOPTIONS_TUBING_INJECTION] = "Autre (à préciser) ";
translations[OPTION_SIMULTANEOUSFLOWOPTIONS_PRIMARY_AND_SECONDARY] = "Poche principale et secondaire";
translations[OPTION_SIMULTANEOUSFLOWOPTIONS_TWO_OR_MORE_LEADS] = "Deux lignes ou plus s'écoulant dans un seul set";
translations[OPTION_SIMULTANEOUSFLOWOPTIONS_TWO_ADMINISTRATION] = "Deux ensembles d'administration dotés chacun de sa propre pompe à perfusion";
translations[OPTION_HANGERUSEDOPTIONS_VANTIVE_HANGER] = "Crochet Vantive";
translations[OPTION_HANGERUSEDOPTIONS_NON_VANTIVE_HANGER] = "Crochet d'une autre marque/fabricant";
translations[OPTION_BAGLOWEROPTIONS_BAGS_WERE_AT] = "Les poches étaient à la même hauteur";
translations[OPTION_BAGLOWEROPTIONS_PRIMARY] = "Principal";
translations[OPTION_BAGLOWEROPTIONS_SECONDARY] = "Secondaire";
translations[OPTION_YSITECONNECTEDOPTIONS_MIDDLE] = "Mi-hauteur";
translations[OPTION_YSITECONNECTEDOPTIONS_LOWER] = "Bas";
translations[OPTION_YSITECONNECTEDOPTIONS_UPPER] = "Haut";
translations[OPTION_WITHPUMPOPTIONS_YES_PROVIDE_NAME] = "Oui - Indiquez le nom et le code produit de la pompe (à préciser)";
translations[OPTION_WHATCLAMPFAILEDOPTIONS_DARK_BLUE] = "Clamp à glisser bleue foncé";
translations[OPTION_WHATCLAMPFAILEDOPTIONS_LIGHT_BLUE] = "Clamp à glisser bleu clair";
translations[OPTION_WHATCLAMPFAILEDOPTIONS_NOTCH_CLAMP] = "Clamp à pincer";
translations[OPTION_WHATCLAMPFAILEDOPTIONS_ROLLER_CLAMP] = "Clamp à roulette/molette";
translations[OPTION_WHATCLAMPFAILEDOPTIONS_WHITE_SLIDE_CLAMP] = "Clamp à glisser blanc";
translations[OPTION_ISSUESOBSERVEDCLAMPOPTIONS_YES_THE_CLAMP] = "Oui - le clamp était cassé ou fissuré";
translations[OPTION_OTHERSITUATIONSPRODUCTOPTIONS_AIR_IN_LINE] = "Air dans la ligne";
translations[OPTION_OTHERSITUATIONSPRODUCTOPTIONS_CLAMP_ISSUE] = "Problème de clamp";
translations[OPTION_OTHERSITUATIONSPRODUCTOPTIONS_ODOR] = "Problème lié à l'odeur";
translations[OPTION_OTHERSITUATIONSPRODUCTOPTIONS_OTHER] = "Autre (à préciser)";
translations[OPTION_WHICHCLAMPISSUEOPTIONS_NOTCH_PINCH] = "Clamp à pincer";
translations[OPTION_WHICHCLAMPISSUEOPTIONS_ROLLER_CLAMP] = "Clamp à roulette";
translations[OPTION_WHICHCLAMPISSUEOPTIONS_SLIDE_CLAMP] = "Clamp à glisser";
translations[OPTION_WHICHCLAMPISSUEOPTIONS_UNKNOWN] = "Inconnu";
translations[OPTION_WHICHCLAMPISSUEOPTIONS_OTHER] = "Autre (à préciser)";
translations[OPTION_CLAMPISSUEEXPERIENCEDOPTIONS_CRACKED_BROKEN] = "Composant fissuré/cassé";
translations[OPTION_CLAMPISSUEEXPERIENCEDOPTIONS_DIFFICULT_TO_OPEN] = "Difficile à ouvrir";
translations[OPTION_CLAMPISSUEEXPERIENCEDOPTIONS_DIFFICULT_TO_CLOSE] = "Difficile à fermer";
translations[OPTION_CLAMPISSUEEXPERIENCEDOPTIONS_MISSING] = "Composant manquant";
translations[OPTION_CLAMPISSUEEXPERIENCEDOPTIONS_UNABLE_TO_OPEN] = "Impossible d'ouvrir";
translations[OPTION_CLAMPISSUEEXPERIENCEDOPTIONS_UNABLE_TO_CLOSE] = "Impossible de fermer";
translations[OPTION_CLAMPISSUEEXPERIENCEDOPTIONS_UNABLE_TO_CONTROL] = "Impossible de contrôler le flux/débit";
translations[OPTION_CLAMPDESCRIBESISSUEOPTIONS_DIFFICULT_TO_SQUEEZE] = "Difficile à exercer de la pression sur la chambre compte-gouttes";
translations[OPTION_CLAMPDESCRIBESISSUEOPTIONS_INSTRUCTIONS_WERE] = "Les instructions étaient difficiles à suivre/à comprendre";
translations[OPTION_CLAMPDESCRIBESISSUEOPTIONS_PRODUCT_WAS_DIFFICULT] = "Le produit était difficile à utiliser ";
translations[OPTION_LEAKOCCUROPTIONS_CRACK_BREAK] = "Cassé/Endommagé";
translations[OPTION_LEAKOCCUROPTIONS_CUT_SLICE] = "Coupure/Fissure";
translations[OPTION_LEAKOCCUROPTIONS_DISCONNECTION_OF_CONNECTABLE] = "Déconnexion des composants connectables/produits connectés";
translations[DISCONNECTION_OF_CONNECTABLE] = "Déconnexion des composants connectables/produits connectés";
translations[OPTION_LEAKOCCUROPTIONS_HOLE_TEA] = "Trou/Déchirure";
translations[OPTION_LEAKOCCUROPTIONS_SEPARATION_OF_BONDED] = "Séparation de composants collés";
translations[OPTION_LEAKOCCUROPTIONS_OTHER] = "Autre (à préciser)";
translations[OPTION_LEAKSCENARIOSOPTIONS_ADHERED_PORT] = "Port adhéré";
translations[OPTION_LEAKSCENARIOSOPTIONS_DAMAGE_HOLES] = "Défaut (trous, déchirures, etc.) de l'emballage secondaire ou du carton intermédiaire ";
translations[OPTION_LEAKSCENARIOSOPTIONS_DAMAGED_SHIPPING_CARTON] = "Carton d'expédition endommagé durant la livraison";
translations[OPTION_LEAKSCENARIOSOPTIONS_EXPOSURE_TO_EXTREME] = "Exposition à la chaleur ou au froid";
translations[OPTION_LEAKSCENARIOSOPTIONS_OPENING_SHIPPING] = "Ouverture du carton d'expédition avec un coupe-boîte/objet tranchant ";
translations[OPTION_LEAKSCENARIOSOPTIONS_UNKNOWN] = "Inconnu";
translations[OPTION_LEAKSCENARIOSOPTIONS_NONE_OF_THE_ABOVE] = "Aucun des éléments ci-dessus.";
translations[OPTION_LEAKSCENARIOSOPTIONS_PRESSURE_CUFF] = "Manchette de pression ou injecteur de pression utilisé ";
translations[OPTION_SCENARIOSLEAKOPTIONS_ADHERED_PORT] = "Port collapsé sur lui-même";
translations[OPTION_LEAKSCENARIOSOPTIONS_PETS_CLAWED_CHEWED] = "Animaux (griffés/mâchés)";
translations[OPTION_PRODUCTDAMAGEDOPTIONS_PRODUCT] = "Produit";
translations[OPTION_PRODUCTDAMAGEDOPTIONS_SHIPPING_CARTON_BOX] = "Carton d'expédition/ Boîte";
translations[OPTION_MATTERFOREIGNLOCATEDOPTIONS_INSIDE_THE_PRODUCT] = "À l'intérieur du produit";
translations[OPTION_MATTERFOREIGNLOCATEDOPTIONS_INSIDE_THE_SHIPPING] = "À l'intérieur du carton d'expédition";
translations[OPTION_MATTERFOREIGNLOCATEDOPTIONS_ON_THE_OUTSIDE_OF_PRODUCT] = "À l'extérieur du produit";
translations[OPTION_SELOPTIONCONNECTIONISSUEOPTIONS_DIFFICULTIES_CONNECTING] = "Difficultés de raccordement du produit à un autre produit";
translations[OPTION_SELOPTIONCONNECTIONISSUEOPTIONS_DIFFICULTIES_DISCONNECTING] = "Difficultés de déconnexion du produit d'un autre produit";
translations[OPTION_SELOPTIONCONNECTIONISSUEOPTIONS_LOOSE_CONNECTION] = "Connexion incomplète";
translations[OPTION_SELOPTIONCONNECTIONISSUEOPTIONS_SEPARATION_OF_COMPONENTS] = "Séparation de composants d'un produit unique";
translations[OPTION_SELOPTIONCONNECTIONISSUEOPTIONS_SEPARATION_DISCONNECTION] = "Séparation/déconnexion du produit d'un autre produit ";
translations[OPTION_MATTERFOREIGNLOCATEDOPTIONS_ON_THE_EXTERIOR] = "À l'extérieur du carton d'expédition";
translations[OPTION_MATTERFOREIGNLOCATEDOPTIONS_ON_THE_INSIDE_OF] = "À l'intérieur de l'emballage/pochette de protection";
translations[OPTION_MATTERFOREIGNLOCATEDOPTIONS_ON_THE_OUTSIDE_OF] = "À l'extérieur de l'emballage/pochette de protection";
translations[OPTION_OPTIONFLOWISSUEOPTIONS_NOT_FLOWING] = "Pas d'écoulement/de débit";
translations[OPTION_OPTIONFLOWISSUEOPTIONS_RESTRICTED_OR] = "Ecoulement/débit partiel ou restreint";
translations[OPTION_OPTIONFLOWISSUEOPTIONS_OTHER] = "Autre (à préciser)";
translations[OPTION_MOSTAPPROLABELINGISSUEOPTIONS_BARCODE_ISSUE] = "Problème de code-barres - Informations incorrectes affichées lors de la numérisation";
translations[OPTION_MOSTAPPROLABELINGISSUEOPTIONS_DIFFICULTIES_SCANNING] = "Difficultés à scanner le code-barres/code-barres non scannable";
translations[OPTION_MOSTAPPROLABELINGISSUEOPTIONS_ILLEGIBLE_LABEL] = "Étiquette illisible ";
translations[OPTION_MOSTAPPROLABELINGISSUEOPTIONS_INCORRECT_LABEL] = "Étiquette incorrecte ";
translations[OPTION_MOSTAPPROLABELINGISSUEOPTIONS_INCOMPLETE_LABEL] = "Étiquette incomplète ";
translations[OPTION_MOSTAPPROLABELINGISSUEOPTIONS_LABELS_PRODUCT] = "Les étiquettes (produit, boîte/carton, liste d'expédition) n'ont pas les mêmes informations";
translations[OPTION_MOSTAPPROLABELINGISSUEOPTIONS_LABEL_TOO_SIMILAR] = "Etiquette trop similaire à un autre produit ";
translations[OPTION_MOSTAPPROLABELINGISSUEOPTIONS_MISSING_LABEL] = "Étiquette manquante";
translations[OPTION_MOSTAPPROLABELINGISSUEOPTIONS_MISSING_BARCODE] = "Code-barres manquant";
translations[OPTION_MOSTAPPROLABELINGISSUEOPTIONS_OTHER] = "Autre (à préciser)";
translations[OPTION_DESCOFISSUEOPTIONS_FROZEN_PRODUCT] = "Le produit reçu était congelé";
translations[OPTION_DESCOFISSUEOPTIONS_THAWED_PRODUCT] = "Le produit a été reçu décongelé";
translations[OPTION_ALARMOPTIONS_YES_ALARM_NOT_KNOWN] = "Oui, Alarme inconnue";
translations[OPTION_ALARMOPTIONS_YES_SPECIFY] = "Oui, spécifiez";
translations[OPTION_DIFFICULTINTWISTCLAMPOPTIONS_YES_THE_TRANSFER_FULLY_OPEN] = "Oui, le transfert set n'a pas pu être complètement ouvert";
translations[OPTION_DIFFICULTINTWISTCLAMPOPTIONS_YES_THE_TRANSFER_FULLY_CLOSED] = "Oui, le transfert set n'a pas pu être complètement fermé";
translations[OPTION_DIFFICULTINTWISTCLAMPOPTIONS_YES_THE_TWIST_OPEN_AT_ALL] = "Oui, Le composant à tourner était si serrée que le transfert set ne pouvait pas s'ouvrir";
translations[OPTION_DIFFICULTINTWISTCLAMPOPTIONS_YES_THE_TWIST_CLOSE_AT_ALL] = "Oui, Le composant à tourner était si serrée que le transfert set ne pouvait pas se fermer";
translations[OPTION_COMPONENTHADISSUEOPTIONS_BOX_OR_OVERPOUCH] = "Boite ou pochette de protection";
translations[OPTION_COMPONENTHADISSUEOPTIONS_BLUE_CLAMP_ON] = "Clamp bleue sur la ligne du remplissage final";
translations[OPTION_COMPONENTHADISSUEOPTIONS_CASSETT] = "Cassette";
translations[OPTION_COMPONENTHADISSUEOPTIONS_DRAIN_LINE] = "Connecteur et capuchon sur la ligne vidange";
translations[OPTION_COMPONENTHADISSUEOPTIONS_EFFLUENT_SAMPLE] = "Site de prélèvement ligne effluent";
translations[OPTION_COMPONENTHADISSUEOPTIONS_LINES] = "Lignes";
translations[OPTION_COMPONENTHADISSUEOPTIONS_LUER_SPIKE] = "Connecteurs Luer/Spike";
translations[OPTION_COMPONENTHADISSUEOPTIONS_ORGANIZER] = "Organisateur de lignes";
translations[OPTION_COMPONENTHADISSUEOPTIONS_PULL_RING_PATIENT_LINE] = "Capuchons de protection sur la ligne patient";
translations[OPTION_COMPONENTHADISSUEOPTIONS_PULL_RING_PROTECTORS] = "Protecteur/Capuchon d'embout ";
translations[OPTION_COMPONENTHADISSUEOPTIONS_RED_CLAMP_ON] = "Clamp rouge sur la ligne chauffée";
translations[OPTION_COMPONENTHADISSUEOPTIONS_TACK_WELD] = "Point de soudure/collage";
translations[OPTION_COMPONENTHADISSUEOPTIONS_WHITE_CLAMP_ON_SUPPLY] = "Clamp blanc sur la ligne";
translations[OPTION_SELECTCOMPONENTHADISSUEOPTIONS_BEIGE_CATHETER] = "Connecteur/Adaptateur de cathéter beige ";
translations[OPTION_SELECTCOMPONENTHADISSUEOPTIONS_CHIP_INSERT] = "Chip Insert";
translations[OPTION_SELECTCOMPONENTHADISSUEOPTIONS_DARK_BLUE_CONNECTOR] = "Connecteur bleu foncé ";
translations[OPTION_SELECTCOMPONENTHADISSUEOPTIONS_LIGHT_BLUE_MAIN] = "Corps principal bleu clair ";
translations[OPTION_SELECTCOMPONENTHADISSUEOPTIONS_LIGHT_BLUE_PULL] = "Capuchon d'anneau bleu clair";
translations[OPTION_SELECTCOMPONENTHADISSUEOPTIONS_LIGHT_BLUE_OCCLUDER] = "Bras d'occlusion bleu clair";
translations[OPTION_SELECTCOMPONENTHADISSUEOPTIONS_SILICONE_TUBING] = "Tube en silicone ";
translations[OPTION_SELECTCOMPONENTHADISSUEOPTIONS_TITANIUM_SPIKE] = "Titanium Spike";
translations[OPTION_SELECTCOMPONENTHADISSUEOPTIONS_UV_FLASH_SPIKE] = "UV Flash Spike";
translations[OPTION_SELECTCOMPONENTHADISSUEOPTIONS_WHITE_TWIST_CLAMP] = "Manchon à tourner blanc";
translations[OPTION_ANYCOMPONENTDAMAGEDOPTIONS_YES_DESCRIBE_THE_DAMAGE] = "Oui : Décrivez les dégâts (à préciser)";
translations[OPTION_MONTHOPTIONS_JAN] = "Jan";
translations[OPTION_MONTHOPTIONS_FEB] = "Fév";
translations[OPTION_MONTHOPTIONS_MAR] = "Mar";
translations[OPTION_MONTHOPTIONS_APR] = "Avr";
translations[OPTION_MONTHOPTIONS_MAY] = "Mai";
translations[OPTION_MONTHOPTIONS_JUN] = "Juin";
translations[OPTION_MONTHOPTIONS_JUL] = "Juil";
translations[OPTION_MONTHOPTIONS_AUG] = "Aou";
translations[OPTION_MONTHOPTIONS_SEP] = "Sep";
translations[OPTION_MONTHOPTIONS_OCT] = "Oct";
translations[OPTION_MONTHOPTIONS_NOV] = "Nov";
translations[OPTION_MONTHOPTIONS_DEC] = "Déc";
translations[OPTION_PROBLEMOPTIONS_OTHER] = "Autre";
translations[OPTION_REPORTEDTOOPTIONS_OTHER] = "Autre";
translations[OPTION_DIFFICULTTOUSEOPTIONS_OTHER] = "Autre (à préciser)";
translations[OPTION_DIFFICULTIESMINICAPOPTIONS_OTHER] = "Autre (à préciser)";
translations[OPTION_BLOCKINGFLOWOPTIONS_OTHER] = "Autre (à préciser)";
translations[OPTION_DESCRIBEISSUEOPTIONS_OTHER] = "Autre (à préciser)";
translations[OPTION_MATERIALLOCATEDOPTIONS_OTHER] = "Autre (à préciser)";
translations[OPTION_OBSERVEDDAMAGEOPTIONS_OTHER] = "Autre (à préciser)";
translations[OPTION_TYPEOBSERVEDDAMAGEOPTIONS_OTHER] = "Autre (à préciser)";
translations[OPTION_PRODUCTDISCOLOREDOPTIONS_OTHER] = "Autre (à préciser)";
translations[OPTION_SPECIFICALLYDESCRIBESOPTIONS_OTHER] = "Autre (à préciser)";
translations[OPTION_MATTERFOREIGNMATERIALPIECESOPTIONS_OTHER] = "Autre (à préciser)";
translations[OPTION_PRODUCTTHAWEDOPTIONS_OTHER] = "Autre (à préciser)";
translations[OPTION_DAMAGEISSUEOBSERVEDOPTIONS_OTHER] = "Autre (à préciser)";
translations[OPTION_DAMAGESPECIFICINFOOPTIONS_OTHER] = "Autre (à préciser)";
translations[OPTION_APPROPRIATEDESCRIPTIONOPTIONS_OTHER] = "Autre (à préciser)";
translations[OPTION_LABELINGISSUEOPTIONS_OTHER] = "Autre (à préciser)";
translations[OPTION_WHATINCORRECTLYDISPLAYEDOPTIONS_OTHER] = "Autre (à préciser)";
translations[OPTION_MOISTUREOBSERVEDOPTIONS_OTHER] = "Autre (à préciser)";
translations[OPTION_COMPONENTLEAKINGOPTIONS_OTHER] = "Autre (à préciser)";
translations[OPTION_WHATTYPEDAMAGEISSUEOPTIONS_OTHER] = "Autre (à préciser)";
translations[OPTION_SITUATIONDESCRIBESISSUEOPTIONS_OTHER] = "Autre (à préciser)";
translations[OPTION_FOLLOWINGSCENARIOSOPTIONS_OTHER] = "Autre (à préciser)";
translations[OPTION_SITUATIONFLOWISSUEOPTIONS_OTHER] = "Autre (à préciser)";
translations[OPTION_SITUATIONSAPPLYEVENTOPTIONS_OTHER] = "Autre (à préciser)";
translations[OPTION_SIMULTANEOUSFLOWOPTIONS_OTHER] = "Autre (à préciser)";
translations[OPTION_WHATCLAMPFAILEDOPTIONS_OTHER] = "Autre (à préciser)";
translations[OPTION_CLAMPISSUEEXPERIENCEDOPTIONS_OTHER] = "Autre (à préciser)";
translations[OPTION_CLAMPDESCRIBESISSUEOPTIONS_DIFFICULT_OTHER] = "Autre (à préciser)";
translations[OPTION_PRODUCTDAMAGEDOPTIONS_OTHER] = "Autre (à préciser)";
translations[OPTION_COMPONENTHADISSUEOPTIONS_OTHER] = "Autre (à préciser)";
translations[OPTION_FOLLOWINGOCCUROPTIONS_NONE_OF_THE_ABOVE] = "Aucun des éléments ci-dessus.";
translations[OPTION_PREVIOUSLYREPORTEDOPTIONS_NO] = "Non";
translations[OPTION_PREVIOUSLYREPORTEDOPTIONS_UNKNOWN] = "Inconnu";
translations[OPTION_PREVIOUSLYREPORTEDOPTIONS_YES] = "Oui";
translations[OPTION_ADDANOTHERFACILITYOPTIONS_NO] = "Non";
translations[OPTION_ADDANOTHERFACILITYOPTIONS_YES] = "Oui";
translations[OPTION_PATIENINVOLVEMENTOPTIONS_NO] = "Non";
translations[OPTION_PATIENINVOLVEMENTOPTIONS_UNKNOWN] = "Inconnu";
translations[OPTION_PATIENINVOLVEMENTOPTIONS_YES] = "Oui";
translations[OPTION_OTHERFACILITYREPORTOPTIONS_NO] = "Non";
translations[OPTION_OTHERFACILITYREPORTOPTIONS_YES] = "Oui";
translations[OPTION_AVAILABILITYOPTIONSDISTRIBUTOR_ASKED_UNKNOWN] = "Demandé mais inconnu";
translations[OPTION_AVAILABILITYOPTIONSDISTRIBUTOR_NO] = "Non";
translations[OPTION_AVAILABILITYOPTIONSDISTRIBUTOR_UNKNOWN] = "Inconnu";
translations[OPTION_AVAILABILITYOPTIONSDISTRIBUTOR_YES] = "Oui";
translations[OPTION_AVAILABILITYOPTIONS_NO] = "Non";
translations[OPTION_AVAILABILITYOPTIONS_YES] = "Oui";
translations[OPTION_MEDIAAVAILABILITYOPTIONS_NO] = "Non";
translations[OPTION_MEDIAAVAILABILITYOPTIONS_YES] = "Oui";
translations[OPTION_MEDIAAVAILABILITYDISTRIBUTOROPTIONS_NO] = "Non";
translations[OPTION_MEDIAAVAILABILITYDISTRIBUTOROPTIONS_UNKNOWN] = "Inconnu";
translations[OPTION_MEDIAAVAILABILITYDISTRIBUTOROPTIONS_YES] = "Oui";
translations[OPTION_UNUSEDAVAILABILITYOPTIONS_NO] = "Non";
translations[OPTION_UNUSEDAVAILABILITYOPTIONS_YES] = "Oui";
translations[OPTION_SELFNEGATIVEIMPACTOPTIONS_NO] = "Non";
translations[OPTION_SELFNEGATIVEIMPACTOPTIONS_YES] = "Oui";
translations[OPTION_PATIENTNEGATIVEIMPACTOPTIONS_NO] = "Non";
translations[OPTION_PATIENTNEGATIVEIMPACTOPTIONS_YES] = "Oui";
translations[OPTION_COUNTERACTIONOPTIONS_NO] = "Non";
translations[OPTION_COUNTERACTIONOPTIONS_YES] = "Oui";
translations[OPTION_DRUGUSEDOPTIONS_NO] = "Non";
translations[OPTION_DRUGUSEDOPTIONS_YES] = "Oui";
translations[OPTION_SHARECONTACTOPTIONS_NO] = "Non";
translations[OPTION_SHARECONTACTOPTIONS_YES] = "Oui";
translations[OPTION_EXPLICITINVESTIGATIONREQUESTOPTIONS_NO] = "Non";
translations[OPTION_EXPLICITINVESTIGATIONREQUESTOPTIONS_YES] = "Oui";
translations[OPTION_DIRECTORDEROPTIONS_NO] = "Non";
translations[OPTION_DIRECTORDEROPTIONS_YES] = "Oui";
translations[OPTION_EXCESSIVEFORCEOPTIONS_NO] = "Non";
translations[OPTION_EXCESSIVEFORCEOPTIONS_UNKNOWN] = "Inconnu";
translations[OPTION_EXCESSIVEFORCEOPTIONS_YES] = "Oui";
translations[OPTION_TWISTCLAMPOPTIONS_NO] = "Non";
translations[OPTION_TWISTCLAMPOPTIONS_UNKNOWN] = "Inconnu";
translations[OPTION_TWISTCLAMPOPTIONS_YES] = "Oui";
translations[OPTION_DIFFICULTIESMINICAPOPTIONS_NO] = "Non";
translations[OPTION_DIFFICULTIESMINICAPOPTIONS_UNKNOWN] = "Inconnu";
translations[OPTION_ENVIRONMENTOPTIONS_NO] = "Non";
translations[OPTION_ENVIRONMENTOPTIONS_UNKNOWN] = "Inconnu";
translations[OPTION_ENVIRONMENTOPTIONS_YES] = "Oui";
translations[OPTION_SPONGEVISIBLEOPTIONS_NO] = "Non";
translations[OPTION_SPONGEVISIBLEOPTIONS_UNKNOWN] = "Inconnu";
translations[OPTION_SPONGEVISIBLEOPTIONS_YES] = "Oui";
translations[OPTION_MATERIALEMBEDDEDOPTIONS_NO] = "Non";
translations[OPTION_MATERIALEMBEDDEDOPTIONS_UNKNOWN] = "Inconnu";
translations[OPTION_MATERIALEMBEDDEDOPTIONS_YES] = "Oui";
translations[OPTION_PIECESMATERIALOPTIONS_NO] = "Non";
translations[OPTION_PIECESMATERIALOPTIONS_UNKNOWN] = "Inconnu";
translations[OPTION_PIECESMATERIALOPTIONS_YES] = "Oui";
translations[OPTION_DISPOSABLECONNECTIONOPTIONS_NO] = "Non";
translations[OPTION_DISPOSABLECONNECTIONOPTIONS_UNKNOWN] = "Inconnu";
translations[OPTION_DISPOSABLECONNECTIONOPTIONS_YES] = "Oui";
translations[OPTION_INITIALCONNECTIONOPTIONS_NO] = "Non";
translations[OPTION_INITIALCONNECTIONOPTIONS_UNKNOWN] = "Inconnu";
translations[OPTION_INITIALCONNECTIONOPTIONS_YES] = "Oui";
translations[OPTION_SPIKELUERCONNECTORSOPTIONS_NO] = "Non";
translations[OPTION_SPIKELUERCONNECTORSOPTIONS_UNKNOWN] = "Inconnu";
translations[OPTION_SPIKELUERCONNECTORSOPTIONS_YES] = "Oui";
translations[OPTION_PETSORANIMALSOPTIONS_NO] = "Non";
translations[OPTION_PETSORANIMALSOPTIONS_UNKNOWN] = "Inconnu";
translations[OPTION_PETSORANIMALSOPTIONS_YES] = "Oui";
translations[OPTION_MINICAPTWISTEDOPTIONS_NO] = "Non";
translations[OPTION_MINICAPTWISTEDOPTIONS_UNKNOWN] = "Inconnu";
translations[OPTION_MINICAPTWISTEDOPTIONS_YES] = "Oui";
translations[OPTION_TRANSFERSETOPTIONS_NO] = "Non";
translations[OPTION_TRANSFERSETOPTIONS_UNKNOWN] = "Inconnu";
translations[OPTION_TRANSFERSETOPTIONS_YES] = "Oui";
translations[OPTION_RESIDUETHREADSOPTIONS_NO] = "Non";
translations[OPTION_RESIDUETHREADSOPTIONS_UNKNOWN] = "Inconnu";
translations[OPTION_DAMAGECAUSELEAKOPTIONS_NO] = "Non";
translations[OPTION_DAMAGECAUSELEAKOPTIONS_UNKNOWN] = "Inconnu";
translations[OPTION_DAMAGECAUSELEAKOPTIONS_YES] = "Oui";
translations[OPTION_SHIPPINGCARTONOPENOPTIONS_NO] = "Non";
translations[OPTION_SHIPPINGCARTONOPENOPTIONS_UNKNOWN] = "Inconnu";
translations[OPTION_SHIPPINGCARTONOPENOPTIONS_YES] = "Oui";
translations[OPTION_ADAPTERDEVICEOPTIONS_NO] = "Non";
translations[OPTION_ADAPTERDEVICEOPTIONS_UNKNOWN] = "Inconnu";
translations[OPTION_ADAPTERDEVICEOPTIONS_YES] = "Oui";
translations[OPTION_SQUEEZINGSOLUTIONOPTIONSS_NO] = "Non";
translations[OPTION_SQUEEZINGSOLUTIONOPTIONSS_UNKNOWN] = "Inconnu";
translations[OPTION_SQUEEZINGSOLUTIONOPTIONSS_YES] = "Oui";
translations[OPTION_FORTHMOTIONOPTIONS_NO] = "Non";
translations[OPTION_FORTHMOTIONOPTIONS_UNKNOWN] = "Inconnu";
translations[OPTION_FORTHMOTIONOPTIONS_YES] = "Oui";
translations[OPTION_ALARMNOFLOWOPTIONS_NO] = "Non";
translations[OPTION_ALARMNOFLOWOPTIONS_UNKNOWN] = "Inconnu";
translations[OPTION_ALARMNOFLOWOPTIONS_YES] = "Oui";
translations[OPTION_DISCOLORATIONMARKINGSOPTIONS_NO] = "Non";
translations[OPTION_DISCOLORATIONMARKINGSOPTIONS_UNKNOWN] = "Inconnu";
translations[OPTION_DISCOLORATIONMARKINGSOPTIONS_YES] = "Oui";
translations[OPTION_BROKENACTIVATEDOPTIONS_NO] = "Non";
translations[OPTION_BROKENACTIVATEDOPTIONS_UNKNOWN] = "Inconnu";
translations[OPTION_BROKENACTIVATEDOPTIONS_YES] = "Oui";
translations[OPTION_vaporizerSightGlassOptions_NO] = "Non";
translations[OPTION_vaporizerSightGlassOptions_UNKNOWN] = "Inconnu";
translations[OPTION_vaporizerSightGlassOptions_YES] = "Oui";
translations[OPTION_PRODUCTHEATOPTIONS_NO] = "Non";
translations[OPTION_PRODUCTHEATOPTIONS_UNKNOWN] = "Inconnu";
translations[OPTION_PRODUCTHEATOPTIONS_YES] = "Oui";
translations[OPTION_DAMAGEPRIORACTIVATIONOPTIONS_NO] = "Non";
translations[OPTION_DAMAGEPRIORACTIVATIONOPTIONS_UNKNOWN] = "Inconnu";
translations[OPTION_DAMAGEPRIORACTIVATIONOPTIONS_YES] = "Oui";
translations[OPTION_LEAKOBSERVEDOPTIONS_NO] = "Non";
translations[OPTION_LEAKOBSERVEDOPTIONS_UNKNOWN] = "Inconnu";
translations[OPTION_LEAKOBSERVEDOPTIONS_YES] = "Oui";
translations[OPTION_EMBEDDEDINTHEPRODUCTOPTIONS_NO] = "Non";
translations[OPTION_EMBEDDEDINTHEPRODUCTOPTIONS_UNKNOWN] = "Inconnu";
translations[OPTION_EMBEDDEDINTHEPRODUCTOPTIONS_YES] = "Oui";
translations[OPTION_WASSOLUTIONADDEDPRODUCTOPTIONS_NO] = "Non";
translations[OPTION_WASSOLUTIONADDEDPRODUCTOPTIONS_UNKNOWN] = "Inconnu";
translations[OPTION_WASSOLUTIONADDEDPRODUCTOPTIONS_YES] = "Oui";
translations[OPTION_CLOUDINESSGOAWAYOPTIONS_NO] = "Non";
translations[OPTION_CLOUDINESSGOAWAYOPTIONS_UNKNOWN] = "Inconnu";
translations[OPTION_CLOUDINESSGOAWAYOPTIONS_YES] = "Oui";
translations[OPTION_AGITATEUNITOPTIONS_NO] = "Non";
translations[OPTION_AGITATEUNITOPTIONS_UNKNOWN] = "Inconnu";
translations[OPTION_AGITATEUNITOPTIONS_YES] = "Oui";
translations[OPTION_PRECIPITATEDISSOLVEOPTIONS_NO] = "Non";
translations[OPTION_PRECIPITATEDISSOLVEOPTIONS_UNKNOWN] = "Inconnu";
translations[OPTION_PRECIPITATEDISSOLVEOPTIONS_YES] = "Oui";
translations[OPTION_TEMPERATURELOGSFREEZEROPTIONS_NO] = "Non";
translations[OPTION_TEMPERATURELOGSFREEZEROPTIONS_UNKNOWN] = "Inconnu";
translations[OPTION_TEMPERATURELOGSFREEZEROPTIONS_YES] = "Oui";
translations[OPTION_STORAGEUNITCALIBRATEDOPTIONSS_NO] = "Non";
translations[OPTION_STORAGEUNITCALIBRATEDOPTIONSS_UNKNOWN] = "Inconnu";
translations[OPTION_STORAGEUNITCALIBRATEDOPTIONSS_YES] = "Oui";
translations[OPTION_RECENTPRESCRIPTIONOPTIONS_NO] = "Non";
translations[OPTION_RECENTPRESCRIPTIONOPTIONS_UNKNOWN] = "Inconnu";
translations[OPTION_RECENTPRESCRIPTIONOPTIONS_YES] = "Oui";
translations[OPTION_EXPIREDPRODUCTOPTIONS_NO] = "Non";
translations[OPTION_EXPIREDPRODUCTOPTIONS_UNKNOWN] = "Inconnu";
translations[OPTION_EXPIREDPRODUCTOPTIONS_YES] = "Oui";
translations[OPTION_ABNORMALITIESDAMAGEOPTIONS_NO] = "Non";
translations[OPTION_ABNORMALITIESDAMAGEOPTIONS_UNKNOWN] = "Inconnu";
translations[OPTION_ABNORMALITIESDAMAGEOPTIONS_YES] = "Oui";
translations[OPTION_OVERPOUCHPOUCHSCANNINGOPTIONS_NO] = "Non";
translations[OPTION_OVERPOUCHPOUCHSCANNINGOPTIONS_UNKNOWN] = "Inconnu";
translations[OPTION_OVERPOUCHPOUCHSCANNINGOPTIONS_YES] = "Oui";
translations[OPTION_LABELSSAMEINFORMATIONOPTIONS_NO] = "Non";
translations[OPTION_LABELSSAMEINFORMATIONOPTIONS_UNKNOWN] = "Inconnu";
translations[OPTION_LABELSSAMEINFORMATIONOPTIONS_YES] = "Oui";
translations[OPTION_BARCODESCANNEROPTIONS_NO] = "Non";
translations[OPTION_BARCODESCANNEROPTIONS_UNKNOWN] = "Inconnu";
translations[OPTION_BARCODESCANNEROPTIONS_YES] = "Oui";
translations[OPTION_FRANGIBLEOBSERVEDOPTIONS_NO] = "Non";
translations[OPTION_FRANGIBLEOBSERVEDOPTIONS_UNKNOWN] = "Inconnu";
translations[OPTION_FRANGIBLEOBSERVEDOPTIONS_YES] = "Oui";
translations[OPTION_FRANGIBLEDAMAGEDEFECTOPTIONS_NO] = "Non";
translations[OPTION_FRANGIBLEDAMAGEDEFECTOPTIONS_UNKNOWN] = "Inconnu";
translations[OPTION_FRANGIBLEDAMAGEDEFECTOPTIONS_YES] = "Oui";
translations[OPTION_FRANGIBLEBROKENOPTIONS_NO] = "Non";
translations[OPTION_FRANGIBLEBROKENOPTIONS_UNKNOWN] = "Inconnu";
translations[OPTION_FRANGIBLEBROKENOPTIONS_YES] = "Oui";
translations[OPTION_MOISTURECLEAROPTIONS_UNKNOWN] = "Inconnu";
translations[OPTION_MOISTURECLEAROPTIONS_YES] = "Oui";
translations[OPTION_DIFFICULTYSPIKINGOPTIONS_NO] = "Non";
translations[OPTION_DIFFICULTYSPIKINGOPTIONS_UNKNOWN] = "Inconnu";
translations[OPTION_DIFFICULTYSPIKINGOPTIONS_YES] = "Oui";
translations[OPTION_WASFRANGIBLEDAMAGEOPTIONS_NO] = "Non";
translations[OPTION_WASFRANGIBLEDAMAGEOPTIONS_UNKNOWN] = "Inconnu";
translations[OPTION_WASFRANGIBLEDAMAGEOPTIONS_YES] = "Oui";
translations[OPTION_PRESSURECUFFOPTIONS_NO] = "Non";
translations[OPTION_PRESSURECUFFOPTIONS_UNKNOWN] = "Inconnu";
translations[OPTION_PRESSURECUFFOPTIONS_YES] = "Oui";
translations[OPTION_LIQUIDSPILLEDOPTIONS_UNKNOWN] = "Inconnu";
translations[OPTION_BOTTLEINTOVAPORIZEROPTIONS_NO] = "Non";
translations[OPTION_BOTTLEINTOVAPORIZEROPTIONS_UNKNOWN] = "Inconnu";
translations[OPTION_BOTTLEINTOVAPORIZEROPTIONS_YES] = "Oui";
translations[OPTION_REMOVEDFROMPACKAGEOPTIONS_NO] = "Non";
translations[OPTION_REMOVEDFROMPACKAGEOPTIONS_UNKNOWN] = "Inconnu";
translations[OPTION_REMOVEDFROMPACKAGEOPTIONS_YES] = "Oui";
translations[OPTION_ADDINGMEDICATIONOPTIONS_NO] = "Non";
translations[OPTION_ADDINGMEDICATIONOPTIONS_UNKNOWN] = "Inconnu";
translations[OPTION_ADDINGMEDICATIONOPTIONS_YES] = "Oui";
translations[OPTION_PATIENTCONNECTEDPRODUCTOPTIONS_NO] = "Non";
translations[OPTION_PATIENTCONNECTEDPRODUCTOPTIONS_UNKNOWN] = "Inconnu";
translations[OPTION_PATIENTCONNECTEDPRODUCTOPTIONS_YES] = "Oui";
translations[OPTION_WASPRODUCTREPLACEDOPTIONS_NO] = "Non";
translations[OPTION_WASPRODUCTREPLACEDOPTIONS_UNKNOWN] = "Inconnu";
translations[OPTION_WASPRODUCTREPLACEDOPTIONS_YES] = "Oui";
translations[OPTION_WASPOWERINJECTOROPTIONS_NO] = "Non";
translations[OPTION_WASPOWERINJECTOROPTIONS_UNKNOWN] = "Inconnu";
translations[OPTION_WASPOWERINJECTOROPTIONS_YES] = "Oui";
translations[OPTION_INJECTIONSITEOPENINGOPTIONS_NO] = "Non";
translations[OPTION_INJECTIONSITEOPENINGOPTIONS_UNKNOWN] = "Inconnu";
translations[OPTION_INJECTIONSITEOPENINGOPTIONS_YES] = "Oui";
translations[OPTION_INJECTIONSITEOPENINGOPTIONS_OTHER] = "Autre (à préciser)";
translations[OPTION_VISIBLEIRREGULARITIESOPTIONS_NO] = "Non";
translations[OPTION_VISIBLEIRREGULARITIESOPTIONS_UNKNOWN] = "Inconnu";
translations[OPTION_EVENTUALLYESTABLISHEDOPTIONS_NO] = "Non";
translations[OPTION_EVENTUALLYESTABLISHEDOPTIONS_UNKNOWN] = "Inconnu";
translations[OPTION_EVENTUALLYESTABLISHEDOPTIONS_YES] = "Oui";
translations[OPTION_TOOLUSEDASSISTOPTIONS_NO] = "Non";
translations[OPTION_TOOLUSEDASSISTOPTIONS_UNKNOWN] = "Inconnu";
translations[OPTION_SECUREPRIORUSEOPTIONS_NO] = "Non";
translations[OPTION_SECUREPRIORUSEOPTIONS_UNKNOWN] = "Inconnu";
translations[OPTION_SECUREPRIORUSEOPTIONS_YES] = "Oui";
translations[OPTION_PRIORDISCONNECTINGOPTIONS_NO] = "Non";
translations[OPTION_PRIORDISCONNECTINGOPTIONS_UNKNOWN] = "Inconnu";
translations[OPTION_PRIORDISCONNECTINGOPTIONS_YES] = "Oui";
translations[OPTION_FLOWPREVIOUSLYSEENOPTIONS_NO] = "Non";
translations[OPTION_FLOWPREVIOUSLYSEENOPTIONS_UNKNOWN] = "Inconnu";
translations[OPTION_FLOWPREVIOUSLYSEENOPTIONS_YES] = "Oui";
translations[OPTION_YSITECONNECTEDOPTIONS_UNKNOWN] = "Inconnu";
translations[OPTION_COMPONENTSETREPLACEDOPTIONS_NO] = "Non";
translations[OPTION_COMPONENTSETREPLACEDOPTIONS_UNKNOWN] = "Inconnu";
translations[OPTION_COMPONENTSETREPLACEDOPTIONS_YES] = "Oui";
translations[OPTION_WITHPUMPOPTIONS_NO] = "Non";
translations[OPTION_WITHPUMPOPTIONS_UNKNOWN] = "Inconnu";
translations[OPTION_CLAMPFAILOPTIONS_NO] = "Non";
translations[OPTION_CLAMPFAILOPTIONS_UNKNOWN] = "Inconnu";
translations[OPTION_CLAMPFAILOPTIONS_YES] = "Oui";
translations[OPTION_ISSUESOBSERVEDCLAMPOPTIONS_NO] = "Non";
translations[OPTION_ISSUESOBSERVEDCLAMPOPTIONS_UNKNOWN] = "Inconnu";
translations[OPTION_WASMATERIALEMBEDDEDOPTIONS_NO] = "Non";
translations[OPTION_WASMATERIALEMBEDDEDOPTIONS_UNKNOWN] = "Inconnu";
translations[OPTION_WASMATERIALEMBEDDEDOPTIONS_YES] = "Oui";
translations[OPTION_APPEARPRODUCTMATERIALOPTIONS_NO] = "Non";
translations[OPTION_APPEARPRODUCTMATERIALOPTIONS_UNKNOWN] = "Inconnu";
translations[OPTION_APPEARPRODUCTMATERIALOPTIONS_YES] = "Oui";
translations[OPTION_SHIPPINGCARTONDAMAGEDOPTIONS_NO] = "Non";
translations[OPTION_SHIPPINGCARTONDAMAGEDOPTIONS_UNKNOWN] = "Inconnu";
translations[OPTION_SHIPPINGCARTONDAMAGEDOPTIONS_YES] = "Oui";
translations[OPTION_GELPACKSOPTIONS_NO] = "Non";
translations[OPTION_GELPACKSOPTIONS_YES] = "Oui";
translations[OPTION_EXPIREDPRODUCTUSEOPTIONS_NO] = "Non";
translations[OPTION_EXPIREDPRODUCTUSEOPTIONS_UNKNOWN] = "Inconnu";
translations[OPTION_EXPIREDPRODUCTUSEOPTIONS_YES] = "Oui";
translations[OPTION_ALARMOPTIONS_NO] = "Non";
translations[OPTION_ALARMOPTIONS_UNKNOWN] = "Inconnu";
translations[OPTION_CLEANINGSOLUTIONSOPTIONS_NO] = "Non";
translations[OPTION_CLEANINGSOLUTIONSOPTIONS_UNKNOWN] = "Inconnu";
translations[OPTION_CLEANINGSOLUTIONSOPTIONS_YES] = "Oui";
translations[OPTION_DIFFICULTINTWISTCLAMPOPTIONS_NO] = "Non";
translations[OPTION_DIFFICULTINTWISTCLAMPOPTIONS_UNKNOWN] = "Inconnu";
translations[OPTION_TRANSFERREPLACEDOPTIONS_NO] = "Non";
translations[OPTION_TRANSFERREPLACEDOPTIONS_UNKNOWN] = "Inconnu";
translations[OPTION_TRANSFERREPLACEDOPTIONS_YES] = "Oui";
translations[OPTION_FULLYTIGHTENEDOPTIONS_NO] = "Non";
translations[OPTION_FULLYTIGHTENEDOPTIONS_UNKNOWN] = "Inconnu";
translations[OPTION_FULLYTIGHTENEDOPTIONS_YES] = "Oui";
translations[OPTION_ANYCOMPONENTDAMAGEDOPTIONSS_NO] = "Non";
translations[OPTION_ANYCOMPONENTDAMAGEDOPTIONSS_UNKNOWN] = "Inconnu";
translations[OPTION_ISSUERESULTLEAKOPTIONS_NO] = "Non";
translations[OPTION_ISSUERESULTLEAKOPTIONS_UNKNOWN] = "Inconnu";
translations[OPTION_ISSUERESULTLEAKOPTIONS_YES] = "Oui";
translations[OPTION_ISSUERESULTLEAKOPTIONS_OTHER] = "Autre (à préciser)";
translations[OPTION_SAMPLESAVAILABLEFOREVALUATIONOPTIONS_NO] = "Non";
translations[OPTION_SAMPLESAVAILABLEFOREVALUATIONOPTIONS_YES] = "Oui";
translations[OPTION_EXPLICITLYREQUESTOPTIONS_NO] = "Non";
translations[OPTION_EXPLICITLYREQUESTOPTIONS_UNKNOWN] = "Inconnu";
translations[OPTION_EXPLICITLYREQUESTOPTIONS_YES] = "Oui";
translations[OPTION_WEREPATIENTUSINGPRODUCTOPTIONS_NO] = "Non";
translations[OPTION_WEREPATIENTUSINGPRODUCTOPTIONS_UNKNOWN] = "Inconnu";
translations[OPTION_WEREPATIENTUSINGPRODUCTOPTIONS_YES] = "Oui";
translations[OPTION_PATIENINVOLVEMENTOPTIONS_ASKED_UNKNOWN] = "Demandé mais inconnu";
translations[OPTION_MEDIAAVAILABILITYDISTRIBUTOROPTIONS_ASKED_UNKNOWN] = "Demandé mais inconnu";
translations[OPTION_CHAMBERDISCOLOREDOPTIONS_UNKNOWN] = "Inconnu";
translations[OPTION_MATTERFOREIGNMATERIALPIECESOPTIONS_UNKNOWN] = "Inconnu";
translations[OPTION_DAMAGEISSUEOBSERVEDOPTIONS_NO] = "Non";
translations[OPTION_DAMAGEISSUEOBSERVEDOPTIONS_UNKNOWN] = "Inconnu";
translations[OPTION_SCENARIOSLEAKOPTIONS_UNKNOWN] = "Inconnu";
translations[OPTION_SCENARIOSLEAKOPTIONS_NONE_OF_THE_ABOVE] = "Aucun des éléments ci-dessus.";
translations[OPTION_MOISTURECLEAROPTIONS_NO_DESCRIBE_THE_COLOR] = "Non - décrire la couleur (à préciser)";
translations[OPTION_EMBEDDEDPLASTICOPTIONS_UNKNOWN] = "Inconnu";
translations[OPTION_WHATTYPEDAMAGEISSUEOPTIONS_UNKNOWN] = "Inconnu";
translations[OPTION_TOOLUSEDASSISTOPTIONS_YES_SPECIFY_THE_TOOL] = "Oui - Spécifiez l'outil utilisé (à préciser)";
translations[OPTION_SITUATIONSAPPLYEVENTOPTIONS_SEPARATION] = "Séparation";
translations[OPTION_HANGERUSEDOPTIONS_UNKNOWN] = "Inconnu";
translations[OPTION_HANGERUSEDOPTIONS_NONE] = "Aucun";
translations[OPTION_BAGLOWEROPTIONS_UNKNOWN] = "Inconnu";
translations[OPTION_ISSUESOBSERVEDCLAMPOPTIONS_YES_OTHER] = "Oui - Autre (à préciser)";
translations[OPTION_CLAMPISSUEEXPERIENCEDOPTIONS_UNKNOWN] = "Inconnu";
translations[OPTION_MATTERFOREIGNMATERIALPIECESOPTIONS_NO] = "Aucune";
translations[OPTION_WEIGHTUNITOPTIONS_KILOGRAM] = "Kilogramme (s)";
translations[OPTION_WEIGHTUNITOPTIONS_POUND] = "Livre (s)";
translations[OPTION_INFUSATESOLUTIONOPTIONS_NO] = "Non";
translations[OPTION_INFUSATESOLUTIONOPTIONS_UNKNOWN] = "Inconnu";
translations[PLEASE_ENTER_THE_VALUE] = "Veuillez saisir la valeur";
translations[PLEASE_SELECT_THE_VALUE] = "Veuillez sélectionner la valeur";
translations[PLEASE_SELECT_THE_DATE] = "Sélectionner une date";
translations[PLEASE_CHOOSE_THE_VALUE] = "Veuillez choisir la valeur";
translations[OPTION_MEDIAAVAILABILITYOPTIONS_UNKNOWN] = "Inconnu";
translations[OPTION_COUNTRYOPTIONS_GREAT_BRITAIN] = "GREAT BRITAIN";
translations[OPTION_COUNTRYOPTIONS_KOSOVO] = "KOSOVO";
translations[OPTION_COUNTRYOPTIONS_NORTHERN_IRELAND] = "NORTHERN IRELAND";
translations[OPTION_COUNTRYOPTIONS_AFGHANISTAN] = "AFGHANISTAN";
translations[OPTION_COUNTRYOPTIONS_ÅLAND_ISLANDS] = "ÅLAND ISLANDS";
translations[OPTION_COUNTRYOPTIONS_ALBANIA] = "ALBANIA";
translations[OPTION_COUNTRYOPTIONS_ALGERIA] = "ALGERIA";
translations[OPTION_COUNTRYOPTIONS_AMERICAN_SAMOA] = "AMERICAN SAMOA";
translations[OPTION_COUNTRYOPTIONS_ANDORRA] = "ANDORRA";
translations[OPTION_COUNTRYOPTIONS_ANGOLA] = "ANGOLA";
translations[OPTION_COUNTRYOPTIONS_ANGUILLA] = "ANGUILLA";
translations[OPTION_COUNTRYOPTIONS_ANTARCTICA] = "ANTARCTICA";
translations[OPTION_COUNTRYOPTIONS_ANTIGUA_AND_BARBUDA] = "ANTIGUA AND BARBUDA";
translations[OPTION_COUNTRYOPTIONS_ARGENTINA] = "ARGENTINA";
translations[OPTION_COUNTRYOPTIONS_ARMENIA] = "ARMENIA";
translations[OPTION_COUNTRYOPTIONS_ARUBA] = "ARUBA";
translations[OPTION_COUNTRYOPTIONS_AUSTRALIA] = "AUSTRALIA";
translations[OPTION_COUNTRYOPTIONS_AUSTRIA] = "AUSTRIA";
translations[OPTION_COUNTRYOPTIONS_AZERBAIJAN] = "AZERBAIJAN";
translations[OPTION_COUNTRYOPTIONS_BAHAMAS] = "BAHAMAS";
translations[OPTION_COUNTRYOPTIONS_BAHRAIN] = "BAHRAIN";
translations[OPTION_COUNTRYOPTIONS_BANGLADESH] = "BANGLADESH";
translations[OPTION_COUNTRYOPTIONS_BARBADOS] = "BARBADOS";
translations[OPTION_COUNTRYOPTIONS_BELARUS] = "BELARUS";
translations[OPTION_COUNTRYOPTIONS_BELGIUM] = "BELGIUM";
translations[OPTION_COUNTRYOPTIONS_BELIZE] = "BELIZE";
translations[OPTION_COUNTRYOPTIONS_BENIN] = "BENIN";
translations[OPTION_COUNTRYOPTIONS_BERMUDA] = "BERMUDA";
translations[OPTION_COUNTRYOPTIONS_BHUTAN] = "BHUTAN";
translations[OPTION_COUNTRYOPTIONS_BOLIVIA] = "BOLIVIA";
translations[OPTION_COUNTRYOPTIONS_BOSNIA_AND_HERZEGOVINA] = "BOSNIA AND HERZEGOVINA";
translations[OPTION_COUNTRYOPTIONS_BOTSWANA] = "BOTSWANA";
translations[OPTION_COUNTRYOPTIONS_BOUVET_ISLAND] = "BOUVET ISLAND";
translations[OPTION_COUNTRYOPTIONS_BRAZIL] = "BRAZIL";
translations[OPTION_COUNTRYOPTIONS_BRITISH_INDIAN_OCEAN_TERRITORY] = "BRITISH INDIAN OCEAN TERRITORY";
translations[OPTION_COUNTRYOPTIONS_BRUNEI_DARUSSALAM] = "BRUNEI DARUSSALAM";
translations[OPTION_COUNTRYOPTIONS_BULGARIA] = "BULGARIA";
translations[OPTION_COUNTRYOPTIONS_BURKINA_FASO] = "BURKINA FASO";
translations[OPTION_COUNTRYOPTIONS_BURUNDI] = "BURUNDI";
translations[OPTION_COUNTRYOPTIONS_CAMBODIA] = "CAMBODIA";
translations[OPTION_COUNTRYOPTIONS_CAMEROON] = "CAMEROON";
translations[OPTION_COUNTRYOPTIONS_CANADA] = "CANADA";
translations[OPTION_COUNTRYOPTIONS_CAPE_VERDE] = "CAPE VERDE";
translations[OPTION_COUNTRYOPTIONS_CAYMAN_ISLANDS] = "CAYMAN ISLANDS";
translations[OPTION_COUNTRYOPTIONS_CENTRAL_AFRICAN_REPUBLIC] = "CENTRAL AFRICAN REPUBLIC";
translations[OPTION_COUNTRYOPTIONS_CHAD] = "CHAD";
translations[OPTION_COUNTRYOPTIONS_CHILE] = "CHILE";
translations[OPTION_COUNTRYOPTIONS_CHINA] = "CHINA";
translations[OPTION_COUNTRYOPTIONS_CHRISTMAS_ISLAND] = "CHRISTMAS ISLAND";
translations[OPTION_COUNTRYOPTIONS_COCOS_KEELING_ISLANDS] = "COCOS (KEELING) ISLANDS";
translations[OPTION_COUNTRYOPTIONS_COLOMBIA] = "COLOMBIA";
translations[OPTION_COUNTRYOPTIONS_COMOROS] = "COMOROS";
translations[OPTION_COUNTRYOPTIONS_CONGO] = "CONGO";
translations[OPTION_COUNTRYOPTIONS_CONGO_THE_DEMOCRATIC_REPUBLIC_OF_THE] = "CONGO, THE DEMOCRATIC REPUBLIC OF THE";
translations[OPTION_COUNTRYOPTIONS_COOK_ISLANDS] = "COOK ISLANDS";
translations[OPTION_COUNTRYOPTIONS_COSTA_RICA] = "COSTA RICA";
translations[OPTION_COUNTRYOPTIONS_CÔTE_DIVOIRE_IVORY_COAST] = "CÔTE D'IVOIRE (IVORY COAST)";
translations[OPTION_COUNTRYOPTIONS_CROATIA] = "CROATIA";
translations[OPTION_COUNTRYOPTIONS_CUBA] = "CUBA";
translations[OPTION_COUNTRYOPTIONS_CYPRUS] = "CYPRUS";
translations[OPTION_COUNTRYOPTIONS_CZECH_REPUBLIC] = "CZECH REPUBLIC";
translations[OPTION_COUNTRYOPTIONS_DENMARK] = "DENMARK";
translations[OPTION_COUNTRYOPTIONS_DJIBOUTI] = "DJIBOUTI";
translations[OPTION_COUNTRYOPTIONS_DOMINICA] = "DOMINICA";
translations[OPTION_COUNTRYOPTIONS_DOMINICAN_REPUBLIC] = "DOMINICAN REPUBLIC";
translations[OPTION_COUNTRYOPTIONS_ECUADOR] = "ECUADOR";
translations[OPTION_COUNTRYOPTIONS_EGYPT] = "EGYPT";
translations[OPTION_COUNTRYOPTIONS_EL_SALVADOR] = "EL SALVADOR";
translations[OPTION_COUNTRYOPTIONS_EQUATORIAL_GUINEA] = "EQUATORIAL GUINEA";
translations[OPTION_COUNTRYOPTIONS_ERITREA] = "ERITREA";
translations[OPTION_COUNTRYOPTIONS_ESTONIA] = "ESTONIA";
translations[OPTION_COUNTRYOPTIONS_ETHIOPIA] = "ETHIOPIA";
translations[OPTION_COUNTRYOPTIONS_FALKLAND_ISLANDS_MALVINAS] = "FALKLAND ISLANDS (MALVINAS)";
translations[OPTION_COUNTRYOPTIONS_FAROE_ISLANDS] = "FAROE ISLANDS";
translations[OPTION_COUNTRYOPTIONS_FIJI] = "FIJI";
translations[OPTION_COUNTRYOPTIONS_FINLAND] = "FINLAND";
translations[OPTION_COUNTRYOPTIONS_FRANCE] = "FRANCE";
translations[OPTION_COUNTRYOPTIONS_FRENCH_GUIANA] = "FRENCH GUIANA";
translations[OPTION_COUNTRYOPTIONS_FRENCH_POLYNESIA] = "FRENCH POLYNESIA";
translations[OPTION_COUNTRYOPTIONS_FRENCH_SOUTHERN_TERRITORIES] = "FRENCH SOUTHERN TERRITORIES";
translations[OPTION_COUNTRYOPTIONS_GABON] = "GABON";
translations[OPTION_COUNTRYOPTIONS_GAMBIA] = "GAMBIA";
translations[OPTION_COUNTRYOPTIONS_GEORGIA] = "GEORGIA";
translations[OPTION_COUNTRYOPTIONS_GERMANY] = "GERMANY";
translations[OPTION_COUNTRYOPTIONS_GHANA] = "GHANA";
translations[OPTION_COUNTRYOPTIONS_GIBRALTAR] = "GIBRALTAR";
translations[OPTION_COUNTRYOPTIONS_GREECE] = "GREECE";
translations[OPTION_COUNTRYOPTIONS_GREENLAND] = "GREENLAND";
translations[OPTION_COUNTRYOPTIONS_GRENADA] = "GRENADA";
translations[OPTION_COUNTRYOPTIONS_GUADELOUPE] = "GUADELOUPE";
translations[OPTION_COUNTRYOPTIONS_GUAM] = "GUAM";
translations[OPTION_COUNTRYOPTIONS_GUATEMALA] = "GUATEMALA";
translations[OPTION_COUNTRYOPTIONS_GUERNSEY] = "GUERNSEY";
translations[OPTION_COUNTRYOPTIONS_GUINEA] = "GUINEA";
translations[OPTION_COUNTRYOPTIONS_GUINEA_BISSAU] = "GUINEA-BISSAU";
translations[OPTION_COUNTRYOPTIONS_GUYANA] = "GUYANA";
translations[OPTION_COUNTRYOPTIONS_HAITI] = "HAITI";
translations[OPTION_COUNTRYOPTIONS_HEARD_ISLAND_AND_MCDONALD_ISLANDS] = "HEARD ISLAND AND MCDONALD ISLANDS";
translations[OPTION_COUNTRYOPTIONS_HOLY_SEE_VATICAN_CITY_STATE] = "HOLY SEE (VATICAN CITY STATE)";
translations[OPTION_COUNTRYOPTIONS_HONDURAS] = "HONDURAS";
translations[OPTION_COUNTRYOPTIONS_HONG_KONG] = "HONG KONG";
translations[OPTION_COUNTRYOPTIONS_HUNGARY] = "HUNGARY";
translations[OPTION_COUNTRYOPTIONS_ICELAND] = "ICELAND";
translations[OPTION_COUNTRYOPTIONS_INDIA] = "INDIA";
translations[OPTION_COUNTRYOPTIONS_INDONESIA] = "INDONESIA";
translations[OPTION_COUNTRYOPTIONS_IRAN_ISLAMIC_REPUBLIC_OF] = "IRAN, ISLAMIC REPUBLIC OF";
translations[OPTION_COUNTRYOPTIONS_IRAQ] = "IRAQ";
translations[OPTION_COUNTRYOPTIONS_IRELAND] = "IRELAND";
translations[OPTION_COUNTRYOPTIONS_ISLE_OF_MAN] = "ISLE OF MAN";
translations[OPTION_COUNTRYOPTIONS_ISRAEL] = "ISRAEL";
translations[OPTION_COUNTRYOPTIONS_ITALY] = "ITALY";
translations[OPTION_COUNTRYOPTIONS_JAMAICA] = "JAMAICA";
translations[OPTION_COUNTRYOPTIONS_JAPAN] = "JAPAN";
translations[OPTION_COUNTRYOPTIONS_JERSEY] = "JERSEY";
translations[OPTION_COUNTRYOPTIONS_JORDAN] = "JORDAN";
translations[OPTION_COUNTRYOPTIONS_KAZAKHSTAN] = "KAZAKHSTAN";
translations[OPTION_COUNTRYOPTIONS_KENYA] = "KENYA";
translations[OPTION_COUNTRYOPTIONS_KIRIBATI] = "KIRIBATI";
translations[OPTION_COUNTRYOPTIONS_KOREA_DEMOCRATIC_PEOPLES_REPUBLIC_OF] = "KOREA, DEMOCRATIC PEOPLE'S REPUBLIC OF";
translations[OPTION_COUNTRYOPTIONS_KOREA_REPUBLIC_OF] = "KOREA, REPUBLIC OF";
translations[OPTION_COUNTRYOPTIONS_KUWAIT] = "KUWAIT";
translations[OPTION_COUNTRYOPTIONS_KYRGYZSTAN] = "KYRGYZSTAN";
translations[OPTION_COUNTRYOPTIONS_LAO_PEOPLES_DEMOCRATIC_REPUBLIC] = "LAO PEOPLE'S DEMOCRATIC REPUBLIC";
translations[OPTION_COUNTRYOPTIONS_LATVIA] = "LATVIA";
translations[OPTION_COUNTRYOPTIONS_LEBANON] = "LEBANON";
translations[OPTION_COUNTRYOPTIONS_LESOTHO] = "LESOTHO";
translations[OPTION_COUNTRYOPTIONS_LIBERIA] = "LIBERIA";
translations[OPTION_COUNTRYOPTIONS_LIBYAN_ARAB_JAMAHIRIYA] = "LIBYAN ARAB JAMAHIRIYA";
translations[OPTION_COUNTRYOPTIONS_LIECHTENSTEIN] = "LIECHTENSTEIN";
translations[OPTION_COUNTRYOPTIONS_LITHUANIA] = "LITHUANIA";
translations[OPTION_COUNTRYOPTIONS_LUXEMBOURG] = "LUXEMBOURG";
translations[OPTION_COUNTRYOPTIONS_MACAO] = "MACAO";
translations[OPTION_COUNTRYOPTIONS_MACEDONIA_THE_FORMER_YUGOSLAV_REPUBLIC_OF] = "MACEDONIA, THE FORMER YUGOSLAV REPUBLIC OF";
translations[OPTION_COUNTRYOPTIONS_MADAGASCAR] = "MADAGASCAR";
translations[OPTION_COUNTRYOPTIONS_MALAWI] = "MALAWI";
translations[OPTION_COUNTRYOPTIONS_MALAYSIA] = "MALAYSIA";
translations[OPTION_COUNTRYOPTIONS_MALDIVES] = "MALDIVES";
translations[OPTION_COUNTRYOPTIONS_MALI] = "MALI";
translations[OPTION_COUNTRYOPTIONS_MALTA] = "MALTA";
translations[OPTION_COUNTRYOPTIONS_MARSHALL_ISLANDS] = "MARSHALL ISLANDS";
translations[OPTION_COUNTRYOPTIONS_MARTINIQUE] = "MARTINIQUE";
translations[OPTION_COUNTRYOPTIONS_MAURITANIA] = "MAURITANIA";
translations[OPTION_COUNTRYOPTIONS_MAURITIUS] = "MAURITIUS";
translations[OPTION_COUNTRYOPTIONS_MAYOTTE] = "MAYOTTE";
translations[OPTION_COUNTRYOPTIONS_MEXICO] = "MEXICO";
translations[OPTION_COUNTRYOPTIONS_MICRONESIA_FEDERATED_STATES_OF] = "MICRONESIA, FEDERATED STATES OF";
translations[OPTION_COUNTRYOPTIONS_MOLDOVA] = "MOLDOVA";
translations[OPTION_COUNTRYOPTIONS_MONACO] = "MONACO";
translations[OPTION_COUNTRYOPTIONS_MONGOLIA] = "MONGOLIA";
translations[OPTION_COUNTRYOPTIONS_MONTENEGRO] = "MONTENEGRO";
translations[OPTION_COUNTRYOPTIONS_MONTSERRAT] = "MONTSERRAT";
translations[OPTION_COUNTRYOPTIONS_MOROCCO] = "MOROCCO";
translations[OPTION_COUNTRYOPTIONS_MOZAMBIQUE] = "MOZAMBIQUE";
translations[OPTION_COUNTRYOPTIONS_MYANMAR] = "MYANMAR";
translations[OPTION_COUNTRYOPTIONS_NAMIBIA] = "NAMIBIA";
translations[OPTION_COUNTRYOPTIONS_NAURU] = "NAURU";
translations[OPTION_COUNTRYOPTIONS_NEPAL] = "NEPAL";
translations[OPTION_COUNTRYOPTIONS_NETHERLANDS] = "NETHERLANDS";
translations[OPTION_COUNTRYOPTIONS_NEW_CALEDONIA] = "NEW CALEDONIA";
translations[OPTION_COUNTRYOPTIONS_NEW_ZEALAND] = "NEW ZEALAND";
translations[OPTION_COUNTRYOPTIONS_NICARAGUA] = "NICARAGUA";
translations[OPTION_COUNTRYOPTIONS_NIGER] = "NIGER";
translations[OPTION_COUNTRYOPTIONS_NIGERIA] = "NIGERIA";
translations[OPTION_COUNTRYOPTIONS_NIUE] = "NIUE";
translations[OPTION_COUNTRYOPTIONS_NORFOLK_ISLAND] = "NORFOLK ISLAND";
translations[OPTION_COUNTRYOPTIONS_NORTHERN_MARIANA_ISLANDS] = "NORTHERN MARIANA ISLANDS";
translations[OPTION_COUNTRYOPTIONS_NORWAY] = "NORWAY";
translations[OPTION_COUNTRYOPTIONS_OMAN] = "OMAN";
translations[OPTION_COUNTRYOPTIONS_PAKISTAN] = "PAKISTAN";
translations[OPTION_COUNTRYOPTIONS_PALAU] = "PALAU";
translations[OPTION_COUNTRYOPTIONS_PALESTINIAN_TERRITORY_OCCUPIED] = "PALESTINIAN TERRITORY, OCCUPIED";
translations[OPTION_COUNTRYOPTIONS_PANAMA] = "PANAMA";
translations[OPTION_COUNTRYOPTIONS_PAPUA_NEW_GUINEA] = "PAPUA NEW GUINEA";
translations[OPTION_COUNTRYOPTIONS_PARAGUAY] = "PARAGUAY";
translations[OPTION_COUNTRYOPTIONS_PERU] = "PERU";
translations[OPTION_COUNTRYOPTIONS_PHILIPPINES] = "PHILIPPINES";
translations[OPTION_COUNTRYOPTIONS_PITCAIRN] = "PITCAIRN";
translations[OPTION_COUNTRYOPTIONS_POLAND] = "POLAND";
translations[OPTION_COUNTRYOPTIONS_PORTUGAL] = "PORTUGAL";
translations[OPTION_COUNTRYOPTIONS_PUERTO_RICO] = "PUERTO RICO";
translations[OPTION_COUNTRYOPTIONS_QATAR] = "QATAR";
translations[OPTION_COUNTRYOPTIONS_RÉUNION] = "RÉUNION";
translations[OPTION_COUNTRYOPTIONS_ROMANIA] = "ROMANIA";
translations[OPTION_COUNTRYOPTIONS_RUSSIAN_FEDERATION] = "RUSSIAN FEDERATION";
translations[OPTION_COUNTRYOPTIONS_RWANDA] = "RWANDA";
translations[OPTION_COUNTRYOPTIONS_SAINT_BARTHÉLEMY] = "SAINT BARTHÉLEMY";
translations[OPTION_COUNTRYOPTIONS_SAINT_HELENA] = "SAINT HELENA";
translations[OPTION_COUNTRYOPTIONS_SAINT_KITTS_AND_NEVIS] = "SAINT KITTS AND NEVIS";
translations[OPTION_COUNTRYOPTIONS_SAINT_LUCIA] = "SAINT LUCIA";
translations[OPTION_COUNTRYOPTIONS_SAINT_MARTIN] = "SAINT MARTIN";
translations[OPTION_COUNTRYOPTIONS_SAINT_PIERRE_AND_MIQUELON] = "SAINT PIERRE AND MIQUELON";
translations[OPTION_COUNTRYOPTIONS_SAINT_VINCENT_AND_THE_GRENADINES] = "SAINT VINCENT AND THE GRENADINES";
translations[OPTION_COUNTRYOPTIONS_SAMOA] = "SAMOA";
translations[OPTION_COUNTRYOPTIONS_SAN_MARINO] = "SAN MARINO";
translations[OPTION_COUNTRYOPTIONS_SAO_TOME_AND_PRINCIPE] = "SAO TOME AND PRINCIPE";
translations[OPTION_COUNTRYOPTIONS_SAUDI_ARABIA] = "SAUDI ARABIA";
translations[OPTION_COUNTRYOPTIONS_SENEGAL] = "SENEGAL";
translations[OPTION_COUNTRYOPTIONS_SERBIA] = "SERBIA";
translations[OPTION_COUNTRYOPTIONS_SEYCHELLES] = "SEYCHELLES";
translations[OPTION_COUNTRYOPTIONS_SIERRA_LEONE] = "SIERRA LEONE";
translations[OPTION_COUNTRYOPTIONS_SINGAPORE] = "SINGAPORE";
translations[OPTION_COUNTRYOPTIONS_SLOVAKIA] = "SLOVAKIA";
translations[OPTION_COUNTRYOPTIONS_SLOVENIA] = "SLOVENIA";
translations[OPTION_COUNTRYOPTIONS_SOLOMON_ISLANDS] = "SOLOMON ISLANDS";
translations[OPTION_COUNTRYOPTIONS_SOMALIA] = "SOMALIA";
translations[OPTION_COUNTRYOPTIONS_SOUTH_AFRICA] = "SOUTH AFRICA";
translations[OPTION_COUNTRYOPTIONS_SOUTH_GEORGIA_AND_THE_SOUTH_SANDWICH_ISLANDS] = "SOUTH GEORGIA AND THE SOUTH SANDWICH ISLANDS";
translations[OPTION_COUNTRYOPTIONS_SPAIN] = "SPAIN";
translations[OPTION_COUNTRYOPTIONS_SRI_LANKA] = "SRI LANKA";
translations[OPTION_COUNTRYOPTIONS_SUDAN] = "SUDAN";
translations[OPTION_COUNTRYOPTIONS_SURINAME] = "SURINAME";
translations[OPTION_COUNTRYOPTIONS_SVALBARD_AND_JAN_MAYEN] = "SVALBARD AND JAN MAYEN";
translations[OPTION_COUNTRYOPTIONS_SWAZILAND] = "SWAZILAND";
translations[OPTION_COUNTRYOPTIONS_SWEDEN] = "SWEDEN";
translations[OPTION_COUNTRYOPTIONS_SWITZERLAND] = "SWITZERLAND";
translations[OPTION_COUNTRYOPTIONS_SYRIAN_ARAB_REPUBLIC] = "SYRIAN ARAB REPUBLIC";
translations[OPTION_COUNTRYOPTIONS_TAIWAN_ROC] = "TAIWAN, R.O.C.";
translations[OPTION_COUNTRYOPTIONS_TAJIKISTAN] = "TAJIKISTAN";
translations[OPTION_COUNTRYOPTIONS_TANZANIA_UNITED_REPUBLIC_OF] = "TANZANIA, UNITED REPUBLIC OF";
translations[OPTION_COUNTRYOPTIONS_THAILAND] = "THAILAND";
translations[OPTION_COUNTRYOPTIONS_TIMOR_LESTE] = "TIMOR-LESTE";
translations[OPTION_COUNTRYOPTIONS_TOGO] = "TOGO";
translations[OPTION_COUNTRYOPTIONS_TOKELAU] = "TOKELAU";
translations[OPTION_COUNTRYOPTIONS_TONGA] = "TONGA";
translations[OPTION_COUNTRYOPTIONS_TRINIDAD_AND_TOBAGO] = "TRINIDAD AND TOBAGO";
translations[OPTION_COUNTRYOPTIONS_TUNISIA] = "TUNISIA";
translations[OPTION_COUNTRYOPTIONS_TURKEY] = "TURKEY";
translations[OPTION_COUNTRYOPTIONS_TURKMENISTAN] = "TURKMENISTAN";
translations[OPTION_COUNTRYOPTIONS_TURKS_AND_CAICOS_ISLANDS] = "TURKS AND CAICOS ISLANDS";
translations[OPTION_COUNTRYOPTIONS_TUVALU] = "TUVALU";
translations[OPTION_COUNTRYOPTIONS_UGANDA] = "UGANDA";
translations[OPTION_COUNTRYOPTIONS_UKRAINE] = "UKRAINE";
translations[OPTION_COUNTRYOPTIONS_UNITED_ARAB_EMIRATES] = "UNITED ARAB EMIRATES";
translations[OPTION_COUNTRYOPTIONS_UNITED_KINGDOM] = "UNITED KINGDOM";
translations[OPTION_COUNTRYOPTIONS_UNITED_STATES] = "UNITED STATES";
translations[OPTION_COUNTRYOPTIONS_UNITED_STATES_MINOR_OUTLYING_ISLANDS] = "UNITED STATES MINOR OUTLYING ISLANDS";
translations[OPTION_COUNTRYOPTIONS_URUGUAY] = "URUGUAY";
translations[OPTION_COUNTRYOPTIONS_UZBEKISTAN] = "UZBEKISTAN";
translations[OPTION_COUNTRYOPTIONS_VANUATU] = "VANUATU";
translations[OPTION_COUNTRYOPTIONS_VENEZUELA] = "VENEZUELA";
translations[OPTION_COUNTRYOPTIONS_VIET_NAM] = "VIET NAM";
translations[OPTION_COUNTRYOPTIONS_VIRGIN_ISLANDS_BRITISH] = "VIRGIN ISLANDS, BRITISH";
translations[OPTION_COUNTRYOPTIONS_VIRGIN_ISLANDS_US] = "VIRGIN ISLANDS, U.S.";
translations[OPTION_COUNTRYOPTIONS_WALLIS_AND_FUTUNA] = "WALLIS AND FUTUNA";
translations[OPTION_COUNTRYOPTIONS_WESTERN_SAHARA] = "WESTERN SAHARA";
translations[OPTION_COUNTRYOPTIONS_YEMEN] = "YEMEN";
translations[OPTION_COUNTRYOPTIONS_ZAMBIA] = "ZAMBIA";
translations[OPTION_COUNTRYOPTIONS_ZIMBABWE] = "ZIMBABWE";
translations[OPTION_DOESTHEPARTICULATEMATTER_NO] = "Non";
translations[OPTION_DOESTHEPARTICULATEMATTER_UNKNOWN] = "Inconnu";
translations[OPTION_DOESTHEPARTICULATEMATTER_YES] = "Oui";
translations[I_HAVE_READ_AND_UNDERSTAND_THE_LINKED_PRIVACY_NOTICE] = "J'ai lu et compris l'avis de confidentialité lié au portail de commentaires sur les produits de Vantive. ";
translations[PRODUCT_LOT] = "Numéro de lot";
translations[SHIPPING_DISTRIBUTION_LABEL] = "Étiquette d'expédition/de distribution";
translations[CARTON_LABEL] = "Étiquette en carton";
translations[INTERNAL_PRODUCT_LABEL] = "Étiquette interne du produit";
translations[TITLE_PD_RENAL] = "DP Rénal";
translations[TITLE_SOLUTIONS] = "Solutions";
translations[TITLE_ACCESS] = "Accéder";
translations[TITLE_ALL_OTHER_PRODUCT] = "Tous les autres produits";
translations[REPORTED_PROBLEM] = "Problème signalé";
translations[LOGIN] = "Connexion";
translations[SYSTEM_MENU] = "Menu Système";
translations[INITIATE_PRODUCT_FEEDBACK] = "Commencer la soumission du retour d'expérience";
translations[FEEDBACK_STATUS] = "Statut des commentaires";
translations[OKTACALLBACK] = "OktaCallback";
translations[VALID_EMAIL] = "Veuillez saisir une adresse e-mail valide";
translations[VALID_NUMERIC] = "Entrez une valeur numérique.";
translations[PLEASE_UPLOAD_IMAGE] = "Veuillez télécharger une (des) image (s)";
translations[VALID_DATE] = "S'il vous plaît sélectionnez une date valide";
translations[QUANTITY] = "Quantité";
translations[EDIT] = "Éditer";
translations[DELETE] = "Effacer";
translations[LOT_SERIAL_NO] = "Numéro de lot/série";
translations[LOT_NUMBER_NOT_FOUND] = "Numéro de lot non reconnu";
translations[SEARCHING_LOT_NUMBER] = "Chercher le numéro de lot";
translations[PRODUCT_CODE_NOT_FOUND] = "Code produit non reconnu";
translations[SEARCHING_PRODUCT_CODE] = "Chercher le code produit";
translations[FILE_OF_TYPES_ARE_NOT_ALLOWED] = "Ce type de fichier (.asa, .asax, .bat, .cer, .cmd, .docm, .exe, .img, .iso, .js, .php, .php5, .pht, .phtml, .ps1, .py, .rar,  .scr, .shtml, .swf, .vbs, .xap, .xml, .xps) n'est pas autorisé.";
translations[THE_FILE_YOU_ARE_ATTEMPTING] = "Le fichier que vous avez tenter de télécharger excède la taille autorisée. Veuillez compresser le fichier ou télécharger un fichier différent.";
translations[IMAGE_ICON] = "Cliquer sur l'icone de l'image pour sélectionner une option";
translations[LOGIN_TO_ACCOUNT] = "Connectez-vous au compte";
translations[SIGN_IN_TO_YOUR_ACCOUNT] = "Connectez-vous à votre compte";
translations[PASSWORD] = "Mot de passe";
translations[SIGN_IN] = "S'identifier";
translations[UNKNOWN] = "Inconnu";
translations[ASKED_UNKNOWN] = "Demandé mais inconnu";
translations[DD_MMM_YYYY] = "DD-MMM-YYYY";
translations[DD] = "DD";
translations[MMM] = "MMM";
translations[YYYY] = "YYYY";
translations[SELECT_COUNTRY] = "Sélectionner un pays";
translations[CHINESE_SIMPLIFIED_CHINESE] = "Chinois (Chinois simplifié)";
translations[DUTCH] = "Néerlandais";
translations[ENGLISH] = "Anglais";
translations[FRENCH] = "Français";
translations[GERMAN] = "Allemand";
translations[ITALIAN] = "Italien";
translations[JAPANESE] = "Japonais";
translations[KOREAN] = "Coréen";
translations[MANDARIN_TRADITIONAL_CHINESE] = "Mandarin (Chinois traditionnel)";
translations[POLISH] = "Polonais";
translations[PORTUGUESE] = "Portugais";
translations[SPANISH] = "Espagnol";
translations[THAI] = "Thaï";
translations[TURKISH] = "Turc";
translations[VIETNAMESE] = "Vietnamien";
translations[BROWSE] = "Parcourir";
translations[FEEDBACK_SUBMITTED] = "Commentaires soumis";
translations[YOUR_PRODUCT_EXPERIENCE_FEEDBACK] = "Les commentaires de votre expérience produit ont été envoyés avec succès. Merci pour votre rapport. Vous recevrez un e-mail contenant un numéro de référence. En tant que fournisseur de produits médicaux, la satisfaction des clients et le retour d'expérience concernant nos produits sont essentiels à notre objectif de fournir des produits de la plus haute qualité. S'il vous plaît contactez";
translations[IF_YOU_HAVE_QUESTIONS_OR_ADDITIONAL_INFORMATION] = "si vous avez des questions ou des informations supplémentaires.";
translations[CLOSE] = "Ferme";
translations[PATIENT_AGE] = "Âge du patient";
translations[ENTER_AGE] = "Entrez l'âge";
translations[PATIENT_DOB] = "Date de naissance patient";
translations[RELEVANT_ATTACHMENTS] = "Veuillez joindre les documents liés à ce rapport.";
translations[VANTIVE_ACCOUNT_CREDENTIALS] = "Entrer les informations d'identification de votre compte Vantive";
translations[GET_PRODUCT_DETAILS] = "Obtenir les détails du produit";
translations[USE_THE_DIAGRAM_ABOVE_FIGURE_2] = "Utilisez le diagramme ci-dessus (figure 2) pour déterminer l'emplacement du problème signalé";
translations[FACILITY_ADDRESS] = "Adresse de l'établissement";
translations[LABEL_ANOTHER_FACILITY_ADDRESS] = "Adresse de l'établissement additionnel ";
translations[CHOOSE_PRODUCT_CODE] = "Veuillez sélectionner le code produit associé au numéro de lot ou de série indiqué";
translations[DECLINE] = "Refuser";
translations[OPTION_COUNTRYOPTIONS_BONAIRE_SINT_EUSTATIUS_AND_SABA] = "BONAIRE, SINT EUSTATIUS AND SABA";
translations[OPTION_COUNTRYOPTIONS_CURAÇAO] = "CURAÇAO";
translations[OPTION_COUNTRYOPTIONS_SOUTH_SUDAN] = "SOUTH SUDAN";
translations[OPTION_COUNTRYOPTIONS_ESWATINI] = "ESWATINI";
translations[FORM_HELP_TEXT] = "indique qu'un texte d'aide est disponible pour ce champ";
translations[YOUR_FIRST_NAME] = "Votre prénom";
translations[YOUR_LAST_NAME] = "Votre nom de famille";
translations[MY_FIRST_NAME] = "Mon prénom";
translations[MY_LAST_NAME] = "Mon nom de famille";
translations[PATIENT_FIRST_NAME] = "Prénom du patient";
translations[PATIENT_LAST_NAME] = "Nom de famille du patient";
translations[REPORTER_FIRST_NAME] = "Prénom du déclarant";
translations[REPORTER_LAST_NAME] = "Nom de famille du déclarant";
translations[EMPLOYEE_FIRST_NAME] = "Prénom de l'employé";
translations[EMPLOYEE_LAST_NAME] = "Nom de famille de l'employé";
translations[END_USER_CUSTOMER_FIRST_NAME] = "Prénom de l'utilisateur final/du client";
translations[END_USER_CUSTOMER_LAST_NAME] = "Nom de famille de l'utilisateur final/du client";
translations[ADDITIONAL_CONTACT_FIRST_NAME] = "Prénom du contact supplémentaire";
translations[ADDITIONAL_CONTACT_LAST_NAME] = "Nom de famille du contact supplémentaire";
translations[COPYRIGHT] = "Copyright ©";
translations[COPYRIGHT_VANTIVE] = "Vantive";
translations[COPYRIGHT_VERSION] = "Tous droits réservés | Version";
translations[ADD_ADDITIONAL_CONTACT] = "Ajouter un contact supplémentaire";
translations[CONTACT_ME] = "Le client ne souhaite pas être contacté. Contactez-moi pour toute question supplémentaire.";
translations[DO_NOT_CONTACT] = "Ne pas contacter";
translations[END_USER_CUSTOMER_FACILITY_NAME] = "Nom de l'établissement de l'utilisateur final/client";
translations[END_USER_CUSTOMER_PHONE] = "Numéro de téléphone de l'utilisateur final/client";
translations[END_USER_CUSTOMER_EMAIL] = "Adresse e-mail de l'utilisateur final/client";
translations[END_USER_CUSTOMER_FACILITY_ADDRESS] = "Adresse de l’établissement de l'utilisateur final/client";
translations[SAME_AS_PATIENT_ADDRESS] = "Identique à Adresse du patient";
translations[SAME_AS_REPORTER_ADDRESS] = "Identique à adresse du  contact";
translations[SAME_AS_END_USER_CUSTOMER_ADDRESS] = "Identique à adresse de l’établissement de l'utilisateur final/client";
translations[USE_THE_DIAGRAM_ABOVE_FIGURE_3] = "Utilisez le diagramme ci-dessus (figure 3) pour déterminer l'emplacement du problème signalé";
translations[CONTACT_US] = "Contactez-nous";
translations[LANDING_BRIEF_FOR_DEVICE] = "Pour des demandes de réparation, d'intervention technique ou de commande de pièces détachées, veuillez s'il-vous-plaît contacter le Service Technique Local Vantive.";
translations[PATIENT_SEX] = "Sexe des patients";
translations[OPTION_PATIENTGENDEROPTIONS_CISGENDER_CISGENDER_MAN_BOY] = "Homme/garçon cisgenre";
translations[OPTION_PATIENTGENDEROPTIONS_CISGENDER_CISGENDER_WOMAN_GIRL] = "Femme/fille cisgenre";
translations[OPTION_PATIENTGENDEROPTIONS_CISGENDER_TRANSGENDER_MAN_TRANS_MAN_FEMALE_TO_MALE_FTM] = "Homme transgenre/homme trans/femme à homme";
translations[OPTION_PATIENTGENDEROPTIONS_CISGENDER_TRANSGENDER_WOMAN_TRANS_WOMAN_MALE_TO_FEMALE_MTF] = "Femme transgenre/femme trans/homme à femme";
translations[OPTION_PATIENTGENDEROPTIONS_CISGENDER_OTHER_GENDER_CATEGORY_PLEASE_SPECIFY] = "Autre catégorie de genre ; veuillez préciser";
translations[OPTION_PATIENTGENDEROPTIONS_CISGENDER_DECLINE_TO_ANSWER] = "Refuser de répondre à";
translations[ATTENTION_NEEDED] = "! ! ! ATTENTION URGENTE : votre soumission au portail de commentaires sur les produits a échoué !";
translations[SUBMIT_ERR_MSG] = "Pour soumettre à nouveau votre plainte, cliquez sur OK, puis sur Soumettre. Ou envoyez votre plainte par e-mail à (@@@).";
translations[SUBMIT_RETRY_MSG] = "Si vous avez soumis une nouvelle demande, vérifiez que vous avez reçu un e-mail de confirmation dans votre boîte e-mail depuis le portail de commentaires sur les produits. Si aucun e-mail de confirmation n'a été reçu, cela signifie que la soumission n'a pas été acceptée et vous DEVEZ envoyer votre réclamation par e-mail à (@@@).";
translations[OK] = "OK";

export default lang;